import * as OpenCC from 'opencc-js';

/**
 * 语言转换工具
 * - 简体 → 繁体字符映射（用于 zh-HK / zh-TW 输出）
 * - 英文文本表（用于 en 输出）
 * - 日文/韩文文本表（用于 ja/ko 输出）
 */
export {
  getWuxingFixedLocale,
  getWuxingAnalysisLocale,
  type WuxingFixedLocale,
  type WuxingAnalysisLocale,
} from './locale/wuxingLocale';

// ─── 简繁字符映射 ──────────────────────────────────────────────
const SIMP_TO_TRAD: Record<string, string> = {
  '这':'這',
  '优':'優','谨':'謹','预':'預','阵':'陣',
  '挑':'挑','励':'勵','辞':'辭','锁':'鎖','镜':'鏡','额':'額','账':'賬',
  '费':'費','检':'檢','险':'險','赢':'贏','虑':'慮','脑':'腦',
  '关':'關','问':'問','对':'對','业':'業',
  '无':'無','实':'實','为':'為',
  '带':'帶','现':'現','会':'會','导':'導',
  '积':'積','单':'單','应':'應',
  '传':'傳','选':'選','权':'權','损':'損','让':'讓',
  '总':'總','机':'機','战':'戰','头':'頭',
  '号':'號','词':'詞',
  '边':'邊','们':'們','双':'雙','级':'級','该':'該',
  '继':'繼','组':'組','万':'萬','补':'補','领':'領',
  '国':'國','间':'間','决':'決','择':'擇','线':'線',
  '阳':'陽','职':'職','员':'員',
  '鱼':'魚','厂':'廠','还':'還',
  '专':'專','则':'則','剧':'劇','获':'獲',
  '报':'報','签':'簽','约':'約','称':'稱','适':'適','举':'舉','讨':'討',
  '诉':'訴','购':'購','帮':'幫','码':'碼','础':'礎','记':'記','谋':'謀',
  '议':'議','纸':'紙','细':'細','纹':'紋',
  '题':'題','类':'類','满':'滿','乱':'亂',
  '态':'態','认':'認','区':'區','两':'兩','层':'層',
  '虽':'雖','拥':'擁','种':'種','产':'產','显':'顯','际':'際',
  '针':'針','织':'織','丝':'絲','红':'紅','黄':'黃',
  '黑':'黑','白':'白','铜':'銅','铁':'鐵',
  '珠':'珠','玉':'玉','宝':'寶','珍':'珍','钻':'鑽','晶':'晶','翡':'翡',
  '翠':'翠','琥':'琥','珀':'珀','圣':'聖',
  '仙':'仙','佛':'佛',
  '耻':'恥','勇':'勇',
  '爱':'愛','和':'和','平':'平','福':'福','寿':'壽',
  '财':'財','官':'官','印':'印','食':'食','伤':'傷','杀':'殺',
  '劫':'劫','梦':'夢','愿':'願','望':'望','希':'希','求':'求','得':'得',
  '失':'失','喜':'喜','忧':'憂','悲':'悲','苦':'苦','甜':'甜',
  '酸':'酸','辣':'辣','咸':'鹹','淡':'淡','热':'熱','冷':'冷','温':'溫',
  '暖':'暖','凉':'涼','燥':'燥','清':'清',
  '浊':'濁','亮':'亮','暗':'暗','光':'光','影':'影',
  
  '星':'星','天':'天',
  '水':'水','火':'火','木':'木','金':'金',
  '东':'東','西':'西','南':'南','北':'北','中':'中','上':'上','下':'下',
  '左':'左','右':'右','前':'前','后':'後','里':'裡','外':'外','内':'內',
  '高':'高','低':'低','大':'大','小':'小','多':'多','少':'少','好':'好',
  '坏':'壞','快':'快','慢':'慢','强':'強','弱':'弱','新':'新','旧':'舊',
  '远':'遠','近':'近','深':'深','浅':'淺','重':'重','轻':'輕','厚':'厚',
  '薄':'薄','宽':'寬','窄':'窄','短':'短','圆':'圓',
  '直':'直','曲':'曲','顺':'順','逆':'逆','正':'正','反':'反','吉':'吉',
  '凶':'凶','宜':'宜','忌':'忌','衰':'衰','克':'克',
  '泄':'洩','扶':'扶','冲':'沖','刑':'刑','害':'害','破':'破',
  '驿':'驛','桃':'桃','花':'花','贵':'貴','人':'人','禄':'祿',
  '岁':'歲','月':'月','日':'日','时':'時',
  '秒':'秒','年':'年','节':'節','候':'候','令':'令','旺':'旺',
  '相':'相','休':'休','囚':'囚','死':'死','绿':'綠','蓝':'藍','紫':'紫',
  '钱':'錢','银':'銀','宫':'宮','殿':'殿','庙':'廟','寺':'寺',
  '庵':'庵','塔':'塔','桥':'橋','门':'門','窗':'窗','房':'房','屋':'屋',
  '宅':'宅','园':'園','林':'林','山':'山','川':'川','海':'海','江':'江',
  '河':'河','湖':'湖','池':'池','井':'井','泉':'泉','溪':'溪','谷':'谷',
  '峰':'峰','岭':'嶺','坡':'坡','原':'原','田':'田',
  '石':'石','岩':'岩','矿':'礦','沙':'沙','土':'土','壤':'壤','尘':'塵',
  '灰':'灰','烟':'煙','雾':'霧','云':'雲','霞':'霞','虹':'虹','电':'電',
  '雷':'雷','风':'風','雨':'雨','雪':'雪','霜':'霜','露':'露','冰':'冰',
  '晴':'晴','阴':'陰','晕':'暈','干':'乾','湿':'濕','寒':'寒','暑':'暑',
  '秋':'秋','冬':'冬','春':'春','夏':'夏','昼':'晝','夜':'夜','晨':'晨',
  '暮':'暮','朝':'朝','夕':'夕','子':'子','丑':'丑','寅':'寅',
  '卯':'卯','辰':'辰','巳':'巳','午':'午','未':'未','申':'申','酉':'酉',
  '戌':'戌','亥':'亥','甲':'甲','乙':'乙','丙':'丙','丁':'丁','戊':'戊',
  '己':'己','庚':'庚','辛':'辛','壬':'壬','癸':'癸','鼠':'鼠','牛':'牛',
  '虎':'虎','兔':'兔','龙':'龍','蛇':'蛇','马':'馬','羊':'羊','猴':'猴',
  '鸡':'雞','狗':'狗','猪':'豬','轮':'輪','回':'回','转':'轉','动':'動',
  '静':'靜','起':'起','落':'落','开':'開',
  '盈':'盈','亏':'虧','增':'增','减':'減','加':'加',
  '乘':'乘','除':'除','比':'比','较':'較','超':'超',
  '到':'到','从':'從','至':'至','由':'由','往':'往','来':'來','去':'去',
  '行':'行','走':'走','跑':'跑','飞':'飛','游':'遊','涉':'涉','渡':'渡',
  '过':'過','越':'越','经':'經','历':'歷','阅':'閱','观':'觀','察':'察',
  '看':'看','视':'視','听':'聽','闻':'聞',
  '学':'學','习':'習','练':'練','修':'修','炼':'煉','养':'養',
  '育':'育','生':'生','长':'長','发':'發','展':'展','变':'變','化':'化',
  '进':'進','退':'退','升':'升','降':'降','沉':'沉','浮':'浮','散':'散',
  '聚':'聚','分':'分','合':'合','离':'離','隔':'隔','断':'斷','连':'連',
  '续':'續','延':'延','伸':'伸','扩':'擴','缩':'縮','收':'收','放':'放',
  '握':'握','持':'持','守':'守','护':'護','卫':'衛','保':'保',
  '稳':'穩','固':'固','定':'定','立':'立','建':'建','创':'創','设':'設',
  '置':'置','安':'安','装':'裝','配':'配','备':'備','用':'用','器':'器',
  '具':'具','材':'材','料':'料','资':'資','源':'源','力':'力',
  '场':'場','域':'域','界':'界','境':'境',
  '位':'位','方':'方','向':'向','处':'處','所':'所','地':'地','点':'點',
  '面':'面','体':'體','状':'狀','样':'樣','式':'式',
  '局':'局','势':'勢','形':'形','象':'象','图':'圖','像':'像','画':'畫',
  '文':'文','字':'字','书':'書','写':'寫','读':'讀','说':'說','话':'話',
  '语':'語','声':'聲','音':'音','乐':'樂','歌':'歌','舞':'舞','艺':'藝',
  '技':'技','能':'能','才':'才','华':'華','德':'德','品':'品',
  '质':'質','格':'格','情':'情','志':'志','意':'意','思':'思',
  '念':'念','想':'想','觉':'覺','感':'感','知':'知','识':'識','见':'見',
  '解':'解','悟':'悟','通':'通','达':'達','明':'明','智':'智','慧':'慧',
  '灵':'靈','性':'性','心':'心','身':'身','命':'命','运':'運','魂':'魂',
  '魄':'魄','精':'精','气':'氣','神':'神','道':'道','术':'術','法':'法',
  '礼':'禮','义':'義','仁':'仁','信':'信','忠':'忠','孝':'孝','廉':'廉',
};

/**
 * 简体中文 → 繁体中文转换
 */
const s2tConverter = OpenCC.Converter({ from: 'cn', to: 'tw' });

export function toTraditional(text: string): string {
  if (!text) return text;
  try {
    return s2tConverter(text);
  } catch {
    return text.split('').map(c => SIMP_TO_TRAD[c] ?? c).join('');
  }
}

/**
 * 繁体中文 → 简体中文转换
 * （用于 zh-CN 模式下展示以繁体为底稿的文案/服务端内容）
 */
const t2sConverter = OpenCC.Converter({ from: 'tw', to: 'cn' });

export function toSimplified(text: string): string {
  if (!text) return text;
  try {
    return t2sConverter(text);
  } catch {
    return text;
  }
}

/**
 * 根据语言决定是否转换文本
 * zh-HK/zh-TW → 转繁体；zh-CN → 转简体；其他 → 原样返回
 */
export function convertText(text: string, lang: string): string {
  if (lang === 'zh-HK' || lang === 'zh-TW') return toTraditional(text);
  if (lang === 'zh-CN') return toSimplified(text);
  return text;
}

// ─── 五行元素英文名 ────────────────────────────────────────────
export const ELEMENT_EN: Record<string, string> = {
  '木': 'Wood', '火': 'Fire', '土': 'Earth', '金': 'Metal', '水': 'Water',
};

// ─── 五行元素日文名 ────────────────────────────────────────────
export const ELEMENT_JA: Record<string, string> = {
  '木': '木', '火': '火', '土': '土', '金': '金', '水': '水',
};

// ─── 五行元素韩文名 ────────────────────────────────────────────
export const ELEMENT_KO: Record<string, string> = {
  '木': '목', '火': '화', '土': '토', '金': '금', '水': '수',
};

// ─── 五行元素标签（多语言，用于 UI 节点显示）─────────────────
// 英文：Metal / Wood / Water / Fire / Earth（标准五行直译）
export const ELEMENT_LABELS_I18N: Record<string, Record<string, string>> = {
  '木': { 'zh-CN': '木', 'zh-HK': '木', 'en': 'Wood',  'ja': '木', 'ko': '목' },
  '火': { 'zh-CN': '火', 'zh-HK': '火', 'en': 'Fire',  'ja': '火', 'ko': '화' },
  '土': { 'zh-CN': '土', 'zh-HK': '土', 'en': 'Earth', 'ja': '土', 'ko': '토' },
  '金': { 'zh-CN': '金', 'zh-HK': '金', 'en': 'Metal', 'ja': '金', 'ko': '금' },
  '水': { 'zh-CN': '水', 'zh-HK': '水', 'en': 'Water', 'ja': '水', 'ko': '수' },
};

// ─── 五行元素翻译辅助函数 ──────────────────────────────────────
/**
 * 返回五行元素的本地化名称
 * 英文标准：Metal / Wood / Water / Fire / Earth（金→Metal, 土→Earth）
 */
export function getElementLabel(element: string, lang: string): string {
  return ELEMENT_LABELS_I18N[element]?.[lang]
    ?? ELEMENT_LABELS_I18N[element]?.['zh-CN']
    ?? element;
}

/**
 * 返回带后缀的五行元素名称
 * 中文/日文：金行  英文：Metal  韩文：금행
 */
export function getElementWithSuffix(element: string, lang: string): string {
  const label = getElementLabel(element, lang);
  if (lang === 'en') return label;
  if (lang === 'ko') return `${label}행`;
  return `${label}行`;
}

// ─── 五行元素说明（多语言，用于灵摆等场景）──────────────────────
export const ELEMENT_DESC_I18N: Record<string, Record<string, string>> = {
  '木': {
    'zh-CN': '木行代表生发与成长之力，此时的能量场有利于新事物的开始和向上拓展。',
    'zh-HK': '木行代表生發與成長之力，此時的能量場有利於新事物的開始和向上拓展。',
    'en': 'Wood represents growth and upward vitality. The energy field is favorable for new beginnings and expanding horizons.',
    'ja': '木は発生と成長の力を象徴し、新しいことを始め、上向きに拡展するのに有利なエネルギー場です。',
    'ko': '목은 생발과 성장의 힘을 나타내며, 새로운 것을 시작하고 위로 확장하는 데 유리한 에너지 장입니다.',
  },
  '火': {
    'zh-CN': '火行代表热情与转化之力，此时的能量场活跃而充满动能，适合积极推进。',
    'zh-HK': '火行代表熱情與轉化之力，此時的能量場活躍而充滿動能，適合積極推進。',
    'en': 'Fire represents passion and transformation. The energy field is vibrant and dynamic—ideal for actively moving things forward.',
    'ja': '火は情熱と変化の力を象徴し、エネルギー場は活発で動的です。積極的に前進するのに適しています。',
    'ko': '화는 열정과 변화의 힘을 나타내며, 에너지 장이 활발하고 역동적이어서 적극적으로 추진하기에 적합합니다.',
  },
  '土': {
    'zh-CN': '土行代表稳固与承载之力，此时的能量场厚实而平稳，适合巩固根基。',
    'zh-HK': '土行代表穩固與承載之力，此時的能量場厚實而平穩，適合鞏固根基。',
    'en': 'Earth represents stability and grounding. The energy field is solid and steady—ideal for consolidating foundations.',
    'ja': '土は安定と支えの力を象徴し、エネルギー場は厚実で安定しています。基盤を固めるのに適しています。',
    'ko': '토는 안정과 지지의 힘을 나타내며, 에너지 장이 두텁고 안정적이어서 기반을 다지기에 적합합니다.',
  },
  '金': {
    'zh-CN': '金行代表收敛与精纯之力，此时的能量场清晰而锐利，适合做出决断。',
    'zh-HK': '金行代表收斂與精純之力，此時的能量場清晰而銳利，適合做出決斷。',
    'en': 'Metal represents clarity and precision. The energy field is clear and sharp—ideal for making decisive choices.',
    'ja': '金は収斂と精純の力を象徴し、エネルギー場は明晰で鋭利です。決断を下すのに適しています。',
    'ko': '금은 수렴과 정순의 힘을 나타내며, 에너지 장이 명확하고 날카로워서 결단을 내리기에 적합합니다.',
  },
  '水': {
    'zh-CN': '水行代表流动与智慧之力，此时的能量场灵活深沉，适合深度思考。',
    'zh-HK': '水行代表流動與智慧之力，此時的能量場靈活深沉，適合深度思考。',
    'en': 'Water represents flow and wisdom. The energy field is flexible and deep—ideal for profound thinking and insight.',
    'ja': '水は流動と知恵の力を象徴し、エネルギー場は柔軟で深く、深く考えるのに適しています。',
    'ko': '수는 흐름과 지혜의 힘을 나타내며, 에너지 장이 유연하고 깊어서 깊이 사고하기에 적합합니다.',
  },
};

// ─── 五行副标题（多语言）──────────────────────────────────────
export const ELEMENT_SUBS_I18N: Record<string, Record<string, string>> = {
  '木': {
    'zh-CN': '生机活力', 'zh-HK': '生機活力',
    'en': 'Growth & Vitality', 'ja': '成長・活力', 'ko': '성장 활력',
  },
  '火': {
    'zh-CN': '热情动力', 'zh-HK': '熱情動力',
    'en': 'Passion & Drive', 'ja': '情熱・行動力', 'ko': '열정 동력',
  },
  '土': {
    'zh-CN': '稳固根基', 'zh-HK': '穩固根基',
    'en': 'Stability & Foundation', 'ja': '安定・基盤', 'ko': '안정 기반',
  },
  '金': {
    'zh-CN': '决断清明', 'zh-HK': '決斷清明',
    'en': 'Clarity & Decision', 'ja': '明晰・決断', 'ko': '명확 결단',
  },
  '水': {
    'zh-CN': '智慧流动', 'zh-HK': '智慧流動',
    'en': 'Wisdom & Flow', 'ja': '知恵・流動', 'ko': '지혜 흐름',
  },
};

// ─── 十神名称多语言 ────────────────────────────────────────────
export const SHISHEN_NAMES_I18N: Record<string, Record<string, string>> = {
  '比肩': { 'zh-CN': '比肩', 'zh-HK': '比肩', 'en': 'Peer', 'ko': '비견', 'ja': '比肩（ひけん）' },
  '劫财': { 'zh-CN': '劫财', 'zh-HK': '劫財', 'en': 'Rob Wealth', 'ko': '겁재', 'ja': '劫財（ごうざい）' },
  '食神': { 'zh-CN': '食神', 'zh-HK': '食神', 'en': 'Output Star', 'ko': '식신', 'ja': '食神（しょくじん）' },
  '伤官': { 'zh-CN': '伤官', 'zh-HK': '傷官', 'en': 'Hurt Officer', 'ko': '상관', 'ja': '傷官（しょうかん）' },
  '偏财': { 'zh-CN': '偏财', 'zh-HK': '偏財', 'en': 'Side Wealth', 'ko': '편재', 'ja': '偏財（へんざい）' },
  '正财': { 'zh-CN': '正财', 'zh-HK': '正財', 'en': 'Direct Wealth', 'ko': '정재', 'ja': '正財（せいざい）' },
  '七杀': { 'zh-CN': '七杀', 'zh-HK': '七殺', 'en': 'Seven Killings', 'ko': '칠살', 'ja': '七殺（しちさつ）' },
  '正官': { 'zh-CN': '正官', 'zh-HK': '正官', 'en': 'Direct Officer', 'ko': '정관', 'ja': '正官（せいかん）' },
  '偏印': { 'zh-CN': '偏印', 'zh-HK': '偏印', 'en': 'Side Seal', 'ko': '편인', 'ja': '偏印（へんいん）' },
  '正印': { 'zh-CN': '正印', 'zh-HK': '正印', 'en': 'Direct Seal', 'ko': '정인', 'ja': '正印（せいいん）' },
  '日主': { 'zh-CN': '日主', 'zh-HK': '日主', 'en': 'Day Master', 'ko': '일주', 'ja': '日主（にっしゅ）' },
};

export function getShishenLabel(shishen: string, lang: string): string {
  if (lang === 'zh-CN' || lang === 'zh-HK' || lang === 'zh-TW') return toTraditional(shishen);
  return SHISHEN_NAMES_I18N[shishen]?.[lang] ?? SHISHEN_NAMES_I18N[shishen]?.['zh-CN'] ?? shishen;
}

// ─── 流年/大运等级多语言 ───────────────────────────────────────
export const LIUNIAN_LEVEL_I18N: Record<string, Record<string, string>> = {
  '大吉': { 'zh-CN': '大吉', 'zh-HK': '大吉', 'en': 'Very Auspicious', 'ko': '대길', 'ja': '大吉' },
  '吉': { 'zh-CN': '吉', 'zh-HK': '吉', 'en': 'Auspicious', 'ko': '길', 'ja': '吉' },
  '平顺': { 'zh-CN': '平顺', 'zh-HK': '平順', 'en': 'Smooth', 'ko': '평순', 'ja': '平順' },
  '需注意': { 'zh-CN': '需注意', 'zh-HK': '需注意', 'en': 'Caution', 'ko': '주의', 'ja': '注意' },
  '挑战': { 'zh-CN': '挑战', 'zh-HK': '挑戰', 'en': 'Challenging', 'ko': '도전', 'ja': '挑戦' },
};

export function getLiunianLevelLabel(level: string, lang: string): string {
  if (lang === 'zh-CN' || lang === 'zh-HK' || lang === 'zh-TW') return convertText(level, lang);
  return LIUNIAN_LEVEL_I18N[level]?.[lang] ?? level;
}

// ─── 流年领域等级多语言 ────────────────────────────────────────
export const DOMAIN_LEVEL_I18N: Record<string, Record<string, string>> = {
  '优秀': { 'zh-CN': '优秀', 'zh-HK': '優秀', 'en': 'Excellent', 'ko': '우수', 'ja': '優秀' },
  '良好': { 'zh-CN': '良好', 'zh-HK': '良好', 'en': 'Good', 'ko': '양호', 'ja': '良好' },
  '平稳': { 'zh-CN': '平稳', 'zh-HK': '平穩', 'en': 'Steady', 'ko': '평안', 'ja': '平穏' },
  '注意': { 'zh-CN': '注意', 'zh-HK': '注意', 'en': 'Watch', 'ko': '주의', 'ja': '注意' },
  '谨慎': { 'zh-CN': '谨慎', 'zh-HK': '謹慎', 'en': 'Caution', 'ko': '신중', 'ja': '慎重' },
};

export function getDomainLevelLabel(level: string, lang: string): string {
  if (lang === 'zh-CN' || lang === 'zh-HK' || lang === 'zh-TW') return convertText(level, lang);
  return DOMAIN_LEVEL_I18N[level]?.[lang] ?? level;
}

// ─── 格局名称多语言 ────────────────────────────────────────────
export const GEJU_NAMES_I18N: Record<string, Record<string, string>> = {
  '正官格': { 'zh-CN': '正官格', 'zh-HK': '正官格', 'en': 'Direct Officer Pattern', 'ko': '정관격', 'ja': '正官格（せいかんかく）' },
  '七杀格': { 'zh-CN': '七杀格', 'zh-HK': '七殺格', 'en': 'Seven Killings Pattern', 'ko': '칠살격', 'ja': '七殺格（しちさつかく）' },
  '正印格': { 'zh-CN': '正印格', 'zh-HK': '正印格', 'en': 'Direct Seal Pattern', 'ko': '정인격', 'ja': '正印格（せいいんかく）' },
  '偏印格': { 'zh-CN': '偏印格', 'zh-HK': '偏印格', 'en': 'Side Seal Pattern', 'ko': '편인격', 'ja': '偏印格（へんいんかく）' },
  '食神格': { 'zh-CN': '食神格', 'zh-HK': '食神格', 'en': 'Output Star Pattern', 'ko': '식신격', 'ja': '食神格（しょくじんかく）' },
  '伤官格': { 'zh-CN': '伤官格', 'zh-HK': '傷官格', 'en': 'Hurt Officer Pattern', 'ko': '상관격', 'ja': '傷官格（しょうかんかく）' },
  '正财格': { 'zh-CN': '正财格', 'zh-HK': '正財格', 'en': 'Direct Wealth Pattern', 'ko': '정재격', 'ja': '正財格（せいざいかく）' },
  '偏财格': { 'zh-CN': '偏财格', 'zh-HK': '偏財格', 'en': 'Side Wealth Pattern', 'ko': '편재격', 'ja': '偏財格（へんざいかく）' },
  '比劫格': { 'zh-CN': '比劫格', 'zh-HK': '比劫格', 'en': 'Peer-Rob Pattern', 'ko': '비겁격', 'ja': '比劫格（ひごうかく）' },
  '从强格': { 'zh-CN': '从强格', 'zh-HK': '從強格', 'en': 'Follow Strength Pattern', 'ko': '종강격', 'ja': '従強格（じゅうきょうかく）' },
  '从弱格': { 'zh-CN': '从弱格', 'zh-HK': '從弱格', 'en': 'Follow Weakness Pattern', 'ko': '종약격', 'ja': '従弱格（じゅうじゃくかく）' },
  '从财格': { 'zh-CN': '从财格', 'zh-HK': '從財格', 'en': 'Follow Wealth Pattern', 'ko': '종재격', 'ja': '従財格（じゅうざいかく）' },
  '从杀格': { 'zh-CN': '从杀格', 'zh-HK': '從殺格', 'en': 'Follow Killings Pattern', 'ko': '종살격', 'ja': '従殺格（じゅうさつかく）' },
  '从儿格': { 'zh-CN': '从儿格', 'zh-HK': '從兒格', 'en': 'Follow Output Pattern', 'ko': '종아격', 'ja': '従児格（じゅうじかく）' },
  '化气格': { 'zh-CN': '化气格', 'zh-HK': '化氣格', 'en': 'Transform Qi Pattern', 'ko': '화기격', 'ja': '化気格（かきかく）' },
};

export function getGejuLabel(name: string, lang: string): string {
  if (lang === 'zh-CN' || lang === 'zh-HK' || lang === 'zh-TW') return convertText(name, lang);
  return GEJU_NAMES_I18N[name]?.[lang] ?? GEJU_NAMES_I18N[name]?.['zh-CN'] ?? name;
}

// ─── 神煞名称多语言 ────────────────────────────────────────────
export const SHENSHA_NAMES_I18N: Record<string, Record<string, string>> = {
  '天乙贵人': { 'zh-CN': '天乙贵人', 'zh-HK': '天乙貴人', 'en': 'Heavenly Yi Noble', 'ko': '천을귀인', 'ja': '天乙貴人（てんいきじん）' },
  '文昌贵人': { 'zh-CN': '文昌贵人', 'zh-HK': '文昌貴人', 'en': 'Literary Star Noble', 'ko': '문창귀인', 'ja': '文昌貴人（ぶんしょうきじん）' },
  '驿马': { 'zh-CN': '驿马', 'zh-HK': '驛馬', 'en': 'Travel Star', 'ko': '역마', 'ja': '驛馬（えきば）' },
  '桃花': { 'zh-CN': '桃花', 'zh-HK': '桃花', 'en': 'Peach Blossom', 'ko': '도화', 'ja': '桃花（とうか）' },
  '羊刃': { 'zh-CN': '羊刃', 'zh-HK': '羊刃', 'en': 'Yang Blade', 'ko': '양인', 'ja': '羊刃（ようじん）' },
  '华盖': { 'zh-CN': '华盖', 'zh-HK': '華蓋', 'en': 'Flowery Canopy', 'ko': '화개', 'ja': '華蓋（かがい）' },
  '将星': { 'zh-CN': '将星', 'zh-HK': '將星', 'en': 'General Star', 'ko': '장성', 'ja': '将星（しょうせい）' },
  '魁罡': { 'zh-CN': '魁罡', 'zh-HK': '魁罡', 'en': 'Kui Gang Star', 'ko': '괴강', 'ja': '魁罡（かいごう）' },
  '孤辰': { 'zh-CN': '孤辰', 'zh-HK': '孤辰', 'en': 'Solitary Star', 'ko': '고진', 'ja': '孤辰（こしん）' },
  '寡宿': { 'zh-CN': '寡宿', 'zh-HK': '寡宿', 'en': 'Widow Star', 'ko': '과숙', 'ja': '寡宿（かしゅく）' },
};

export function getShenshaLabel(name: string, lang: string): string {
  if (lang === 'zh-CN' || lang === 'zh-HK' || lang === 'zh-TW') return convertText(name, lang);
  return SHENSHA_NAMES_I18N[name]?.[lang] ?? SHENSHA_NAMES_I18N[name]?.['zh-CN'] ?? name;
}

// ─── 神煞等级多语言 ────────────────────────────────────────────
export const SHENSHA_LEVEL_I18N: Record<string, Record<string, string>> = {
  '大吉': { 'zh-CN': '大吉', 'zh-HK': '大吉', 'en': 'Very Auspicious', 'ko': '대길', 'ja': '大吉' },
  '吉': { 'zh-CN': '吉', 'zh-HK': '吉', 'en': 'Auspicious', 'ko': '길', 'ja': '吉' },
  '中': { 'zh-CN': '中', 'zh-HK': '中', 'en': 'Neutral', 'ko': '중성', 'ja': '中' },
  '注意': { 'zh-CN': '注意', 'zh-HK': '注意', 'en': 'Caution', 'ko': '주의', 'ja': '注意' },
  '化解': { 'zh-CN': '化解', 'zh-HK': '化解', 'en': 'Resolve', 'ko': '화해', 'ja': '化解' },
};

export function getShenshaLevelLabel(level: string, lang: string): string {
  if (lang === 'zh-CN' || lang === 'zh-HK' || lang === 'zh-TW') return convertText(level, lang);
  return SHENSHA_LEVEL_I18N[level]?.[lang] ?? level;
}

// ─── 柱位名称多语言 ────────────────────────────────────────────
export const PILLAR_NAMES_I18N: Record<string, Record<string, string>> = {
  '年柱': { 'zh-CN': '年柱', 'zh-HK': '年柱', 'en': 'Year Pillar', 'ko': '연주', 'ja': '年柱' },
  '月柱': { 'zh-CN': '月柱', 'zh-HK': '月柱', 'en': 'Month Pillar', 'ko': '월주', 'ja': '月柱' },
  '日柱': { 'zh-CN': '日柱', 'zh-HK': '日柱', 'en': 'Day Pillar', 'ko': '일주', 'ja': '日柱' },
  '时柱': { 'zh-CN': '时柱', 'zh-HK': '時柱', 'en': 'Hour Pillar', 'ko': '시주', 'ja': '時柱' },
  '年柱、月柱': { 'zh-CN': '年柱、月柱', 'zh-HK': '年柱、月柱', 'en': 'Year & Month Pillars', 'ko': '연주・월주', 'ja': '年柱・月柱' },
  '年柱、日柱': { 'zh-CN': '年柱、日柱', 'zh-HK': '年柱、日柱', 'en': 'Year & Day Pillars', 'ko': '연주・일주', 'ja': '年柱・日柱' },
  '年柱、时柱': { 'zh-CN': '年柱、时柱', 'zh-HK': '年柱、時柱', 'en': 'Year & Hour Pillars', 'ko': '연주・시주', 'ja': '年柱・時柱' },
  '月柱、日柱': { 'zh-CN': '月柱、日柱', 'zh-HK': '月柱、日柱', 'en': 'Month & Day Pillars', 'ko': '월주・일주', 'ja': '月柱・日柱' },
  '月柱、时柱': { 'zh-CN': '月柱、时柱', 'zh-HK': '月柱、時柱', 'en': 'Month & Hour Pillars', 'ko': '월주・시주', 'ja': '月柱・時柱' },
  '日柱、时柱': { 'zh-CN': '日柱、时柱', 'zh-HK': '日柱、時柱', 'en': 'Day & Hour Pillars', 'ko': '일주・시주', 'ja': '日柱・時柱' },
  '年柱、月柱、日柱': { 'zh-CN': '年柱、月柱、日柱', 'zh-HK': '年柱、月柱、日柱', 'en': 'Year, Month & Day Pillars', 'ko': '연주・월주・일주', 'ja': '年柱・月柱・日柱' },
  '年柱、月柱、时柱': { 'zh-CN': '年柱、月柱、时柱', 'zh-HK': '年柱、月柱、時柱', 'en': 'Year, Month & Hour Pillars', 'ko': '연주・월주・시주', 'ja': '年柱・月柱・時柱' },
};

export function getPillarLabel(pillar: string, lang: string): string {
  if (lang === 'zh-CN' || lang === 'zh-HK' || lang === 'zh-TW') return convertText(pillar, lang);
  return PILLAR_NAMES_I18N[pillar]?.[lang] ?? pillar;
}

// ─── 大运/流年 十神领域描述（en/ko/ja）────────────────────────
type ShishenKey = '正官'|'七杀'|'正印'|'偏印'|'食神'|'伤官'|'正财'|'偏财'|'比肩'|'劫财'|'日主';
type DomainKey = 'overview'|'career'|'emotion'|'wealth'|'health';

const SHISHEN_DOMAIN_EN: Record<ShishenKey, Record<DomainKey, string>> = {
  正官: {
    overview: 'Direct Officer presides — a period of order, recognition, and steady advancement. Discipline and integrity are rewarded across all areas.',
    career: 'Career recognition and promotion opportunities emerge strongly. Principled, steady conduct earns leadership trust and advancement.',
    emotion: 'Relationships mature toward stability. Good time for serious commitments; existing bonds deepen meaningfully.',
    wealth: 'Steady salary growth and reliable returns. Conservative management and disciplined saving are favored over speculation.',
    health: 'Overall condition is good. Manage stress proactively; avoid prolonged anxiety to maintain wellbeing.',
  },
  七杀: {
    overview: 'Seven Killings governs — a cycle of challenge, pressure, and powerful potential. Every adversity hides a breakthrough opportunity.',
    career: 'Intense external pressure and competition. Rising to challenges activates your greatest potential; bold, strategic action creates breakthroughs.',
    emotion: 'Romantic tension with strong-willed clashes possible. Calm, patient communication is essential to maintain harmony.',
    wealth: 'Financial volatility; avoid high-risk ventures. Conservative, steady management protects accumulated wealth.',
    health: 'High-stress period. Monitor cardiovascular health; adequate sleep and emotional stability are essential.',
  },
  正印: {
    overview: 'Direct Seal shines — benefactor energy is strong, learning flourishes, and noble helpers appear. A decade of meaningful growth.',
    career: 'Excellent time for learning, credentials, and mentorship. Benefactors assist your career; long-term skill investments pay dividends.',
    emotion: 'Stable and warm relationships. Mature bonds deepen naturally; family connections may facilitate romantic opportunity.',
    wealth: 'Steady income through expertise and reputation. Avoid aggressive investment; patient accumulation is the right path.',
    health: 'Solid and healthy. Rest and nourishment support body and spirit; guard against over-relying on others.',
  },
  偏印: {
    overview: 'Side Seal activates — unconventional thinking deepens, specialized expertise shines, and independent paths lead forward.',
    career: 'Deep professional expertise produces outstanding results. Research, technical, and advisory roles excel. Specialization becomes your greatest asset.',
    emotion: 'Reserved in love; active communication and shared intellectual interests build the best connections.',
    wealth: 'Skills-based and knowledge income flow well. Consulting and expertise monetization are optimal revenue channels.',
    health: 'High mental energy consumption. Ensure adequate rest; avoid prolonged isolation that may cause emotional blockage.',
  },
  食神: {
    overview: 'Output Star shines — creative talent flows freely, life is abundant, and joy fills every area. A golden decade of self-expression.',
    career: 'A golden period for showcasing talents. Arts, creative, and skills-based work thrive. Career flows naturally and joyfully.',
    emotion: 'Warm and tender romance. Singles radiate natural charm; couples enjoy deeply fulfilling shared experiences.',
    wealth: 'Multiple income channels flow smoothly. Talent monetizes beautifully; lifestyle quality improves noticeably.',
    health: 'Strong vitality and excellent digestive health. Maintain active habits; avoid overindulgence for optimal wellbeing.',
  },
  伤官: {
    overview: 'Hurt Officer energizes — breakthrough thinking rises, creative individuality surges, and unconventional paths illuminate the way forward.',
    career: 'Innovation, creative entrepreneurship, and freelance ventures excel. Channel personal brilliance into creative achievements.',
    emotion: 'Rich romantic idealism with high partner expectations. Cultivating more tolerance and fewer disputes sustains love.',
    wealth: 'Variable income with mixed opportunity and risk. Avoid impulsive spending; no major investments this cycle.',
    health: 'Sensitive nervous system; prone to insomnia. Establish regular routines and prioritize sleep quality.',
  },
  正财: {
    overview: 'Direct Wealth flows — a period of steady accumulation, reliable returns, and grounded progress. Effort reliably converts to reward.',
    career: 'Career advances steadily; diligent effort yields visible results. Promotion and salary increase opportunities are strong.',
    emotion: 'Relationships become practical and stable. Excellent time to formalize partnerships and deepen meaningful commitments.',
    wealth: 'Peak financial period; income grows steadily and reliably. Accumulate solid assets through consistent, focused effort.',
    health: 'Excellent overall condition. Regular diet and exercise maintain optimal health; steady, grounded living is best.',
  },
  偏财: {
    overview: 'Side Wealth activates — diverse opportunities flow, social energy rises, and multi-channel fortune opens wide.',
    career: 'Diverse opportunities abound; networking unlocks business breakthroughs. Side ventures and commercial partnerships show notable progress.',
    emotion: 'Strong romantic magnetism; popular socially. If partnered, focus fully on your primary relationship to secure lasting happiness.',
    wealth: 'Multiple income sources with good investment opportunities. Move quickly on right opportunities; maintain a disciplined savings plan.',
    health: 'Active and energetic. Guard against over-socializing affecting rest; ensure adequate sleep each night.',
  },
  比肩: {
    overview: 'Peer energy rises — collaboration and competition both increase. Building unique strengths and strategic alliances leads to steady advancement.',
    career: 'Peer collaboration and competition both intensify. Build unique competitive advantages and strong alliances for best results.',
    emotion: 'Equal, independent partnership dynamic. Both parties need mutual respect and personal space to thrive.',
    wealth: 'Watch financial risks from peer partnerships. Avoid impulsive investments; steady personal accumulation is safest.',
    health: 'Generally stable. Avoid draining energy in excessive competition; maintain life balance and personal wellbeing.',
  },
  劫财: {
    overview: 'Rob Wealth surges — boldness and pioneering drive open new frontiers. Powerful momentum needs clear boundaries and wise direction.',
    career: 'Boldness and expansion energy open new frontiers. Good for growth, but clearly define boundaries in financial partnerships.',
    emotion: 'Relationships have intensity and fluctuation. Greater tolerance and clear communication prevent misunderstandings from escalating.',
    wealth: 'Elevated financial risk this cycle. Avoid high-risk investments; strictly control unnecessary expenditures.',
    health: 'High energy but emotional volatility. Maintain emotional stability; avoid excessive drinking and overexertion.',
  },
  日主: {
    overview: 'Stable, steady progress. Focus on core strengths and let consistent effort build lasting results.',
    career: 'Stable career momentum. Steady effort in your core area yields consistent, meaningful results.',
    emotion: 'Relationship energy is stable and comfortable. Nurture connection with thoughtful, consistent care.',
    wealth: 'Steady and reliable financial condition. Maintain healthy savings habits and moderate investments.',
    health: 'Good overall health. Maintain daily wellness routines; regular check-ups support long-term vitality.',
  },
};

const SHISHEN_DOMAIN_KO: Record<ShishenKey, Record<DomainKey, string>> = {
  正官: {
    overview: '정관이 이 대운을 주관합니다. 질서, 인정, 안정적인 전진의 시기입니다. 원칙과 성실함이 보상받습니다.',
    career: '직업 인정과 승진 기회가 강해집니다. 원칙적이고 신뢰할 수 있는 행동이 리더십의 신뢰를 얻습니다.',
    emotion: '인간관계가 안정적으로 성숙해집니다. 진지한 헌신에 좋은 시기이며 기존 유대가 깊어집니다.',
    wealth: '꾸준한 급여 성장과 안정적인 수익. 보수적인 관리와 규율 있는 저축이 최선입니다.',
    health: '전반적으로 좋은 상태. 스트레스를 선제적으로 관리하고 장기적인 불안을 피하세요.',
  },
  七杀: {
    overview: '칠살이 이 대운을 주관합니다. 도전, 압박, 강력한 잠재력의 시기입니다. 모든 역경에는 돌파구가 숨어 있습니다.',
    career: '강한 외부 압박과 경쟁. 도전에 맞서면 최대 잠재력이 활성화됩니다. 대담한 전략적 행동이 돌파구를 만듭니다.',
    emotion: '강한 의지의 충돌로 낭만적인 긴장감이 있을 수 있습니다. 차분하고 인내심 있는 소통이 조화를 유지합니다.',
    wealth: '재정적 변동성. 고위험 투자를 피하세요. 보수적이고 안정적인 관리가 쌓인 재산을 보호합니다.',
    health: '고스트레스 기간. 심혈관 건강을 모니터링하고 충분한 수면과 감정 안정이 필수입니다.',
  },
  正印: {
    overview: '정인이 빛납니다. 귀인 에너지가 강하고 학습이 번창하며 고귀한 조력자가 나타납니다. 의미 있는 성장의 10년입니다.',
    career: '학습, 자격증, 멘토링에 탁월한 시기. 귀인이 경력을 돕습니다. 장기적인 기술 투자가 큰 수익을 냅니다.',
    emotion: '안정적이고 따뜻한 인간관계. 성숙한 유대가 자연스럽게 깊어집니다.',
    wealth: '전문성과 명성을 통한 꾸준한 수입. 공격적인 투자를 피하고 인내심 있는 축적이 올바른 길입니다.',
    health: '튼튼하고 건강합니다. 휴식과 영양이 몸과 마음을 지원합니다.',
  },
  偏印: {
    overview: '편인이 활성화됩니다. 비관습적인 사고가 깊어지고 전문 지식이 빛나며 독립적인 길이 앞을 향합니다.',
    career: '깊은 전문 지식이 뛰어난 결과를 만듭니다. 연구, 기술, 자문 역할이 탁월합니다.',
    emotion: '사랑에서 내성적. 적극적인 소통과 공동의 지적 관심사가 최고의 연결을 구축합니다.',
    wealth: '기술 기반 및 지식 수입이 잘 흐릅니다. 컨설팅과 전문 지식 수익화가 최적의 수입원입니다.',
    health: '높은 정신 에너지 소모. 충분한 휴식을 보장하고 오랜 고립으로 인한 감정 장벽을 피하세요.',
  },
  食神: {
    overview: '식신이 빛납니다. 창의적 재능이 자유롭게 흐르고 삶이 풍요로우며 모든 영역에 기쁨이 가득합니다.',
    career: '재능을 발휘하는 황금기. 예술, 창작, 기술 기반 업무가 번창합니다. 경력이 자연스럽고 즐겁게 흘러갑니다.',
    emotion: '따뜻하고 다정한 낭만. 솔로는 자연스러운 매력을 발산하고 커플은 깊이 충만한 경험을 즐깁니다.',
    wealth: '여러 수입 채널이 원활히 흐릅니다. 재능이 아름답게 수익화되며 생활 수준이 눈에 띄게 향상됩니다.',
    health: '강한 활력과 훌륭한 소화 건강. 과식을 피하고 활동적인 습관을 유지하세요.',
  },
  伤官: {
    overview: '상관이 활력을 불어넣습니다. 돌파적인 사고가 솟아오르고 창의적 개성이 급증합니다.',
    career: '혁신, 창업 및 프리랜서 벤처가 탁월합니다. 개인의 탁월함을 창의적 성과로 채널링하세요.',
    emotion: '파트너에 대한 높은 기대치를 가진 풍부한 낭만적 이상주의. 더 많은 관용과 적은 분쟁이 사랑을 유지합니다.',
    wealth: '기회와 위험이 혼재된 변동적인 수입. 충동적인 지출을 피하고 이 사이클에서는 큰 투자를 삼가세요.',
    health: '민감한 신경계. 불면증에 취약합니다. 규칙적인 루틴을 확립하고 수면의 질을 우선시하세요.',
  },
  正财: {
    overview: '정재가 흐릅니다. 꾸준한 축적, 신뢰할 수 있는 수익, 발전의 시기. 노력이 안정적으로 보상으로 전환됩니다.',
    career: '경력이 꾸준히 발전합니다. 성실한 노력이 가시적인 결과를 낳습니다. 승진 및 급여 인상 기회가 강합니다.',
    emotion: '인간관계가 현실적이고 안정적으로 됩니다. 파트너십을 공식화하고 의미 있는 헌신을 깊게 하기에 좋은 시기.',
    wealth: '최고의 재정 시기. 수입이 꾸준하고 안정적으로 성장합니다. 일관된 노력으로 견고한 자산을 축적하세요.',
    health: '전반적으로 훌륭한 상태. 규칙적인 식이와 운동이 최적의 건강을 유지합니다.',
  },
  偏财: {
    overview: '편재가 활성화됩니다. 다양한 기회가 흐르고 사교 에너지가 상승하며 다채로운 행운이 열립니다.',
    career: '풍부한 다양한 기회. 네트워킹이 사업 돌파구를 만듭니다. 부업과 상업적 파트너십이 진전을 보입니다.',
    emotion: '강한 낭만적 매력으로 사교적으로 인기가 있습니다. 파트너가 있다면 주요 관계에 집중하세요.',
    wealth: '여러 수입원과 좋은 투자 기회. 좋은 기회를 빠르게 잡고 규율 있는 저축 계획을 유지하세요.',
    health: '활발하고 에너지가 넘칩니다. 과도한 사교 활동이 휴식에 영향을 주지 않도록 하고 충분한 수면을 확보하세요.',
  },
  比肩: {
    overview: '비견 에너지가 상승합니다. 협력과 경쟁이 모두 증가합니다. 독특한 강점과 전략적 동맹 구축이 꾸준한 전진을 이끕니다.',
    career: '동료 협업과 경쟁이 모두 강화됩니다. 독특한 경쟁 우위와 강력한 동맹을 구축하세요.',
    emotion: '평등하고 독립적인 파트너십 역학. 양측 모두 상호 존중과 개인 공간이 필요합니다.',
    wealth: '동료 파트너십으로 인한 재정 위험을 주시하세요. 충동적인 투자를 피하세요.',
    health: '전반적으로 안정적. 과도한 경쟁에서 에너지를 낭비하지 말고 생활 균형을 유지하세요.',
  },
  劫财: {
    overview: '겁재가 급상승합니다. 대담함과 개척 동력이 새로운 지평을 엽니다. 강력한 모멘텀에는 명확한 경계와 현명한 방향이 필요합니다.',
    career: '대담함과 확장 에너지가 새로운 지평을 엽니다. 성장에 좋지만 재정 파트너십의 경계를 명확히 하세요.',
    emotion: '강도와 변동이 있는 인간관계. 더 많은 관용과 명확한 소통이 오해 확대를 방지합니다.',
    wealth: '이 사이클에서 재정 위험이 높아집니다. 고위험 투자를 피하고 불필요한 지출을 엄격히 통제하세요.',
    health: '높은 에너지지만 감정적 변동. 감정 안정을 유지하고 과도한 음주와 과로를 피하세요.',
  },
  日主: {
    overview: '안정적이고 꾸준한 진전. 핵심 강점에 집중하고 일관된 노력이 지속적인 결과를 만들어 냅니다.',
    career: '안정적인 경력 모멘텀. 핵심 분야의 꾸준한 노력이 일관되고 의미 있는 결과를 낳습니다.',
    emotion: '인간관계 에너지가 안정적이고 편안합니다. 사려 깊고 일관된 배려로 연결을 키우세요.',
    wealth: '안정적이고 신뢰할 수 있는 재정 상태. 건전한 저축 습관과 적당한 투자를 유지하세요.',
    health: '전반적으로 좋은 건강. 일상적인 건강 루틴을 유지하세요.',
  },
};

const SHISHEN_DOMAIN_JA: Record<ShishenKey, Record<DomainKey, string>> = {
  正官: {
    overview: '正官がこの大運を主管します。秩序・認定・安定した前進の時期です。規律と誠実さが報われます。',
    career: '職場での認定と昇進の機会が強まります。原則的で信頼できる行動がリーダーシップの信頼を得ます。',
    emotion: '人間関係が安定へと成熟します。真剣なコミットメントに良い時期、既存の絆が深まります。',
    wealth: '給与の安定した成長と信頼できるリターン。保守的な管理と規律ある貯蓄が最善です。',
    health: '全体的に良好な状態。ストレスを予防的に管理し、長期的な不安を避けましょう。',
  },
  七杀: {
    overview: '七殺がこの大運を支配します。挑戦・圧力・強力な潜在力の時期。あらゆる逆境に突破口が隠れています。',
    career: '強い外部プレッシャーと競争。困難に立ち向かうことで最大の潜在力が発揮されます。',
    emotion: '強い意志のぶつかりで恋愛に緊張が生まれることも。穏やかで忍耐強いコミュニケーションが調和を保ちます。',
    wealth: '財運に変動あり。高リスク投資を避け、保守的で安定した管理が積み重ねた財産を守ります。',
    health: '高ストレス期間。心血管の健康を注視し、十分な睡眠と感情の安定が不可欠です。',
  },
  正印: {
    overview: '正印が輝きます。貴人のエネルギーが強く、学びが花開き、高貴な助力者が現れます。意義ある成長の10年。',
    career: '学習・資格・メンターシップに優れた時期。貴人がキャリアを支援します。長期的スキル投資が実を結びます。',
    emotion: '安定した温かな人間関係。成熟した絆が自然に深まります。',
    wealth: '専門性と評判による安定した収入。積極的な投資を避け、忍耐強い積み重ねが正しい道。',
    health: 'しっかりした健康状態。休息と栄養が心身を支えます。',
  },
  偏印: {
    overview: '偏印が発動します。型にはまらない思考が深まり、専門知識が輝き、独立した道が前に開けます。',
    career: '深い専門知識が卓越した結果をもたらします。研究・技術・アドバイザリー職が優秀です。',
    emotion: '恋愛では内向的。積極的なコミュニケーションと共通の知的関心が最良のつながりを築きます。',
    wealth: 'スキルベースと知識収入の流れが良好。コンサルティングと専門知識の収益化が最適です。',
    health: '精神エネルギーの消耗が高い。十分な休息を確保し、長期的な孤立が感情の閉塞をもたらさないように。',
  },
  食神: {
    overview: '食神が輝きます。創造的才能が自由に流れ、生活が豊かで、あらゆる領域に喜びが満ちます。',
    career: '才能を披露する黄金期。芸術・創作・スキルベースの仕事が繁栄します。キャリアは自然と流れます。',
    emotion: '温かく優しい恋愛。独身者は自然な魅力を放ち、カップルは深く充実した経験を楽しみます。',
    wealth: '複数の収入チャンネルが順調に流れます。才能が美しく収益化され、生活の質が顕著に向上します。',
    health: '旺盛な活力と優れた消化機能。暴飲暴食を避け、活動的な習慣を維持しましょう。',
  },
  伤官: {
    overview: '傷官が活力を与えます。突破的な思考が高まり、創造的個性が溢れ出します。',
    career: '革新・創業・フリーランスが卓越。個人の輝きを創造的な成果に集中させましょう。',
    emotion: '豊かな恋愛理想主義でパートナーへの期待が高い。より多くの寛容と少ない争いが愛を維持します。',
    wealth: '機会とリスクが混在する変動収入。衝動的な支出を避け、大きな投資は控えましょう。',
    health: '敏感な神経系で不眠になりやすい。規則的なルーティンを確立し、睡眠の質を優先しましょう。',
  },
  正财: {
    overview: '正財が流れます。着実な積み重ね・信頼できるリターン・着実な進歩の時期。努力が確実に報酬に変換されます。',
    career: 'キャリアが着実に前進します。勤勉な努力が目に見える結果をもたらします。昇進・昇給の機会が強まります。',
    emotion: '人間関係が現実的で安定します。パートナーシップを正式化し意味のあるコミットメントを深めるのに良い時期。',
    wealth: '財運のピーク期。収入が着実に成長します。一貫した努力で堅固な資産を積み重ねましょう。',
    health: '全体的に優れた状態。規則的な食事と運動が最高の健康を維持します。',
  },
  偏财: {
    overview: '偏財が発動します。多様な機会が流れ、交際エネルギーが高まり、多方面の幸運が開きます。',
    career: '多彩な機会が豊富。ネットワーキングがビジネスの突破口を開きます。副業・商業パートナーシップが進展します。',
    emotion: '強い恋愛的磁力で社交的に人気があります。パートナーがいる場合は主要な関係に集中しましょう。',
    wealth: '複数の収入源と良好な投資機会。良い機会を素早くつかみ、規律ある貯蓄計画を維持しましょう。',
    health: '活発でエネルギッシュ。過度な社交活動が休息に影響しないよう、十分な睡眠を確保してください。',
  },
  比肩: {
    overview: '比肩のエネルギーが高まります。協力と競争の両方が増加します。独自の強みと戦略的同盟の構築が着実な前進をもたらします。',
    career: '同業者の協力と競争が激化します。独自の競争優位と強力な同盟を構築してください。',
    emotion: '平等で独立したパートナーシップのダイナミクス。双方が相互尊重と個人空間を必要とします。',
    wealth: '同業者パートナーシップからの財政リスクに注意。衝動的な投資を避けましょう。',
    health: '全般的に安定。過度な競争でエネルギーを消耗せず、生活バランスを維持してください。',
  },
  劫财: {
    overview: '劫財が急上昇します。大胆さと開拓の原動力が新たな地平を開きます。強い勢いには明確な境界と賢明な方向が必要です。',
    career: '大胆さと拡大エネルギーが新しい地平を開きます。成長に良いですが、財務パートナーシップの境界を明確にしましょう。',
    emotion: '強度と変動のある人間関係。より多くの寛容と明確なコミュニケーションが誤解の拡大を防ぎます。',
    wealth: 'このサイクルでは財政リスクが高まります。高リスク投資を避け、不必要な支出を厳しく管理してください。',
    health: '高エネルギーだが感情的変動あり。感情の安定を保ち、飲み過ぎと過労を避けましょう。',
  },
  日主: {
    overview: '安定した着実な進歩。コアな強みに集中し、一貫した努力が持続的な結果を積み重ねます。',
    career: '安定したキャリアモメンタム。コア領域への着実な努力が一貫した意味のある結果をもたらします。',
    emotion: '人間関係のエネルギーは安定して快適です。思慮深く一貫したケアでつながりを育みましょう。',
    wealth: '安定した信頼できる財政状態。健全な貯蓄習慣と適度な投資を維持してください。',
    health: '全体的に良好な健康。日常的な健康ルーティンを維持してください。',
  },
};

export function getShishenDomainDesc(shishen: string, domain: string, lang: string): string | null {
  const ss = shishen as ShishenKey;
  const d = domain as DomainKey;
  if (lang === 'en') return SHISHEN_DOMAIN_EN[ss]?.[d] ?? null;
  if (lang === 'ko') return SHISHEN_DOMAIN_KO[ss]?.[d] ?? null;
  if (lang === 'ja') return SHISHEN_DOMAIN_JA[ss]?.[d] ?? null;
  return null;
}

// ─── 流年综合描述（en/ko/ja 模板）─────────────────────────────
export function buildLiunianOverallDescLocale(
  year: number,
  shishen: string,
  overallLevel: string,
  lang: string,
): string | null {
  const ss = getShishenLabel(shishen, lang);
  if (lang === 'en') {
    const levelMap: Record<string, string> = {
      '大吉': 'Fortune is exceptionally strong — seize every opportunity.',
      '吉': 'Fortune is favorable overall — good progress across all areas.',
      '平顺': 'Fortune is steady and balanced — steady effort yields results.',
      '需注意': 'Fortune has fluctuations — proceed with care and awareness.',
      '挑战': 'Fortune faces headwinds — stay grounded and adapt wisely.',
    };
    return `${year}: Annual Luck God is ${ss}. ${levelMap[overallLevel] ?? ''} Stay focused and approach each challenge with composure.`;
  }
  if (lang === 'ko') {
    const levelMap: Record<string, string> = {
      '大吉': '운세가 매우 왕성합니다. 모든 기회를 잡으세요.',
      '吉': '운세가 전반적으로 양호합니다. 모든 분야에서 좋은 진전이 있습니다.',
      '平顺': '운세가 안정적입니다. 꾸준한 노력이 결실을 맺습니다.',
      '需注意': '운세에 기복이 있습니다. 신중하게 진행하세요.',
      '挑战': '운세가 역풍을 맞습니다. 차분히 현명하게 적응하세요.',
    };
    return `${year}년 유년 ${ss}운. ${levelMap[overallLevel] ?? ''} 기회를 놓치지 말고 모든 도전에 의연하게 대처하세요.`;
  }
  if (lang === 'ja') {
    const levelMap: Record<string, string> = {
      '大吉': '運勢が非常に旺盛。あらゆる機会をつかんでください。',
      '吉': '運勢は全体的に良好。各方面で順調な進展があります。',
      '平顺': '運勢は安定。着実な努力が実を結びます。',
      '需注意': '運勢に起伏があります。注意深く進んでください。',
      '挑战': '運勢が向かい風です。落ち着いて賢く適応してください。',
    };
    return `${year}年 流年${ss}運。${levelMap[overallLevel] ?? ''} 機会をつかみ、あらゆる挑戦に泰然と向き合ってください。`;
  }
  return null;
}

// ─── 流年大运关键建议（en/ko/ja）─────────────────────────────
export function getShishenKeyAdvice(shishen: string, lang: string): string[] | null {
  const adviceEn: Record<string, string[]> = {
    '正官': ['Seize career advancement; be proactive and principled', 'Relationships grow stable — consider long-term commitments', 'Integrity and trustworthiness are your greatest reputation capital'],
    '七杀': ['Stay calm under pressure; use wisdom over confrontation', 'Strengthen physical fitness to build resilience', 'Avoid rash decisions; approach competition with strategic patience'],
    '正印': ['Noble helpers are active — proactively seek mentors', 'Invest in learning and credentials for long-term returns', 'Stay patient and calm; the right timing will come naturally'],
    '偏印': ['Develop deep expertise in one specialty', 'Create unique value through quiet, independent thought', 'Expand social connections to avoid intellectual narrowing'],
    '食神': ['Boldly showcase your talents — this is your spotlight moment', 'Invest in yourself and improve life quality', 'Stay positive; vitality is abundant and all things flow'],
    '伤官': ['Channel talent into creative output and build a personal brand', 'Be more tolerant in relationships; reduce unnecessary conflicts', 'Think outside the box — innovation brings breakthrough opportunities'],
    '正财': ['Focus on your core work; diligence is the best financial luck', 'Build solid assets with stable, long-term financial planning', 'Establish strong financial management habits'],
    '偏财': ['Expand your network; opportunities emerge through connections', 'Act quickly on the right opportunities', 'Diversify income streams while managing risk proportionally'],
    '比肩': ['Leverage peer collaboration for collective wins', 'Build distinctive competitive advantages', 'Unite allies to meet competitive challenges together'],
    '劫财': ['Be financially cautious; avoid impulsive decisions and guarantees', 'Clearly define contracts in partnerships to protect your interests', 'Channel bold energy into positive, constructive action'],
    '日主': ['Maintain steady progress; leverage existing strengths', 'Stay grounded; consistent effort moves you forward', 'Focus on health and energy to sustain long-term momentum'],
  };
  const adviceKo: Record<string, string[]> = {
    '正官': ['직업 승진 기회를 잡으세요. 적극적이고 원칙적으로', '관계가 안정적으로 성장합니다. 장기적 헌신을 고려하세요', '성실함과 신뢰가 가장 큰 명성 자본입니다'],
    '七杀': ['압박 아래서도 침착하게. 지혜로 대결을 대체하세요', '체력 강화로 회복력을 키우세요', '성급한 결정을 피하고 전략적인 인내로 경쟁에 임하세요'],
    '正印': ['귀인이 활발합니다. 적극적으로 멘토를 찾으세요', '장기적 수익을 위해 학습과 자격증에 투자하세요', '인내심을 갖고 차분하게. 올바른 시기가 자연스럽게 옵니다'],
    '偏印': ['한 가지 전문 분야에서 깊은 지식을 개발하세요', '조용한 독립적 사고를 통해 독특한 가치를 만드세요', '사회적 연결을 확장해 지적 편협함을 방지하세요'],
    '食神': ['재능을 과감하게 발휘하세요. 지금이 스포트라이트의 순간', '자신에게 투자하고 삶의 질을 향상시키세요', '긍정적으로 유지하세요. 활력이 넘치고 모든 것이 흘러갑니다'],
    '伤官': ['재능을 창의적 결과물로 채널링하세요', '관계에서 더 관대하게. 불필요한 갈등을 줄이세요', '박스 밖에서 생각하세요. 혁신이 돌파구를 가져옵니다'],
    '正财': ['핵심 업무에 집중하세요. 성실함이 최고의 재운', '안정적인 장기 재무 계획으로 견고한 자산을 쌓으세요', '강력한 재무 관리 습관을 확립하세요'],
    '偏财': ['네트워크를 확장하세요. 기회는 인맥에서 나옵니다', '올바른 기회에 빠르게 행동하세요', '수입원을 다각화하면서 위험 비율을 관리하세요'],
    '比肩': ['동료 협력을 활용해 집단적 승리를 이루세요', '독특한 경쟁 우위를 구축하세요', '동맹을 단결시켜 경쟁 도전에 함께 대응하세요'],
    '劫财': ['재정적으로 신중하게. 충동적인 결정과 보증을 피하세요', '파트너십에서 계약을 명확히 하세요', '대담한 에너지를 긍정적이고 건설적인 행동으로 채널링하세요'],
    '日主': ['안정적인 진전을 유지하세요. 기존 강점을 활용하세요', '꾸준히 유지하세요. 일관된 노력이 앞으로 나아갑니다', '장기적인 모멘텀을 위해 건강과 에너지에 집중하세요'],
  };
  const adviceJa: Record<string, string[]> = {
    '正官': ['昇進機会をつかみましょう。積極的で原則的に', '関係が安定に向かいます。長期的コミットメントを検討を', '誠実さと信頼性が最大の評判資本です'],
    '七杀': ['プレッシャー下でも冷静に。知恵で対立を置き換えて', '体力強化でレジリエンスを高めましょう', '無謀な決断を避け、戦略的な忍耐で競争に臨みましょう'],
    '正印': ['貴人が活発です。積極的にメンターを探しましょう', '長期的リターンのため学習・資格に投資を', '忍耐強く穏やかに。適切なタイミングが自然にやってきます'],
    '偏印': ['一つの専門分野で深い知識を磨きましょう', '静かな独立した思考でユニークな価値を生み出して', '社会的つながりを広げ知的な偏狭さを防ぎましょう'],
    '食神': ['才能を大胆に発揮しましょう。今があなたの輝く瞬間', '自分に投資し生活の質を向上させましょう', '前向きを保ちましょう。活力が溢れすべてが流れます'],
    '伤官': ['才能を創造的な成果に集中させブランドを構築を', '人間関係でより寛大に。不必要な争いを減らしましょう', '固定観念を超えて。革新が突破口をもたらします'],
    '正财': ['コア業務に集中しましょう。勤勉さが最高の財運', '安定した長期財務計画で堅固な資産を積み立てましょう', '強力な財務管理習慣を確立しましょう'],
    '偏财': ['人脈を広げましょう。機会はつながりから生まれます', '良い機会には素早く行動を', '収入源を分散しつつリスク比率を管理しましょう'],
    '比肩': ['同業者の協力を活用して集団的勝利を', '独自の競争優位を構築しましょう', '同盟を結束させ競争の挑戦に共に対応を'],
    '劫财': ['財務的に慎重に。衝動的な決断・保証を避けましょう', 'パートナーシップで契約を明確にしましょう', '大胆なエネルギーをポジティブな行動に向けましょう'],
    '日主': ['安定した進歩を維持。既存の強みを活用しましょう', '着実に。一貫した努力が前進をもたらします', '長期的モメンタムのため健康とエネルギーに集中を'],
  };
  if (lang === 'en') return adviceEn[shishen] ?? null;
  if (lang === 'ko') return adviceKo[shishen] ?? null;
  if (lang === 'ja') return adviceJa[shishen] ?? null;
  return null;
}

// ─── 流年调和参考（en/ko/ja）────────────────────────────────
export function getLiunianResolveLocale(shishen: string, lang: string): string | null {
  const resolveEn: Record<string, string> = {
    '七杀': 'Perform acts of kindness; avoid confrontational environments; stay humble and low-profile during this period.',
    '劫财': 'Be financially conservative; avoid acting as guarantor; do good deeds to ease financial instability; wear your favorable-element talisman.',
    '伤官': 'Speak less and smile more; channel individuality into creation rather than opposition; cultivate inner peace to reduce emotional swings.',
  };
  const resolveKo: Record<string, string> = {
    '七杀': '선행을 쌓고 음덕을 적립하세요. 경쟁이 치열한 환경을 피하고 이 기간에는 겸손하고 조용하게 지내세요.',
    '劫财': '재정적으로 보수적으로 하세요. 보증인 역할을 피하고 선행으로 재정 불안을 완화하세요.',
    '伤官': '말을 줄이고 미소를 더 하세요. 개성 에너지를 대립이 아닌 창조로 채널링하세요.',
  };
  const resolveJa: Record<string, string> = {
    '七杀': '善行を積み陰徳を貯めましょう。競争の激しい環境を避け、この期間は謙虚に低姿勢を保ちましょう。',
    '劫财': '財務は保守的に。保証人役割を避け、善行で財運の不安定を和らげましょう。',
    '伤官': '発言を減らし笑顔を増やしましょう。個性エネルギーを対立でなく創造に向けましょう。',
  };
  const defaultMsg: Record<string, string> = {
    en: 'Stay positive and kind; think before acting; keep a calm mindset and challenges will naturally ease.',
    ko: '긍정적이고 친절하게 지내세요. 행동 전에 생각하고 차분한 마음을 유지하면 도전이 자연스럽게 완화됩니다.',
    ja: '前向きで親切に。行動前に考え、穏やかな心を保てば挑戦は自然と和らぎます。',
  };
  if (lang === 'en') return resolveEn[shishen] ?? defaultMsg.en;
  if (lang === 'ko') return resolveKo[shishen] ?? defaultMsg.ko;
  if (lang === 'ja') return resolveJa[shishen] ?? defaultMsg.ja;
  return null;
}

// ─── 今日日柱生克关系描述（多语言）────────────────────────────
export const ELEMENT_RELATIONS_I18N: Record<string, Record<string, string>> = {
  '日柱相生': {
    'zh-CN': '受扶助，能量倍增', 'zh-HK': '受扶助，能量倍增',
    'en': 'Supported, energy amplified', 'ja': '生助され、エネルギー倍増', 'ko': '지원받아 에너지 배가',
  },
  '泄气耗力': {
    'zh-CN': '消耗气力，宜蓄能', 'zh-HK': '消耗氣力，宜蓄能',
    'en': 'Energy draining, conserve strength', 'ja': '気力消耗、蓄える時', 'ko': '기력 소모, 축적 필요',
  },
  '日柱相克': {
    'zh-CN': '受制约，需谨慎', 'zh-HK': '受制約，需謹慎',
    'en': 'Restrained, proceed carefully', 'ja': '制約あり、慎重に', 'ko': '제약받아 신중 필요',
  },
  '克制日柱': {
    'zh-CN': '主导制约，气势旺', 'zh-HK': '主導制約，氣勢旺',
    'en': 'Dominant, energy strong', 'ja': '主導的、気勢旺盛', 'ko': '주도적, 기세 왕성',
  },
  '同气比旺': {
    'zh-CN': '同频共振，更旺盛', 'zh-HK': '同頻共振，更旺盛',
    'en': 'Resonating, greatly amplified', 'ja': '同調共鳴、さらに旺盛', 'ko': '공명 증폭, 더욱 왕성',
  },
  '平和无碍': {
    'zh-CN': '平稳运行，无特殊影响', 'zh-HK': '平穩運行，無特殊影響',
    'en': 'Stable, no special influence', 'ja': '安定、特別な影響なし', 'ko': '안정적, 특별한 영향 없음',
  },
};

// ─── 今日五行日柱总结（多语言）────────────────────────────────
export const ELEMENT_DAY_SUMMARY_I18N: Record<string, Record<string, string>> = {
  '木': {
    'zh-CN': '今日木气为主，朝气蓬勃，宜开拓进取、扩展人脉',
    'zh-HK': '今日木氣為主，朝氣蓬勃，宜開拓進取、擴展人脈',
    'en': 'Wood energy prevails today. Vibrant vitality—ideal for growth, exploration & networking.',
    'ja': '今日は木気が主導。活力に満ち、開拓や人脈拡大に最適な一日。',
    'ko': '오늘은 목기가 주도합니다. 활력이 넘치는 날로 개척과 인맥 확장에 적합합니다.',
  },
  '火': {
    'zh-CN': '今日火气主导，热情洋溢，宜展示自我、把握机遇',
    'zh-HK': '今日火氣主導，熱情洋溢，宜展示自我、把握機遇',
    'en': 'Fire energy dominates today. Full of passion—great for self-expression and seizing opportunities.',
    'ja': '今日は火気が主導。情熱あふれ、自己表現や機会掴みに最適。',
    'ko': '오늘은 화기가 주도합니다. 열정이 넘쳐나는 날로 자기 표현과 기회 포착에 적합합니다.',
  },
  '土': {
    'zh-CN': '今日土气旺盛，踏实稳重，宜积累财富、固本培元',
    'zh-HK': '今日土氣旺盛，踏實穩重，宜積累財富、固本培元',
    'en': 'Earth energy strong today. Grounded and steady—ideal for wealth accumulation and solid foundations.',
    'ja': '今日は土気が旺盛。地に足がつき、財の蓄積や基盤強化に最適。',
    'ko': '오늘은 토기가 왕성합니다. 안정적인 날로 재산 축적과 기반 강화에 적합합니다.',
  },
  '金': {
    'zh-CN': '今日金气主宰，果断清晰，宜签约谈判、做重大决策',
    'zh-HK': '今日金氣主宰，果斷清晰，宜簽約談判、做重大決策',
    'en': 'Metal energy leads today. Clear and decisive—perfect for contracts, negotiations and major decisions.',
    'ja': '今日は金気が主導。果断明快、契約・交渉・重大な意思決定に最適。',
    'ko': '오늘은 금기가 주도합니다. 명확하고 결단력 있는 날로 계약, 협상, 중요 결정에 적합합니다.',
  },
  '水': {
    'zh-CN': '今日水气流动，智慧涌现，宜学习谋划、洞察机先',
    'zh-HK': '今日水氣流動，智慧湧現，宜學習謀劃、洞察機先',
    'en': 'Water energy flows today. Wisdom surges—ideal for learning, strategizing and sharp insight.',
    'ja': '今日は水気が流れる。知恵が湧き、学習・戦略立案・先見の明に最適。',
    'ko': '오늘은 수기가 흐릅니다. 지혜가 솟아나는 날로 학습, 전략 수립, 통찰에 적합합니다.',
  },
};

// ─── 宜忌事项英文翻译 ─────────────────────────────────────────
export const YI_JI_EN: Record<string, string> = {
  // 宜
   '开市营业': 'Business Opening', '祭祀祈福': 'Prayer & Offering',
   '上梁安门': 'Roofing & Installation', '求职应聘': 'Job Seeking',
  '成婚嫁娶': 'Wedding Ceremonies', '签约缔盟': 'Signing Contracts', '搬家迁居': 'Moving Home',
  '清扫整理': 'Cleaning & Organizing', '解除纠纷': 'Resolving Disputes', '去旧换新': 'Renewal',
  '求医问诊': 'Medical Consultation', '沐浴洁净': 'Bathing & Purification', '学习进修': 'Learning & Study',
  '婚嫁典礼': 'Wedding Ceremony', '开业庆典': 'Grand Opening', '置办财货': 'Financial Transactions',
  '宴客待友': 'Hosting Guests', '升迁职位': 'Career Advancement', '立契签约': 'Signing Agreements',
  '日常事务': 'Daily Affairs', '休养生息': 'Rest & Recovery', '整理文书': 'Document Organization',
  '朋友聚会': 'Social Gatherings', '家居整顿': 'Home Organization', '签约立约': 'Making Agreements',
  '婚嫁感情': 'Romance & Marriage', '安葬仪式': 'Funeral Rites', '置产购房': 'Property Purchase',
  '商议谈判': 'Business Negotiation', '收成入库': 'Harvest Storage', '执行计划': 'Executing Plans',
  '追债讨债': 'Debt Collection', '捕猎渔猎': 'Hunting & Fishing', '立约执行': 'Contract Execution',
  '除虫杀草': 'Pest Control', '医治疗养': 'Medical Treatment', '排泄宿便': 'Detoxification',
  '清理废物': 'Clearing Waste', '破旧立新': 'Breaking Old Habits', '整理杂乱': 'Tidying Up',
  '打捞修葺': 'Repair Works', '治理旧伤': 'Healing Old Wounds', '收购置产': 'Acquisition',
  '储蓄理财': 'Saving & Finance', '收债还款': 'Debt Repayment', '家居储藏': 'Home Storage',
  '整理仓库': 'Warehouse Organization', '开市开业': 'Opening Business', 
  '出行交际': 'Social Travel', '动土破地': 'Groundbreaking', '求职求学': 'Career & Education',
    
    '休息养生': 'Rest & Wellness',
  '种植耕耘': 'Planting & Farming', '文书写作': 'Writing & Documentation',
  '社交拓展': 'Social Networking', '公开演讲': 'Public Speaking', '文艺创作': 'Creative Arts',
  '仪式庆典': 'Ceremonies & Celebrations', '投资置产': 'Investment', '建筑营造': 'Construction',
  '踏实积累': 'Steady Accumulation', '稳健理财': 'Sound Financial Management',
  '收款还债': 'Collecting & Repaying Debts', '决策斩断': 'Decision Making',
  '运动健身': 'Exercise & Fitness', '旅行出游': 'Travel & Excursion',
  '洽谈沟通': 'Business Communication', '泡澡泡脚': 'Relaxation Bath',
  // 忌
  '冲动消费': 'Impulsive Spending', '争吵口角': 'Arguments & Quarrels', '借贷投资': 'Loans & Risky Investment',
  '熬夜劳累': 'Staying Up Late', '诉讼争讼': 'Litigation', '拆屋破宅': 'Demolition',
  '大手术': 'Major Surgery', '婚嫁宴席': 'Wedding Banquets', '动土兴工': 'Major Construction',
  '出行远游': 'Long-distance Travel', '大额投资': 'Large Investments', '签订合同': 'Contract Signing',
  '婚嫁喜事': 'Wedding Events', '入宅迁居': 'Moving In', '服药就医': 'Taking Medicine',
  '穿井挖沟': 'Digging Wells & Trenches', '葬仪丧事': 'Funeral Services', '借钱告贷': 'Borrowing Money',
  '冒险投机': 'Speculation', '大额交易': 'Large Transactions', '动用刀斧': 'Using Sharp Tools',
  '争讼诉讼': 'Legal Disputes', '高空作业': 'High-altitude Work', '远行征途': 'Long Journeys',
  '攀高涉险': 'Climbing & Risky Activities', 
   '开山动土': 'Excavation', '乘船渡水': 'Water Travel',
  '争讼争讼': 'Disputes & Lawsuits', '破旧事物': 'Breaking Old Things',
  '债务谈判': 'Debt Negotiation', '嫁娶婚事': 'Marriage Events',
  '疏通水道': 'Water Channel Work', '破土挖掘': 'Excavation',
  '宴请宾客': 'Banquets', '频繁变动': 'Frequent Changes', '大规模拆建': 'Large-scale Demolition',
  '无度挥霍': 'Wasteful Spending', '挖土穿井': 'Digging & Well-making',
  '钝刀作业': 'Blunt Instrument Work', '优柔寡断': 'Indecision',
  '金属冒险': 'Metal-related Risks', '大量饮酒': 'Excessive Drinking',
  '情绪失控': 'Emotional Outbursts', '深水涉险': 'Water Hazards',
  '改变既定计划': 'Changing Fixed Plans', '借贷担保': 'Loans & Guarantees', '出行争讼': 'Travel & Disputes',
  '谈判争议': 'Negotiations & Disputes', '借贷抵押': 'Loans & Mortgages', '远行出门': 'Long-distance Travel',
  '高风险投资': 'High-risk Investment', '大兴土木': 'Major Construction', '攀高走险': 'Risky Climbing',
  '高调扬名': 'High-profile Publicity', '家居搬迁': 'Home Relocation', '婚嫁嫁娶': 'Wedding & Marriage',
  '签约立契': 'Signing Contracts', '动土兴建': 'Groundbreaking & Construction', '居家修缮': 'Home Repairs',
  '安居整理': 'Home Organization', '日常理财': 'Daily Financial Management', '祭祀拜神': 'Prayer & Worship',
  '诵经积德': 'Chanting & Virtue', '破土动工': 'Breaking Ground', '求职谋事': 'Job Seeking',
  '开业动土': 'Opening & Groundbreaking', '高风险冒险': 'High-risk Adventures', '手术医疗': 'Surgery & Medical',
  '筑坝堤坝': 'Dam Construction', '填土封穴': 'Earthwork & Filling', '守身修性': 'Self-cultivation',
  '储藏财物': 'Storing Valuables', '诵经冥想': 'Meditation & Chanting', '开市出行': 'Opening & Travel',
  '大型宴席': 'Large Banquets', '破宅拆屋': 'Demolition', '手术诊疗': 'Surgery & Treatment',
  '肾脏消耗': 'Kidney Strain', '伐木砍树': 'Tree Cutting',
  '过度节制': 'Excessive Restriction', '压制创意': 'Suppressing Creativity',
  '限制自由': 'Restricting Freedom', '冷水激身': 'Cold Water Exposure',
  '暗室独处': 'Isolation in Dark', '压抑情感': 'Suppressing Emotions',
  '寒凉饮食': 'Cold Foods & Drinks',
};

// 英文宜忌：若找不到则原样返回
export function translateYiJiEn(item: string): string {
  return YI_JI_EN[item] ?? item;
}

// ─── 建除十二神英文 ───────────────────────────────────────────
export const JIANCHU_EN: Record<string, { name: string; desc: string; auspicious: string; neutral: string }> = {
  '建': { name: 'Establish', desc: 'A day of vitality and initiation—auspicious for bold action and new beginnings.', auspicious: 'Auspicious', neutral: 'Neutral' },
  '除': { name: 'Remove', desc: 'A day to clear the old and make way for the new—ideal for cleansing and fresh starts.', auspicious: 'Auspicious', neutral: 'Neutral' },
  '满': { name: 'Fulfill', desc: 'A day of fulfillment and abundance—excellent for celebrations, weddings and important events.', auspicious: 'Auspicious', neutral: 'Neutral' },
  '平': { name: 'Balance', desc: 'A stable, balanced day—suitable for routine matters and steady progress without rushing.', auspicious: 'Auspicious', neutral: 'Neutral' },
  '定': { name: 'Settle', desc: 'A day of settling and solidifying—good for agreements, commitments and establishing things.', auspicious: 'Auspicious', neutral: 'Neutral' },
  '执': { name: 'Execute', desc: 'A day for execution and follow-through—best for implementing established plans.', auspicious: 'Auspicious', neutral: 'Neutral' },
  '破': { name: 'Break', desc: 'A challenging day with obstacles—best to stay quiet and avoid major undertakings.', auspicious: 'Inauspicious', neutral: 'Inauspicious' },
  '危': { name: 'Danger', desc: 'A cautious day—avoid risky activities and keep a low profile for safety.', auspicious: 'Inauspicious', neutral: 'Inauspicious' },
  '成': { name: 'Succeed', desc: 'A highly auspicious day—everything undertaken tends to succeed and flourish.', auspicious: 'Auspicious', neutral: 'Neutral' },
  '收': { name: 'Harvest', desc: 'A day for gathering and accumulating—excellent for saving, storing and receiving.', auspicious: 'Auspicious', neutral: 'Neutral' },
  '开': { name: 'Open', desc: 'An auspicious day for new openings—great for starting businesses, socializing and new ventures.', auspicious: 'Auspicious', neutral: 'Neutral' },
  '闭': { name: 'Close', desc: 'A day for retreat and conservation—best to stay inward and accumulate quietly.', auspicious: 'Inauspicious', neutral: 'Inauspicious' },
};

// ─── 方位英文 ─────────────────────────────────────────────────
export const DIRECTION_EN: Record<string, { name: string; short: string }> = {
  '东南方': { name: 'Southeast', short: 'SE' },
  '正东方': { name: 'East', short: 'E' },
  '正南方': { name: 'South', short: 'S' },
  '东北方': { name: 'Northeast', short: 'NE' },
  '正西方': { name: 'West', short: 'W' },
  '西北方': { name: 'Northwest', short: 'NW' },
  '正北方': { name: 'North', short: 'N' },
  '西南方': { name: 'Southwest', short: 'SW' },
};

// ─── 幸运数字韩文含义 ─────────────────────────────────────────
export const NUMBER_MEANINGS_KO: Record<number, string> = {
  1: '시작과 리더십의 숫자. 오늘은 주도적으로 나서고 새로운 길을 개척하세요.',
  2: '조화와 협력의 숫자. 인간관계를 활용하고 부드럽게 협력하여 함께 이기세요.',
  3: '표현과 창의의 숫자. 오늘은 사고가 활발하여 창작, 소통, 사교에 적합합니다.',
  4: '성실과 안정의 숫자. 오늘은 착실하게 기초를 다지고 단계적으로 나아가세요.',
  5: '변화와 자유의 숫자. 오늘은 변화를 받아들이고 새로운 것을 시도하며 유연하게 대응하세요.',
  6: '조화와 책임의 숫자. 오늘은 인연이 왕성하고 가정과 감정 사안이 순조롭습니다.',
  7: '지혜와 내성의 숫자. 오늘은 직관이 예리하여 깊은 사고와 연구에 적합합니다.',
  8: '풍요와 권세의 숫자. 오늘은 재물과 사업 에너지가 모여 물질적 기회를 잡으세요.',
  9: '원만과 대애의 숫자. 오늘은 일을 마무리하고 경험을 정리하며 선행을 쌓으세요.',
};

export const NUMBER_WUXING_KO: Record<number, { element: string; blessing: string }> = {
  1: { element: '수', blessing: '지혜 발현, 만상 새로워짐' },
  2: { element: '토', blessing: '포용 공제, 후덕재물' },
  3: { element: '목', blessing: '생기 발발, 단계적 상승' },
  4: { element: '목', blessing: '기반 견고, 평안 순조' },
  5: { element: '토', blessing: '오행 완전, 중정 평화' },
  6: { element: '금', blessing: '육합 길상, 감정 화순' },
  7: { element: '금', blessing: '칠성 비춤, 지혜 원융' },
  8: { element: '토', blessing: '팔방 재물 모임, 풍성 가득' },
  9: { element: '화', blessing: '구구 귀일, 공덕 원만' },
};

// ─── 幸运数字日文含义 ─────────────────────────────────────────
export const NUMBER_MEANINGS_JA: Record<number, string> = {
  1: '開始とリーダーシップの数字。今日は主体的に行動し、新しい道を切り開きましょう。',
  2: '調和と協力の数字。人間関係を活かし、柔軟に協力して共に勝ちましょう。',
  3: '表現と創造の数字。今日は思考が活発で、創作・コミュニケーション・社交に最適です。',
  4: '堅実と安定の数字。今日は着実に基盤を固め、一歩一歩進みましょう。',
  5: '変化と自由の数字。今日は変化を受け入れ、新しいことに挑戦し、柔軟に対応しましょう。',
  6: '調和と責任の数字。今日は縁が旺盛で、家庭や感情の事柄が順調です。',
  7: '知恵と内省の数字。今日は直感が鋭く、深い思考や研究に最適です。',
  8: '豊かさと権勢の数字。今日は財運と事業エネルギーが集まり、物質的な機会をつかみましょう。',
  9: '円満と大愛の数字。今日は物事を完成させ、経験を整理し、善行を積みましょう。',
};

export const NUMBER_WUXING_JA: Record<number, { element: string; blessing: string }> = {
  1: { element: '水', blessing: '知恵が目覚め、万象が新たになる' },
  2: { element: '土', blessing: '包み込む大地、徳が厚く万物を育む' },
  3: { element: '木', blessing: '生気みなぎり、一歩一歩高みへ' },
  4: { element: '木', blessing: '基盤しっかり、平安で順調な歩み' },
  5: { element: '土', blessing: '五行そろい、中正にして穏やか' },
  6: { element: '金', blessing: '六合めでたく、縁と感情が和やか' },
  7: { element: '金', blessing: '七星が照らし、知恵が円かに融ける' },
  8: { element: '土', blessing: '八方から財が集まり、豊かさ満ちる' },
  9: { element: '火', blessing: '九九帰一、功徳が円満に実る' },
};

// ─── 幸运数字英文含义 ─────────────────────────────────────────
export const NUMBER_MEANINGS_EN: Record<number, string> = {
  1: 'The number of initiation & leadership. Take the lead today, forge new paths and embrace independence.',
  2: 'The number of harmony & cooperation. Leverage relationships, use diplomacy and achieve through partnership.',
  3: 'The number of expression & creativity. Your mind is sharp—ideal for creative work, communication and social engagements.',
  4: 'The number of stability & diligence. Work methodically, lay solid groundwork and focus on building foundations.',
  5: 'The number of change & freedom. Embrace new experiences, stay flexible and adapt to shifting circumstances.',
  6: 'The number of harmony & responsibility. Relationships flourish, family bonds strengthen and kindness brings rewards.',
  7: 'The number of wisdom & introspection. Your intuition is keen—great for deep thinking, research and spiritual practice.',
  8: 'The number of abundance & power. Wealth and career energies converge—seize material opportunities with confidence.',
  9: 'The number of completion & compassion. Wrap up matters, reflect on lessons learned and cultivate generosity.',
};

export const NUMBER_WUXING_EN: Record<number, { element: string; blessing: string }> = {
  1: { element: 'Water', blessing: 'Wisdom awakens, all things renew' },
  2: { element: 'Earth', blessing: 'Embrace all, carry virtue' },
  3: { element: 'Wood', blessing: 'Vitality surges, step by step higher' },
  4: { element: 'Wood', blessing: 'Foundation solid, safe and smooth' },
  5: { element: 'Earth', blessing: 'Five elements balanced, centered and harmonious' },
  6: { element: 'Metal', blessing: 'Six harmonies auspicious, relationships prosper' },
  7: { element: 'Metal', blessing: 'Seven stars aligned, wisdom complete' },
  8: { element: 'Earth', blessing: 'Wealth gathers from all directions' },
  9: { element: 'Fire', blessing: 'All cycles fulfilled, virtue accomplished' },
};

// ─── 食物英文名 ───────────────────────────────────────────────
export const FOOD_EN: Record<string, { name: string; effect: string }> = {
  '菠菜': { name: 'Spinach', effect: 'Nourishes the liver, restores Wood energy and sharpens vision' },
  '韭菜': { name: 'Chinese Chives', effect: 'Warms Yang energy, boosts vitality and strengthens drive' },
  '青椒': { name: 'Green Pepper', effect: 'Amplifies Wood energy, uplifts spirits and supports ambition' },
  '芹菜': { name: 'Celery', effect: 'Clears liver heat, promotes balance and steadies emotions' },
  '柠檬': { name: 'Lemon', effect: 'Sour taste nourishes the liver, enriches Wood energy and heightens perception' },
  '西蓝花': { name: 'Broccoli', effect: 'Protects liver and gallbladder, boosts immunity and invigorates energy' },
  '豆苗': { name: 'Pea Shoots', effect: 'Young Wood sprouting, catalyzes new beginnings and fresh starts' },
  '红枣': { name: 'Red Dates', effect: 'Nourishes heart energy, warms blood vessels and invites good fortune' },
  '枸杞': { name: 'Wolfberries', effect: 'Balances Yin and Fire, boosts vitality and enhances romantic luck' },
  '荔枝': { name: 'Lychee', effect: 'Abundant Fire energy, sweet taste lifts heart and brings joy' },
  '番茄': { name: 'Tomato', effect: 'Nourishes energy and blood, purifies the body and clears negative fields' },
  '苦瓜': { name: 'Bitter Melon', effect: 'Clears heart-fire, prevents excessive Fire energy and maintains balance' },
  '红豆': { name: 'Red Beans', effect: 'Warms heart and stomach, promotes circulation and attracts wealth' },
  '樱桃': { name: 'Cherries', effect: 'Nourishes blood, enhances romance luck and helps relationships flourish' },
  '南瓜': { name: 'Pumpkin', effect: 'Rich in Earth energy, stabilizes foundations and accumulates wealth' },
  '山药': { name: 'Chinese Yam', effect: 'Strengthens spleen and stomach, fortifies Earth element and increases stability' },
  '小米': { name: 'Millet', effect: 'Warms the middle burner, supplements Earth energy and steadies finances' },
  '红薯': { name: 'Sweet Potato', effect: 'Sweet Earth energy, thickens fortune and aligns with Earth power' },
  '蜂蜜': { name: 'Honey', effect: 'Sweet and nourishing, uplifts body and mind and invites sweet luck' },
  '玉米': { name: 'Corn', effect: 'Grain of grains, peak Earth energy, helps gather wealth and noble connections' },
  '姜': { name: 'Ginger', effect: 'Warms the middle and dispels cold, activates Earth energy and clears obstacles' },
  '白萝卜': { name: 'White Radish', effect: 'Metal energy clears lungs, regulates Qi and enhances decisiveness' },
  '银耳': { name: 'Silver Ear Fungus', effect: 'Silver-white like Metal, nourishes skin and brings noble connections' },
  '百合': { name: 'Lily Bulb', effect: 'Clears lungs and calms heart, pure Metal energy and emotional stability' },
  '梨子': { name: 'Pear', effect: 'Moistens lungs and clears dryness, Metal energy flows and dissolves obstacles' },
  '豆腐': { name: 'Tofu', effect: 'White color supplements Metal, light and nourishing and purifies energy' },
  '莲藕': { name: 'Lotus Root', effect: 'Seven holes aligned, Metal energy gathered, aids wealth and wisdom' },
  '杏仁': { name: 'Almonds', effect: 'Supports lung function, supplements Metal energy and boosts action' },
  '黑芝麻': { name: 'Black Sesame', effect: 'Nourishes kidneys and essence, Water energy abundant and opens wisdom' },
  '黑豆': { name: 'Black Beans', effect: 'Enters kidney and supplements Water, activates blood and enhances magnetic field' },
  '核桃': { name: 'Walnuts', effect: 'Nourishes kidney and brain, Water energy rich and sharpens strategy' },
  '桑葚': { name: 'Mulberries', effect: 'Nourishes Yin and blood, Water energy moistens and aids romance and wealth' },
  '板栗': { name: 'Chestnuts', effect: 'Strengthens kidneys, Water and Earth balance and stabilizes foundations' },
  '海带': { name: 'Kelp', effect: 'From the sea, maximum Water energy, helps wisdom flow freely' },
  '葡萄': { name: 'Grapes', effect: 'Juice abundant, Water energy nourishes, helps fortune flow smoothly' },
  '葡萄干': { name: 'Raisins', effect: 'Concentrated Water energy, sweet and nourishing, invites good luck' },
};

// ─── 颜色英文名 ───────────────────────────────────────────────
export const COLOR_EN: Record<string, string> = {
  '竹翠青': 'Bamboo Green', '翡翠绿': 'Jade Green', '碧荷绿': 'Lotus Green',
  '苍松绿': 'Pine Green', '嫩芽绿': 'Sprout Green', '梅雨青': 'Plum Rain Teal',
  '青瓷绿': 'Celadon Green', '松花绿': 'Pine Flower Green',
  '朱砂红': 'Vermilion Red', '胭脂红': 'Rouge Red', '珊瑚红': 'Coral Red',
  '玫瑰紫': 'Rose Purple', '绯红色': 'Crimson', '茜草红': 'Madder Red',
  '石榴红': 'Pomegranate Red', '绛紫红': 'Claret',
  '琥珀黄': 'Amber Yellow', '杏仁黄': 'Almond Yellow', '藤黄色': 'Vine Yellow',
  '暖姜黄': 'Warm Ginger', '土地棕': 'Earth Brown', '米金色': 'Rice Gold',
  '蜂蜜黄': 'Honey Yellow', '沙漠金': 'Desert Gold',
  '月白色': 'Moon White', '象牙白': 'Ivory White', '流金色': 'Liquid Gold',
  '霜银色': 'Frost Silver', '香槟金': 'Champagne Gold', '铂金白': 'Platinum White',
  '银杏黄': 'Ginkgo Yellow', '珍珠白': 'Pearl White',
  '深海蓝': 'Deep Sea Blue', '天青蓝': 'Azure Blue', '靛蓝色': 'Indigo',
  '碧空蓝': 'Sky Blue', '藏青色': 'Navy Blue', '暮霭蓝': 'Dusk Blue',
  '宝石蓝': 'Sapphire Blue', '冰蓝色': 'Ice Blue',
};

// ─── 颜色韩文名 ───────────────────────────────────────────────
export const COLOR_KO: Record<string, string> = {
  '竹翠青': '대나무 초록', '翡翠绿': '비취 초록', '碧荷绿': '연꽃 초록',
  '苍松绿': '소나무 초록', '嫩芽绿': '새싹 초록', '梅雨青': '매화비 청록',
  '青瓷绿': '청자 초록', '松花绿': '솔꽃 초록',
  '朱砂红': '주사 빨강', '胭脂红': '연지 빨강', '珊瑚红': '산호 빨강',
  '玫瑰紫': '장미 보라', '绯红色': '진홍색', '茜草红': '꼭두서니 빨강',
  '石榴红': '석류 빨강', '绛紫红': '자주 빨강',
  '琥珀黄': '호박 노랑', '杏仁黄': '아몬드 노랑', '藤黄色': '등황색',
  '暖姜黄': '따뜻한 생강 노랑', '土地棕': '대지 갈색', '米金色': '쌀 금색',
  '蜂蜜黄': '꿀 노랑', '沙漠金': '사막 금색',
  '月白色': '달빛 흰색', '象牙白': '상아 흰색', '流金色': '유금색',
  '霜银色': '서리 은색', '香槟金': '샴페인 금색', '铂金白': '백금 흰색',
  '银杏黄': '은행 노랑', '珍珠白': '진주 흰색',
  '深海蓝': '심해 파랑', '天青蓝': '하늘 파랑', '靛蓝色': '남색',
  '碧空蓝': '맑은 하늘 파랑', '藏青色': '남청색', '暮霭蓝': '황혼 파랑',
  '宝石蓝': '사파이어 파랑', '冰蓝色': '얼음 파랑',
};

// ─── 颜色日文名 ───────────────────────────────────────────────
export const COLOR_JA: Record<string, string> = {
  '竹翠青': '竹翠青', '翡翠绿': '翡翠グリーン', '碧荷绿': '蓮グリーン',
  '苍松绿': '松グリーン', '嫩芽绿': '新芽グリーン', '梅雨青': '梅雨青',
  '青瓷绿': '青磁グリーン', '松花绿': '松花グリーン',
  '朱砂红': '朱砂レッド', '胭脂红': '臙脂レッド', '珊瑚红': 'コーラルレッド',
  '玫瑰紫': 'ローズパープル', '绯红色': '緋紅色', '茜草红': '茜レッド',
  '石榴红': 'ザクロレッド', '绛紫红': '深紫レッド',
  '琥珀黄': '琥珀イエロー', '杏仁黄': 'アーモンドイエロー', '藤黄色': '藤黄色',
  '暖姜黄': '温かいジンジャーイエロー', '土地棕': '大地ブラウン', '米金色': '米ゴールド',
  '蜂蜜黄': 'ハニーイエロー', '沙漠金': 'デザートゴールド',
  '月白色': '月白色', '象牙白': 'アイボリーホワイト', '流金色': '流金色',
  '霜银色': '霜シルバー', '香槟金': 'シャンパンゴールド', '铂金白': 'プラチナホワイト',
  '银杏黄': 'イチョウイエロー', '珍珠白': 'パールホワイト',
  '深海蓝': '深海ブルー', '天青蓝': '天青ブルー', '靛蓝色': 'インディゴ',
  '碧空蓝': '碧空ブルー', '藏青色': 'ネイビーブルー', '暮霭蓝': '夕霞ブルー',
  '宝石蓝': 'サファイアブルー', '冰蓝色': 'アイスブルー',
};

// ─── 风格英文 ─────────────────────────────────────────────────
export const STYLE_EN: Record<string, string> = {
  '自然清新风': 'Natural & Fresh Style',
  '大胆表达风': 'Bold Expression Style',
  '经典优雅风': 'Classic & Elegant Style',
  '极简高级风': 'Minimalist Luxury Style',
  '流动柔美风': 'Fluid & Soft Style',
};

// ─── 风格韩文 ─────────────────────────────────────────────────
export const STYLE_KO: Record<string, string> = {
  '自然清新风': '자연 청신 스타일',
  '大胆表达风': '대담한 표현 스타일',
  '经典优雅风': '클래식 우아 스타일',
  '极简高级风': '미니멀 럭셔리 스타일',
  '流动柔美风': '유동적 부드러운 스타일',
};

// ─── 风格日文 ─────────────────────────────────────────────────
export const STYLE_JA: Record<string, string> = {
  '自然清新风': 'ナチュラル＆フレッシュスタイル',
  '大胆表达风': 'ボールドエクスプレッションスタイル',
  '经典优雅风': 'クラシック＆エレガントスタイル',
  '极简高级风': 'ミニマリストラグジュアリースタイル',
  '流动柔美风': 'フルイド＆ソフトスタイル',
};

// ─── 吉凶宜忌辅助（auspicious / neutral / inauspicious 英文标签）─
export const AUSPICIOUS_EN: Record<string, string> = {
  '吉': 'Auspicious', '平': 'Neutral', '凶': 'Inauspicious',
  '吉宿': 'Lucky Mansion', '平宿': 'Neutral Mansion',
};

// ─── 星象吉星/凶星标签英文 ───────────────────────────────────
export const STAR_EN: Record<string, string> = {
  '天德贵人': 'Heavenly Virtue', '月德贵人': 'Monthly Virtue', '岁合吉星': 'Year Harmony',
  '三合吉星': 'Triple Harmony', '天喜星': 'Celestial Joy', '生气星': 'Life Energy',
  '天恩星': 'Heavenly Grace', '六合吉神': 'Six Harmonies', '玉堂吉神': 'Jade Hall',
  '明堂吉神': 'Bright Hall', '金匮吉神': 'Golden Chest', '天医星': 'Celestial Healer',
  '天德合': 'Heavenly Virtue Union', '岁德星': 'Year Virtue', '续世星': 'Continuation',
  '福德星': 'Fortune & Virtue', '天贵星': 'Celestial Noble', '天仓星': 'Heavenly Granary',
  '天润星': 'Celestial Nourishment', '天解星': 'Celestial Resolution',
  '月德': 'Monthly Virtue', '六合': 'Six Harmonies',
  '月刑': 'Monthly Penalty', '天刑': 'Celestial Penalty', '大耗': 'Great Loss',
  '小耗': 'Minor Loss', '破碎星': 'Shattered Star', '白虎': 'White Tiger',
  '天狗': 'Celestial Dog', '天罗': 'Celestial Net', 
  '牛宿煞': 'Ox Mansion Sha', '亢宿煞': 'Neck Mansion Sha', '心宿煞': 'Heart Mansion Sha',
  '女宿忌': 'Girl Mansion Taboo', '虚宿煞': 'Void Mansion Sha', '哭虚': 'Weeping Void',
  '危宿煞': 'Rooftop Mansion Sha', '破败': 'Decay Star', '奎宿煞': 'Legs Mansion Sha',
  '地火': 'Earth Fire', '灾煞': 'Disaster Sha', '觜宿煞': 'Beak Mansion Sha',
  '月破': 'Monthly Break', '星宿煞': 'Star Mansion Sha', '翼宿煞': 'Wings Mansion Sha',
  '土府': 'Earth Office', '柳宿煞': 'Willow Mansion Sha', '鬼宿煞': 'Ghost Mansion Sha',
  '昴宿煞': 'Pleiades Mansion Sha',
};

// ─── 吉凶星描述英文 ──────────────────────────────────────────
export const STAR_DESC_EN: Record<string, string> = {
  '天德贵人': 'Celestial Virtue shines—all obstacles dissolve, noble helpers appear and journeys are blessed.',
  '月德贵人': 'Monthly Virtue illuminates—relationships harmonize, family prospers and finances advance steadily.',
  '岁合吉星': 'Year Harmony prevails—perfect timing for contracts, alliances and collaborative wins.',
  '三合吉星': 'Triple Harmony converges—triple support for all endeavors; great matters can be accomplished.',
  '天喜星': 'Celestial Joy descends—happy events multiply; auspicious for weddings and celebrations.',
  '生气星': 'Life Energy surges—vitality flourishes; ideal for groundbreaking and welcoming new life.',
  '天恩星': 'Heavenly Grace spreads—forgiveness and goodwill prevail; excellent for hosting and acts of kindness.',
  '六合吉神': 'Six Harmonies gather—all affairs flow smoothly, human relations are harmonious.',
  '玉堂吉神': 'Jade Hall opens—wealth and nobility arrive; auspicious for property acquisition.',
  '明堂吉神': 'Bright Hall shines—noble energy flows; favorable for career advancement.',
  '金匮吉神': 'Golden Chest opens—wealth streams in; excellent for investment and financial planning.',
  '天医星': 'Celestial Healer presides—medical consultations are effective and healing is enhanced.',
  '天刑': 'Celestial Penalty active—risk of legal issues increases; stay low-key and avoid disputes.',
  '大耗': 'Great Loss star present—guard finances carefully; avoid large investments and impulsive spending.',
  '白虎': 'White Tiger looms—risk of accidents increases; exercise extra caution while traveling.',
  '天狗': 'Celestial Dog watches—guard against unexpected injuries; be alert on journeys.',
  '月破': 'Monthly Break prevails—many obstacles today; stay still, conserve strength and wait for better times.',
  '牛宿煞': 'Ox Mansion Sha present—watch family health carefully; be alert to recurring ailments.',
  '亢宿煞': 'Neck Mansion Sha active—exercise caution in all matters, especially health and accidents.',
  '心宿煞': 'Heart Mansion Sha present—guard against emotional impulsiveness and financial depletion.',
  '女宿忌': 'Girl Mansion Taboo—avoid forcing important decisions; harmony is the priority.',
  '虚宿煞': 'Void Mansion Sha present—emotions may run low; meditate and avoid celebrations.',
  '哭虚': 'Weeping Void active—emotional sensitivity is high; maintain a stable mindset.',
  '危宿煞': 'Rooftop Mansion Sha—avoid high-risk activities; stay conservative and settled.',
  '破败': 'Decay Star present—guard against setbacks; consolidate rather than expand.',
  '奎宿煞': 'Legs Mansion Sha—beware fire hazards; keep emotions calm and steady.',
  '地火': 'Earth Fire flickers—take extra care with fire and electrical safety today.',
  '灾煞': 'Disaster Sha present—keep a low profile; avoid recklessness and watch for disputes.',
  '觜宿煞': 'Beak Mansion Sha—watch for gossip and disputes; speak carefully today.',
  '星宿煞': 'Star Mansion Sha—many obstacles today; stay still and conserve energy.',
  '翼宿煞': 'Wings Mansion Sha—be cautious in all matters; avoid entanglements while traveling.',
  '土府': 'Earth Office weighs down—avoid ground breaking; focus on backlogged matters.',
  '柳宿煞': 'Willow Mansion Sha—pay attention to digestion; eat lightly and avoid excess.',
  '鬼宿煞': 'Ghost Mansion Sha—worship and maintain cleanliness; keep the home tidy.',
  '昴宿煞': 'Pleiades Mansion Sha—guard against sudden injuries; drive with extra care today.',
};

// ─── 建除十二神韩文 ──────────────────────────────────────────
export const JIANCHU_KO: Record<string, { name: string; desc: string }> = {
  '建': { name: '건(建)', desc: '건일은 생기가 왕성하여 만물이 싹트는 날입니다. 출행과 새로운 시작에 길하며 적극적으로 행동하면 좋습니다.' },
  '除': { name: '제(除)', desc: '제일은 묵은 것을 제거하고 새것을 맞이하는 날입니다. 청소와 정리, 분쟁 해결에 적합합니다.' },
  '满': { name: '만(滿)', desc: '만일은 백사가 원만하고 재기가 넘치는 날입니다. 혼례와 경사에 길하며 큰일이 순조롭습니다.' },
  '平': { name: '평(平)', desc: '평일은 평화롭고 안정적인 날입니다. 일상 업무를 처리하기에 적합하며 서두르지 않고 착실히 나아가세요.' },
  '定': { name: '정(定)', desc: '정일은 안정되고 견고한 날입니다. 계약 체결과 혼인 감정사에 길하며 정착에 유리합니다.' },
  '执': { name: '집(執)', desc: '집일은 계획을 실행하고 추진하는 날입니다. 기존 방안을 집행하는 데 길하며 급격한 변화는 피하세요.' },
  '破': { name: '파(破)', desc: '파일은 모든 일에 장애가 많은 날입니다. 조용히 지내는 것이 좋으며 중요한 일을 강행하지 마세요.' },
  '危': { name: '위(危)', desc: '위일은 신중하고 보수적으로 지내야 하는 날입니다. 위험한 활동을 피하고 안정을 유지하세요.' },
  '成': { name: '성(成)', desc: '성일은 대길대리한 날로 모든 일이 성취됩니다. 혼례와 개업 등 경사에 모두 길합니다.' },
  '收': { name: '수(收)', desc: '수일은 수납하고 축적하는 날입니다. 저축과 재물 관리에 적합하며 적극적인 출격보다 수성이 좋습니다.' },
  '开': { name: '개(開)', desc: '개일은 개문대길한 날로 만사를 시작하기에 좋습니다. 개업, 출행, 교제 모두 길합니다.' },
  '闭': { name: '폐(閉)', desc: '폐일은 모든 문이 닫히는 날입니다. 조용히 축적하는 것이 좋으며 움직임보다 정적이 길합니다.' },
};

// ─── 建除十二神日文 ──────────────────────────────────────────
export const JIANCHU_JA: Record<string, { name: string; desc: string }> = {
  '建': { name: '建（けん）', desc: '建日は生気旺盛で万物が芽吹く日です。出行や新しい始まりに吉で、積極的に行動するとよいでしょう。' },
  '除': { name: '除（じょ）', desc: '除日は古いものを取り除き新しいものを迎える日です。清掃・整理・紛争解決に適しています。' },
  '满': { name: '満（まん）', desc: '満日は百事円満で財気が溢れる日です。婚礼や慶事に吉で、大事が順調に進みます。' },
  '平': { name: '平（へい）', desc: '平日は穏やかで安定した日です。日常業務の処理に適しており、焦らず着実に進みましょう。' },
  '定': { name: '定（てい）', desc: '定日は安定・堅固な日です。契約締結や婚姻・感情事に吉で、定着に有利です。' },
  '执': { name: '執（しつ）', desc: '執日は計画を実行・推進する日です。既定の方案を執行するのに吉で、急激な変化は避けましょう。' },
  '破': { name: '破（は）', desc: '破日は万事に障害が多い日です。静かに過ごすのがよく、重要なことを強行しないでください。' },
  '危': { name: '危（き）', desc: '危日は慎重・保守的に過ごすべき日です。危険な活動を避け、安定を保ちましょう。' },
  '成': { name: '成（せい）', desc: '成日は大吉大利な日で万事が成就します。婚礼・開業など慶事はすべて吉です。' },
  '收': { name: '収（しゅう）', desc: '収日は収納・蓄積する日です。貯蓄や財務管理に適しており、積極的な出撃より守成が吉です。' },
  '开': { name: '開（かい）', desc: '開日は開門大吉の日で万事を始めるのに最適です。開業・出行・交際はすべて吉です。' },
  '闭': { name: '閉（へい）', desc: '閉日はすべての門が閉じる日です。静かに蓄積するのがよく、動より静が吉です。' },
};

// ─── 宜忌事项韩文翻译 ─────────────────────────────────────────
export const YI_JI_KO: Record<string, string> = {
  '出行远游': '여행·원정', '开市营业': '개업·영업', '祭祀祈福': '제사·기도',
  '动土破地': '착공·기공', '上梁安门': '상량·문 설치', '求职应聘': '구직·취업',
  '成婚嫁娶': '혼례', '签约缔盟': '계약 체결', '搬家迁居': '이사',
  '清扫整理': '청소·정리', '解除纠纷': '분쟁 해결', '去旧换新': '새것으로 교체',
  '求医问诊': '진료·상담', '沐浴洁净': '목욕·정화', '学习进修': '학습·연수',
  '婚嫁典礼': '혼례식', '开业庆典': '개업식', '置办财货': '재물 거래',
  '宴客待友': '손님 접대', '升迁职位': '승진', '立契签约': '계약 체결',
  '日常事务': '일상 업무', '休养生息': '휴양', '整理文书': '서류 정리',
  '朋友聚会': '친구 모임', '家居整顿': '집 정리', '签约立约': '계약 체결',
  '婚嫁感情': '혼인·연애', '安葬仪式': '장례', '置产购房': '부동산 구매',
  '商议谈判': '협상', '收成入库': '수확 저장', '执行计划': '계획 실행',
  '追债讨债': '채권 회수', '捕猎渔猎': '사냥·낚시', '立约执行': '계약 이행',
  '除虫杀草': '해충 제거', '医治疗养': '치료·요양', '排泄宿便': '해독',
  '清理废物': '폐기물 처리', '破旧立新': '구습 타파', '整理杂乱': '정돈',
  '打捞修葺': '수리', '治理旧伤': '묵은 상처 치료', '收购置产': '자산 취득',
  '储蓄理财': '저축·재테크', '收债还款': '채무 상환', '家居储藏': '가정 저장',
  '整理仓库': '창고 정리', '开市开业': '개업', '婚嫁喜事': '혼례',
  '出行交际': '사교 여행', '求职求学': '취업·진학', 
    
   '休息养生': '휴식·건강 관리', '种植耕耘': '농사·재배',
  '文书写作': '문서 작성', '社交拓展': '인맥 확장', '公开演讲': '공개 연설',
  '文艺创作': '예술 창작', '仪式庆典': '의식·경전', '投资置产': '투자',
  '建筑营造': '건축', '踏实积累': '착실한 축적', '稳健理财': '안정적 재테크',
  '收款还债': '수금·채무 상환', '决策斩断': '결단', '运动健身': '운동·건강',
  '旅行出游': '여행', '洽谈沟通': '비즈니스 소통', '泡澡泡脚': '목욕·족욕',
  '冲动消费': '충동 소비', '争吵口角': '다툼·말다툼', '借贷投资': '대출·위험 투자',
  '熬夜劳累': '야근·과로', '诉讼争讼': '소송', '拆屋破宅': '철거',
  '大手术': '대수술', '婚嫁宴席': '혼례 연회', '动土兴工': '대규모 공사',
  '大额投资': '대규모 투자', '签订合同': '계약 체결', '入宅迁居': '입주·이사',
  '服药就医': '투약·진료', '穿井挖沟': '우물 파기·도랑 파기', '葬仪丧事': '장례',
  '借钱告贷': '차용', '冒险投机': '투기', '大额交易': '대규모 거래',
  '动用刀斧': '날카로운 도구 사용', '争讼诉讼': '법적 분쟁', '高空作业': '고공 작업',
  '远行征途': '장거리 여행', '攀高涉险': '등반·위험 활동', '开山动土': '굴착',
  '乘船渡水': '선박 이용', '破旧事物': '구물 파괴', '债务谈判': '채무 협상',
  '嫁娶婚事': '혼례', '疏通水道': '수로 공사', '破土挖掘': '굴착',
  '宴请宾客': '연회', '频繁变动': '잦은 변동', '大规模拆建': '대규모 철거·건설',
  '无度挥霍': '낭비', '挖土穿井': '굴착·우물 파기', '钝刀作业': '둔기 작업',
  '优柔寡断': '우유부단', '金属冒险': '금속 관련 위험', '大量饮酒': '과음',
  '改变既定计划': '기존 계획 변경', '借贷担保': '대출·보증', '出行争讼': '외출·분쟁',
  '谈判争议': '협상·분쟁', '借贷抵押': '대출·담보', '远行出门': '장거리 외출',
  '高风险投资': '고위험 투자', '大兴土木': '대규모 공사', '攀高走险': '위험한 등반',
  '高调扬名': '고조 홍보', '家居搬迁': '이사', '婚嫁嫁娶': '혼례·결혼',
  '签约立契': '계약 체결', '动土兴建': '착공·건설', '居家修缮': '집 수리',
  '安居整理': '집 정리', '日常理财': '일상 재테크', '祭祀拜神': '제사·기도',
  '诵经积德': '독경·덕 쌓기', '破土动工': '착공', '求职谋事': '구직',
  '开业动土': '개업·착공', '高风险冒险': '고위험 모험', '手术医疗': '수술·의료',
  '筑坝堤坝': '제방 공사', '填土封穴': '토목 공사', '守身修性': '자기 수양',
  '储藏财物': '재물 저장', '诵经冥想': '명상·독경', '开市出行': '개업·외출',
  '大型宴席': '대형 연회', '破宅拆屋': '철거', '手术诊疗': '수술·치료',
  '情绪失控': '감정 폭발', '深水涉险': '수중 위험', '肾脏消耗': '신장 과부하',
  '伐木砍树': '벌목', '过度节制': '과도한 절제', '压制创意': '창의력 억압',
  '限制自由': '자유 제한', '冷水激身': '냉수 자극', '暗室独处': '어두운 곳 고립',
  '压抑情感': '감정 억압', '寒凉饮食': '차가운 음식',
};

// ─── 宜忌事项日文翻译 ─────────────────────────────────────────
export const YI_JI_JA: Record<string, string> = {
  '出行远游': '旅行・遠出', '开市营业': '開業・営業', '祭祀祈福': '祭祀・祈願',
  '动土破地': '着工・地鎮', '上梁安门': '棟上げ・扉設置', '求职应聘': '就職活動',
  '成婚嫁娶': '婚礼', '签约缔盟': '契約締結', '搬家迁居': '引越し',
  '清扫整理': '清掃・整理', '解除纠纷': '紛争解決', '去旧换新': '新旧交替',
  '求医问诊': '受診・相談', '沐浴洁净': '入浴・浄化', '学习进修': '学習・研修',
  '婚嫁典礼': '婚礼式', '开业庆典': '開業式', '置办财货': '財物取引',
  '宴客待友': '接客・おもてなし', '升迁职位': '昇進', '立契签约': '契約締結',
  '日常事务': '日常業務', '休养生息': '休養', '整理文书': '書類整理',
  '朋友聚会': '友人の集まり', '家居整顿': '家の整理', '签约立约': '契約締結',
  '婚嫁感情': '婚姻・恋愛', '安葬仪式': '葬儀', '置产购房': '不動産購入',
  '商议谈判': '交渉', '收成入库': '収穫保管', '执行计划': '計画実行',
  '追债讨债': '債権回収', '捕猎渔猎': '狩猟・釣り', '立约执行': '契約履行',
  '除虫杀草': '害虫駆除', '医治疗养': '治療・療養', '排泄宿便': 'デトックス',
  '清理废物': '廃棄物処理', '破旧立新': '旧習打破', '整理杂乱': '片付け',
  '打捞修葺': '修繕', '治理旧伤': '古傷の治療', '收购置产': '資産取得',
  '储蓄理财': '貯蓄・資産運用', '收债还款': '債務返済', '家居储藏': '家庭保管',
  '整理仓库': '倉庫整理', '开市开业': '開業', '婚嫁喜事': '婚礼',
  '出行交际': '社交旅行', '求职求学': '就職・進学', 
    
   '休息养生': '休息・健康管理', '种植耕耘': '農業・栽培',
  '文书写作': '文書作成', '社交拓展': '人脈拡大', '公开演讲': '公開スピーチ',
  '文艺创作': '芸術創作', '仪式庆典': '儀式・慶典', '投资置产': '投資',
  '建筑营造': '建築', '踏实积累': '着実な積み重ね', '稳健理财': '堅実な資産運用',
  '收款还债': '集金・返済', '决策斩断': '決断', '运动健身': '運動・健康',
  '旅行出游': '旅行', '洽谈沟通': 'ビジネス交渉', '泡澡泡脚': '入浴・足湯',
  '冲动消费': '衝動買い', '争吵口角': '口論・喧嘩', '借贷投资': '借入・危険投資',
  '熬夜劳累': '夜更かし・過労', '诉讼争讼': '訴訟', '拆屋破宅': '解体',
  '大手术': '大手術', '婚嫁宴席': '婚礼宴会', '动土兴工': '大規模工事',
  '大额投资': '大規模投資', '签订合同': '契約締結', '入宅迁居': '入居・引越し',
  '服药就医': '服薬・受診', '穿井挖沟': '井戸掘り・溝掘り', '葬仪丧事': '葬儀',
  '借钱告贷': '借金', '冒险投机': '投機', '大额交易': '大規模取引',
  '动用刀斧': '刃物使用', '争讼诉讼': '法的紛争', '高空作业': '高所作業',
  '远行征途': '長距離旅行', '攀高涉险': '登山・危険活動', '开山动土': '掘削',
  '乘船渡水': '船舶利用', '破旧事物': '旧物破壊', '债务谈判': '債務交渉',
  '嫁娶婚事': '婚礼', '疏通水道': '水路工事', '破土挖掘': '掘削',
  '远行出游': '遠出・旅行', '宴请宾客': '宴会', '频繁变动': '頻繁な変動', '大规模拆建': '大規模解体・建設',
  '无度挥霍': '浪費', '挖土穿井': '掘削・井戸掘り', '钝刀作业': '鈍器作業',
  '优柔寡断': '優柔不断', '金属冒险': '金属関連リスク', '大量饮酒': '過飲',
  '改变既定计划': '既定計画の変更', '借贷担保': 'ローン・保証', '出行争讼': '外出・争訟',
  '谈判争议': '交渉・紛争', '借贷抵押': 'ローン・担保', '远行出门': '長距離外出',
  '高风险投资': '高リスク投資', '大兴土木': '大規模工事', '攀高走险': '危険な登山',
  '高调扬名': '高調宣伝', '家居搬迁': '引越し', '婚嫁嫁娶': '婚礼・結婚',
  '签约立契': '契約締結', '动土兴建': '着工・建設', '居家修缮': '家の修繕',
  '安居整理': '家の整理', '日常理财': '日常の資産運用', '祭祀拜神': '祭祀・祈願',
  '诵经积德': '読経・徳積み', '破土动工': '着工', '求职谋事': '就職活動',
  '开业动土': '開業・着工', '高风险冒险': '高リスク冒険', '手术医疗': '手術・医療',
  '筑坝堤坝': '堤防工事', '填土封穴': '土木工事', '守身修性': '自己修養',
  '储藏财物': '財物保管', '诵经冥想': '瞑想・読経', '开市出行': '開業・外出',
  '大型宴席': '大型宴会', '破宅拆屋': '解体', '手术诊疗': '手術・治療',
  '情绪失控': '感情爆発', '深水涉险': '水中危険', '肾脏消耗': '腎臓過負荷',
  '伐木砍树': '伐採', '过度节制': '過度な節制', '压制创意': '創意抑圧',
  '限制自由': '自由制限', '冷水激身': '冷水刺激', '暗室独处': '暗室孤立',
  '压抑情感': '感情抑圧', '寒凉饮食': '冷たい食事',
};

export function translateYiJiKo(item: string): string {
  return YI_JI_KO[item] ?? YI_JI_EN[item] ?? item;
}

export function translateYiJiJa(item: string): string {
  return YI_JI_JA[item] ?? YI_JI_EN[item] ?? item;
}

// ─── 方位韩文 ─────────────────────────────────────────────────
export const DIRECTION_KO: Record<string, { name: string; short: string }> = {
  '东南方': { name: '동남쪽', short: '동남' },
  '正东方': { name: '정동쪽', short: '정동' },
  '正南方': { name: '정남쪽', short: '정남' },
  '东北方': { name: '동북쪽', short: '동북' },
  '正西方': { name: '정서쪽', short: '정서' },
  '西北方': { name: '서북쪽', short: '서북' },
  '正北方': { name: '정북쪽', short: '정북' },
  '西南方': { name: '서남쪽', short: '서남' },
};

// ─── 方位日文 ─────────────────────────────────────────────────
export const DIRECTION_JA: Record<string, { name: string; short: string }> = {
  '东南方': { name: '東南方', short: '東南' },
  '正东方': { name: '正東方', short: '正東' },
  '正南方': { name: '正南方', short: '正南' },
  '东北方': { name: '東北方', short: '東北' },
  '正西方': { name: '正西方', short: '正西' },
  '西北方': { name: '西北方', short: '西北' },
  '正北方': { name: '正北方', short: '正北' },
  '西南方': { name: '西南方', short: '西南' },
};

// ─── 方位描述韩문 ─────────────────────────────────────────────
export const DIRECTION_DESC_KO: Record<string, { wealth: string; peach: string }> = {
  '동남쪽': {
    wealth: '오늘 재신이 동남쪽에 자리합니다. 이 방향을 향해 업무나 협상을 하면 재물 에너지를 끌어당기는 데 도움이 됩니다.',
    peach: '오늘 연애와 귀인 인연이 동남쪽에 있습니다. 이 방향으로 사교 활동을 하면 매력과 인간관계가 향상됩니다.',
  },
  '정동쪽': {
    wealth: '오늘 재성이 동쪽에 있습니다. 동쪽을 향해 업무나 협상을 하면 재물 에너지를 모을 수 있습니다.',
    peach: '오늘 도화 행운이 동쪽에 있습니다. 이 방향의 사교 활동이 매력과 연애 기회를 높입니다.',
  },
  '정남쪽': {
    wealth: '오늘 남쪽이 명예와 재물을 가져옵니다. 남쪽을 향하면 사회적 가시성과 재물 기회가 높아집니다.',
    peach: '오늘 남쪽에 연애 에너지가 있습니다. 이 방향의 사교 활동이 인간관계와 귀인을 끌어당깁니다.',
  },
  '동북쪽': {
    wealth: '오늘 동북쪽의 안정적인 토기가 신뢰할 수 있는 재물 축적을 가져옵니다. 부동산과 안정적인 재무 활동에 이상적입니다.',
    peach: '오늘 귀인 인연이 동북쪽에 있습니다. 이 방향으로 이동하거나 만남을 가지면 도움과 지원을 받을 수 있습니다.',
  },
  '정서쪽': {
    wealth: '오늘 서쪽의 금기가 결단력과 재물 이득을 가져옵니다. 협상, 계약, 수금에 최적입니다.',
    peach: '오늘 귀인이 서쪽에 있습니다. 서쪽으로 연락하면 권위 있는 인물과 귀중한 동맹을 만날 수 있습니다.',
  },
  '서북쪽': {
    wealth: '오늘 서북쪽의 금기 권위 에너지가 권력과 인맥을 통해 재물을 끌어당깁니다.',
    peach: '오늘 권위 있는 귀인이 서북쪽에 있습니다. 이 방향이 영향력 있는 지원의 문을 열어줍니다.',
  },
  '정북쪽': {
    wealth: '오늘 북쪽의 수기가 영리하고 유동적인 재물을 가져옵니다. 투기적 통찰과 창의적 재무 전략에 이상적입니다.',
    peach: '오늘 연애 행운이 북쪽에서 흐릅니다. 북쪽으로 이동하면 직관과 감정적 연결이 향상됩니다.',
  },
  '서남쪽': {
    wealth: '오늘 서남쪽의 안정적인 토기가 천천히 하지만 확실하게 재물을 축적합니다.',
    peach: '오늘 서남쪽의 도화 에너지가 따뜻함, 가정 화목, 연애 만남을 가져옵니다.',
  },
};

// ─── 方位描述日文 ─────────────────────────────────────────────
export const DIRECTION_DESC_JA: Record<string, { wealth: string; peach: string }> = {
  '東南方': {
    wealth: '今日の財神は東南方に鎮座します。この方向を向いて業務や交渉を行うと財運エネルギーを引き寄せるのに役立ちます。',
    peach: '今日の恋愛・貴人縁は東南方にあります。この方向での社交活動が魅力と人間関係を高めます。',
  },
  '正東方': {
    wealth: '今日の財星は東方にあります。東を向いて業務や交渉を行うと財運エネルギーを集められます。',
    peach: '今日の桃花運は東方にあります。この方向での社交活動が魅力と恋愛機会を高めます。',
  },
  '正南方': {
    wealth: '今日の南方は名誉と財富をもたらします。南を向くと社会的な可視性と財運機会が高まります。',
    peach: '今日の南方に恋愛エネルギーがあります。この方向での社交活動が人間関係と貴人を引き寄せます。',
  },
  '東北方': {
    wealth: '今日の東北方の安定した土気が信頼できる財の蓄積をもたらします。不動産や安定した財務活動に最適です。',
    peach: '今日の貴人縁は東北方にあります。この方向への移動や出会いが助けとサポートをもたらします。',
  },
  '正西方': {
    wealth: '今日の西方の金気が決断力と財の利益をもたらします。交渉・契約・集金に最適です。',
    peach: '今日の貴人は西方にいます。西方への連絡が権威ある人物と貴重な同盟をもたらします。',
  },
  '西北方': {
    wealth: '今日の西北方の金気権威エネルギーが権力と人脈を通じて財を引き寄せます。',
    peach: '今日の権威ある貴人は西北方にいます。この方向が影響力あるサポートの扉を開きます。',
  },
  '正北方': {
    wealth: '今日の北方の水気が賢く流動的な財をもたらします。投機的洞察と創造的財務戦略に最適です。',
    peach: '今日の恋愛運は北方から流れます。北方への移動が直感と感情的つながりを高めます。',
  },
  '西南方': {
    wealth: '今日の西南方の安定した土気がゆっくりと確実に財を蓄積します。',
    peach: '今日の西南方の桃花エネルギーが温もり・家庭の調和・恋愛の出会いをもたらします。',
  },
};

// ─── 吉凶星韩文名 ────────────────────────────────────────────
export const STAR_KO: Record<string, string> = {
  '天德贵人': '천덕귀인', '月德贵人': '월덕귀인', '岁合吉星': '세합길성',
  '三合吉星': '삼합길성', '天喜星': '천희성', '生气星': '생기성',
  '天恩星': '천은성', '六合吉神': '육합길신', '玉堂吉神': '옥당길신',
  '明堂吉神': '명당길신', '金匮吉神': '금궤길신', '天医星': '천의성',
  '天德合': '천덕합', '岁德星': '세덕성', '续世星': '속세성',
  '福德星': '복덕성', '天贵星': '천귀성', '天仓星': '천창성',
  '天润星': '천윤성', '天解星': '천해성', '月德': '월덕', '六合': '육합',
  '月刑': '월형', '天刑': '천형', '大耗': '대모', '小耗': '소모',
  '破碎星': '파쇄성', '白虎': '백호', '天狗': '천구', '天罗': '천라', '月破': '월파',
  '牛宿煞': '우수살', '亢宿煞': '항수살', '心宿煞': '심수살',
  '女宿忌': '여수기', '虚宿煞': '허수살', '哭虚': '곡허',
  '危宿煞': '위수살', '破败': '파패', '奎宿煞': '규수살',
  '地火': '지화', '灾煞': '재살', '觜宿煞': '자수살',
  '星宿煞': '성수살', '翼宿煞': '익수살', '土府': '토부',
  '柳宿煞': '류수살', '鬼宿煞': '귀수살', '昴宿煞': '묘수살',
};

// ─── 吉凶星日文名 ────────────────────────────────────────────
export const STAR_JA: Record<string, string> = {
  '天德贵人': '天徳貴人', '月德贵人': '月徳貴人', '岁合吉星': '歳合吉星',
  '三合吉星': '三合吉星', '天喜星': '天喜星', '生气星': '生気星',
  '天恩星': '天恩星', '六合吉神': '六合吉神', '玉堂吉神': '玉堂吉神',
  '明堂吉神': '明堂吉神', '金匮吉神': '金匱吉神', '天医星': '天医星',
  '天德合': '天徳合', '岁德星': '歳徳星', '续世星': '続世星',
  '福德星': '福徳星', '天贵星': '天貴星', '天仓星': '天倉星',
  '天润星': '天潤星', '天解星': '天解星', '月德': '月徳', '六合': '六合',
  '月刑': '月刑', '天刑': '天刑', '大耗': '大耗', '小耗': '小耗',
  '破碎星': '破砕星', '白虎': '白虎', '天狗': '天狗', '天罗': '天羅', '月破': '月破',
  '牛宿煞': '牛宿煞', '亢宿煞': '亢宿煞', '心宿煞': '心宿煞',
  '女宿忌': '女宿忌', '虚宿煞': '虚宿煞', '哭虚': '哭虚',
  '危宿煞': '危宿煞', '破败': '破敗', '奎宿煞': '奎宿煞',
  '地火': '地火', '灾煞': '災煞', '觜宿煞': '觜宿煞',
  '星宿煞': '星宿煞', '翼宿煞': '翼宿煞', '土府': '土府',
  '柳宿煞': '柳宿煞', '鬼宿煞': '鬼宿煞', '昴宿煞': '昴宿煞',
};

// ─── 吉凶星描述韩文 ──────────────────────────────────────────
export const STAR_DESC_KO: Record<string, string> = {
  '天德贵人': '천덕이 비추어 모든 장애가 사라지고 귀인이 나타나 여행이 축복받습니다.',
  '月德贵人': '월덕이 높이 비추어 인간관계가 조화롭고 가정이 번창하며 재물이 안정적으로 나아갑니다.',
  '岁合吉星': '세합이 당령하여 계약, 동맹, 협력에 완벽한 시기입니다.',
  '三合吉星': '삼합이 모여 모든 일에 세 방향의 도움이 있어 큰일을 이룰 수 있습니다.',
  '天喜星': '천희가 강림하여 경사가 연이어 오며 혼례와 경전에 길합니다.',
  '生气星': '생기가 왕성하여 생기가 발발하며 착공과 새 생명 맞이에 길합니다.',
  '天恩星': '천은이 두루 비추어 관용과 길상이 넘치며 손님 접대와 선행에 길합니다.',
  '六合吉神': '육합이 모여 모든 일이 순조롭고 인간관계가 조화롭습니다.',
  '玉堂吉神': '옥당이 열려 부귀가 임하며 부동산 취득에 길합니다.',
  '明堂吉神': '명당이 높이 비추어 귀기가 흘러 승진과 취직에 유리합니다.',
  '金匮吉神': '금궤가 열려 재원이 넓어지며 재테크와 투자에 길합니다.',
  '天医星': '천의가 당령하여 진료와 치료 효과가 배가되며 병세가 호전됩니다.',
  '天刑': '천형이 비추어 법적 분쟁 위험이 높아집니다. 조용히 행동하고 분쟁을 피하세요.',
  '大耗': '대모성이 임하여 재물 손실에 주의하세요. 대규모 투자와 충동 소비를 피하세요.',
  '白虎': '백호가 임하여 사고 위험이 높아집니다. 여행 시 각별히 주의하세요.',
  '天狗': '천구가 지켜보고 있습니다. 예상치 못한 부상에 주의하고 여행 시 경계하세요.',
  '月破': '월파가 당령하여 오늘은 장애가 많습니다. 조용히 힘을 비축하며 기다리세요.',
  '牛宿煞': '우수살이 임하여 가족 건강에 주의하세요. 반복되는 질환에 경계하세요.',
  '亢宿煞': '항수살이 활성화되어 모든 일에 신중하세요. 특히 건강과 사고에 주의하세요.',
  '心宿煞': '심수살이 임하여 감정 충동과 재물 손실에 주의하세요.',
  '女宿忌': '여수기—중요한 결정을 강행하지 마세요. 조화가 최우선입니다.',
  '虚宿煞': '허수살이 임하여 감정이 저하될 수 있습니다. 명상하고 경사를 피하세요.',
  '哭虚': '곡허가 활성화되어 감정이 예민합니다. 안정적인 마음을 유지하세요.',
  '危宿煞': '위수살—고위험 활동을 피하고 보수적으로 지내세요.',
  '破败': '파패성이 임하여 후퇴에 주의하세요. 확장보다 공고히 하세요.',
  '奎宿煞': '규수살—화재 위험에 주의하고 감정을 차분히 유지하세요.',
  '地火': '지화가 깜빡입니다. 오늘은 화재와 전기 안전에 각별히 주의하세요.',
  '灾煞': '재살이 임하여 낮은 자세를 유지하세요. 무모함을 피하고 분쟁에 주의하세요.',
  '觜宿煞': '자수살—험담과 분쟁에 주의하세요. 오늘은 말을 신중히 하세요.',
  '星宿煞': '성수살—오늘은 장애가 많습니다. 조용히 에너지를 비축하세요.',
  '翼宿煞': '익수살—모든 일에 신중하세요. 여행 중 얽힘을 피하세요.',
  '土府': '토부가 압박합니다. 토목 공사를 피하고 밀린 업무에 집중하세요.',
  '柳宿煞': '류수살—소화에 주의하세요. 가볍게 드시고 과식을 피하세요.',
  '鬼宿煞': '귀수살—제사와 청결을 유지하세요. 집을 깨끗이 하세요.',
  '昴宿煞': '묘수살—갑작스러운 부상에 주의하세요. 오늘은 운전에 각별히 조심하세요.',
};

// ─── 吉凶星描述日文 ──────────────────────────────────────────
export const STAR_DESC_JA: Record<string, string> = {
  '天德贵人': '天徳が照らし、すべての障害が消え、貴人が現れ、旅が祝福されます。',
  '月德贵人': '月徳が高く照らし、人間関係が調和し、家庭が繁栄し、財運が安定して進みます。',
  '岁合吉星': '歳合が当令し、契約・同盟・協力に完璧な時期です。',
  '三合吉星': '三合が集まり、万事に三方向の助けがあり、大事を成し遂げられます。',
  '天喜星': '天喜が降臨し、慶事が続き、婚礼や慶典に吉です。',
  '生气星': '生気が旺盛で、生気が勃発し、着工や新しい命の誕生に吉です。',
  '天恩星': '天恩が広く照らし、寛容と吉祥が溢れ、接客や善行に吉です。',
  '六合吉神': '六合が集まり、万事が順調で人間関係が調和します。',
  '玉堂吉神': '玉堂が開き、富貴が訪れ、不動産取得に吉です。',
  '明堂吉神': '明堂が高く照らし、貴気が流れ、昇進・就職に有利です。',
  '金匮吉神': '金匱が開き、財源が広がり、資産運用・投資に吉です。',
  '天医星': '天医が当令し、受診・治療の効果が倍増し、病状が好転します。',
  '天刑': '天刑が照らし、法的紛争リスクが高まります。低姿勢で行動し、争いを避けましょう。',
  '大耗': '大耗星が臨み、財物の損失に注意。大規模投資と衝動買いを避けましょう。',
  '白虎': '白虎が臨み、事故リスクが高まります。旅行・運転は特に注意してください。',
  '天狗': '天狗が見守っています。予期せぬ怪我に注意し、旅行時は警戒してください。',
  '月破': '月破が当令し、今日は障害が多い。静かに力を蓄えて待ちましょう。',
  '牛宿煞': '牛宿煞が臨み、家族の健康に注意。繰り返す病状に警戒してください。',
  '亢宿煞': '亢宿煞が活性化。万事に慎重に、特に健康と事故に注意しましょう。',
  '心宿煞': '心宿煞が臨み、感情の衝動と財物の損耗に注意してください。',
  '女宿忌': '女宿忌—重要な決断を強行しないでください。調和を最優先に。',
  '虚宿煞': '虚宿煞が臨み、感情が低下しやすい。瞑想し、慶事を避けましょう。',
  '哭虚': '哭虚が活性化。感情が敏感です。安定した心を保ちましょう。',
  '危宿煞': '危宿煞—高リスク活動を避け、保守的に過ごしましょう。',
  '破败': '破敗星が臨み、後退に注意。拡大より固守が吉です。',
  '奎宿煞': '奎宿煞—火災に注意し、感情を穏やかに保ちましょう。',
  '地火': '地火が揺れています。今日は火災と電気安全に特に注意してください。',
  '灾煞': '災煞が臨み、低姿勢を保ちましょう。無謀を避け、争いに注意。',
  '觜宿煞': '觜宿煞—噂と争いに注意。今日は言葉を慎みましょう。',
  '星宿煞': '星宿煞—今日は障害が多い。静かにエネルギーを蓄えましょう。',
  '翼宿煞': '翼宿煞—万事に慎重に。旅行中の巻き込まれを避けましょう。',
  '土府': '土府が圧迫します。土木工事を避け、積み残し業務に集中しましょう。',
  '柳宿煞': '柳宿煞—消化に注意。軽めの食事を心がけ、過食を避けましょう。',
  '鬼宿煞': '鬼宿煞—祭祀と清潔を保ちましょう。家を清潔に。',
  '昴宿煞': '昴宿煞—突然の怪我に注意。今日は運転に格外注意してください。',
};

// ─── 建除名称繁体（zh-HK）────────────────────────────────────
export const JIANCHU_TRAD_NAMES: Record<string, string> = {
  '建': '建', '除': '除', '满': '滿', '平': '平', '定': '定', '执': '執',
  '破': '破', '危': '危', '成': '成', '收': '收', '开': '開', '闭': '閉',
};

// ─── 方位繁体（zh-HK）───────────────────────────────────────
export const DIRECTION_TRAD: Record<string, { name: string; short: string }> = {
  '东南方': { name: '東南方', short: '東南' },
  '正东方': { name: '正東方', short: '正東' },
  '正南方': { name: '正南方', short: '正南' },
  '东北方': { name: '東北方', short: '東北' },
  '正西方': { name: '正西方', short: '正西' },
  '西北方': { name: '西北方', short: '西北' },
  '正北方': { name: '正北方', short: '正北' },
  '西南方': { name: '西南方', short: '西南' },
};

// ─── 方向英文描述 ─────────────────────────────────────────────
export const DIRECTION_DESC_EN: Record<string, { wealth: string; peach: string }> = {
  'Southeast': {
    wealth: 'Wealth energy flows from the Southeast today. Face or move toward this direction for business talks or financial activities to attract prosperity.',
    peach: 'Romance and noble connections favor the Southeast. Travel or socialize in this direction to enhance personal magnetism and relationships.',
  },
  'East': {
    wealth: 'The Wealth Star sits in the East today. Orient yourself eastward for work or negotiations to draw in financial energy.',
    peach: 'Peach Blossom luck favors the East. Social activities in this direction enhance charm and romantic opportunities.',
  },
  'South': {
    wealth: 'The South brings fame and prestige wealth today. Facing south amplifies visibility and social-wealth opportunities.',
    peach: 'The South holds romance energy today. Engaging socially in this direction brightens relationships and attracts helpful people.',
  },
  'Northeast': {
    wealth: 'Northeast\'s stable Earth energy brings reliable wealth accumulation today. Ideal for property matters and solid financial activities.',
    peach: 'Noble connections favor the Northeast. Moving or meeting in this direction invites helpful guidance and support.',
  },
  'West': {
    wealth: 'West\'s Metal energy brings decisiveness and financial gains today. Best for negotiations, contracts and collecting payments.',
    peach: 'Noble helpers reside in the West today. Reaching out westward brings authority figures and valuable allies.',
  },
  'Northwest': {
    wealth: 'Northwest\'s Metal authority energy attracts wealth through power and connections today.',
    peach: 'Authoritative noble helpers favor the Northwest. This direction opens doors to influential support.',
  },
  'North': {
    wealth: 'North\'s Water energy brings clever, flowing wealth today. Ideal for speculative insight and creative financial strategies.',
    peach: 'Romance luck flows from the North. Moving northward enhances intuition and emotional connections.',
  },
  'Southwest': {
    wealth: 'Southwest\'s stable Earth energy accumulates wealth slowly but surely today.',
    peach: 'Peach Blossom energy in the Southwest brings warmth, family harmony and romantic encounters.',
  },
};

// ─── 食物韩文名 ───────────────────────────────────────────────
export const FOOD_KO: Record<string, { name: string; effect: string }> = {
  '菠菜': { name: '시금치', effect: '간을 보양하고 목기를 보충하며 시력을 향상시킵니다' },
  '韭菜': { name: '부추', effect: '양기를 따뜻하게 하고 활력을 높이며 실행력을 강화합니다' },
  '青椒': { name: '청피망', effect: '목기를 증폭시키고 정신을 고양하며 진취심을 촉진합니다' },
  '芹菜': { name: '셀러리', effect: '간열을 내리고 균형을 촉진하며 감정을 안정시킵니다' },
  '柠檬': { name: '레몬', effect: '신맛이 간을 보양하고 목기를 풍부하게 하며 감지력을 높입니다' },
  '西蓝花': { name: '브로콜리', effect: '간담을 보호하고 면역력을 높이며 운세를 활성화합니다' },
  '豆苗': { name: '완두 새싹', effect: '어린 목이 싹트며 새로운 시작을 촉진합니다' },
  '红枣': { name: '대추', effect: '심기를 보양하고 혈맥을 따뜻하게 하며 행운을 불러옵니다' },
  '枸杞': { name: '구기자', effect: '음양을 조화롭게 하고 활력을 높이며 연애운을 강화합니다' },
  '荔枝': { name: '리치', effect: '화기가 충만하고 달콤한 맛이 마음을 기쁘게 합니다' },
  '番茄': { name: '토마토', effect: '기혈을 보양하고 몸을 정화하며 에너지장을 맑게 합니다' },
  '苦瓜': { name: '여주', effect: '심화를 내리고 화기 과잉을 방지하며 균형을 유지합니다' },
  '红豆': { name: '팥', effect: '심장과 위를 따뜻하게 하고 혈액순환을 촉진하며 재물을 모읍니다' },
  '樱桃': { name: '체리', effect: '혈을 보양하고 연애운을 높이며 인간관계를 순조롭게 합니다' },
  '南瓜': { name: '호박', effect: '토기가 충만하고 기반을 안정시키며 재물을 모읍니다' },
  '山药': { name: '마', effect: '비위를 강화하고 토 원소를 보충하며 안정성을 높입니다' },
  '小米': { name: '기장', effect: '중초를 따뜻하게 하고 토기를 보충하며 재물을 안정시킵니다' },
  '红薯': { name: '고구마', effect: '토의 달콤한 기운이 재운을 두텁게 하고 대지 에너지에 순응합니다' },
  '蜂蜜': { name: '꿀', effect: '달콤하게 보양하고 몸과 마음을 윤택하게 하며 달콤한 행운을 불러옵니다' },
  '玉米': { name: '옥수수', effect: '오곡의 으뜸으로 토기가 가장 왕성하여 재물과 귀인을 모읍니다' },
  '姜': { name: '생강', effect: '중초를 따뜻하게 하고 한기를 몰아내며 토기를 활성화합니다' },
  '白萝卜': { name: '흰 무', effect: '금기가 폐를 맑게 하고 기를 조절하며 결단력을 높입니다' },
  '银耳': { name: '흰 목이버섯', effect: '은백색이 금과 같아 피부를 보양하고 귀인운을 높입니다' },
  '百合': { name: '백합', effect: '폐를 맑게 하고 마음을 안정시키며 순수한 금기로 감정을 안정시킵니다' },
  '梨子': { name: '배', effect: '폐를 윤택하게 하고 건조함을 해소하며 금기가 흘러 장애를 해소합니다' },
  '豆腐': { name: '두부', effect: '흰색이 금을 보충하고 담백하게 보양하며 운세 에너지를 정화합니다' },
  '莲藕': { name: '연근', effect: '일곱 구멍이 금기를 모아 재물과 지혜를 돕습니다' },
  '杏仁': { name: '아몬드', effect: '폐 기능을 지원하고 금기를 보충하며 행동력을 높입니다' },
  '黑芝麻': { name: '검은깨', effect: '신장과 정기를 보양하고 수기가 충만하여 지혜의 원천을 엽니다' },
  '黑豆': { name: '검은콩', effect: '신장에 들어가 수기를 보충하고 혈액을 활성화하며 자기장을 강화합니다' },
  '核桃': { name: '호두', effect: '신장과 뇌를 보양하고 수기가 왕성하여 전략과 통찰을 돕습니다' },
  '桑葚': { name: '오디', effect: '음혈을 보양하고 수기가 윤택하여 연애와 재물운을 돕습니다' },
  '板栗': { name: '밤', effect: '신장을 강화하고 수토가 조화를 이루어 기반을 안정시킵니다' },
  '海带': { name: '다시마', effect: '바다에서 와서 수기가 가장 왕성하여 지혜의 흐름을 돕습니다' },
  '葡萄': { name: '포도', effect: '즙이 풍부하고 수기가 자양하여 운세가 순조롭게 흐르도록 돕습니다' },
};

// ─── 食物日文名 ───────────────────────────────────────────────
export const FOOD_JA: Record<string, { name: string; effect: string }> = {
  '菠菜': { name: 'ほうれん草', effect: '肝を養い木気を補い、視力を向上させます' },
  '韭菜': { name: 'ニラ', effect: '陽気を温め活力を高め、実行力を強化します' },
  '青椒': { name: 'ピーマン', effect: '木気を増幅させ精神を高揚させ、進取の気を促します' },
  '芹菜': { name: 'セロリ', effect: '肝熱を冷まし均衡を促進し、感情を安定させます' },
  '柠檬': { name: 'レモン', effect: '酸味が肝を養い木気を豊かにし、感知力を高めます' },
  '西蓝花': { name: 'ブロッコリー', effect: '肝胆を保護し免疫力を高め、運勢を活性化します' },
  '豆苗': { name: '豆苗', effect: '若い木が芽吹き、新しい始まりを触媒します' },
  '红枣': { name: 'なつめ', effect: '心気を養い血脈を温め、幸運を招きます' },
  '枸杞': { name: 'クコの実', effect: '陰陽を調和させ活力を高め、恋愛運を強化します' },
  '荔枝': { name: 'ライチ', effect: '火気が充満し甘い味が心を喜ばせます' },
  '番茄': { name: 'トマト', effect: '気血を養い体を浄化し、エネルギー場を清めます' },
  '苦瓜': { name: 'ゴーヤ', effect: '心火を冷まし火気の過剰を防ぎ、均衡を保ちます' },
  '红豆': { name: '小豆', effect: '心胃を温め血行を促進し、財を集めます' },
  '樱桃': { name: 'さくらんぼ', effect: '血を養い恋愛運を高め、人間関係を順調にします' },
  '南瓜': { name: 'かぼちゃ', effect: '土気が充満し基盤を安定させ、財を集めます' },
  '山药': { name: '山芋', effect: '脾胃を強化し土元素を補い、安定性を高めます' },
  '小米': { name: 'きび', effect: '中焦を温め土気を補い、財を安定させます' },
  '红薯': { name: 'さつまいも', effect: '土の甘い気が財運を厚くし、大地のエネルギーに順応します' },
  '蜂蜜': { name: 'はちみつ', effect: '甘く養い心身を潤し、甘い幸運を招きます' },
  '玉米': { name: 'とうもろこし', effect: '五穀の筆頭で土気が最も旺盛、財と貴人を集めます' },
  '姜': { name: '生姜', effect: '中焦を温め寒気を払い、土気を活性化します' },
  '白萝卜': { name: '大根', effect: '金気が肺を清め気を調節し、決断力を高めます' },
  '银耳': { name: '白きくらげ', effect: '銀白色が金のように肌を養い、貴人運を高めます' },
  '百合': { name: 'ゆり根', effect: '肺を清め心を安定させ、純粋な金気で感情を安定させます' },
  '梨子': { name: '梨', effect: '肺を潤し乾燥を解消し、金気が流れて障害を解消します' },
  '豆腐': { name: '豆腐', effect: '白色が金を補い淡白に養い、運勢エネルギーを浄化します' },
  '莲藕': { name: 'れんこん', effect: '七つの穴が金気を集め、財と知恵を助けます' },
  '杏仁': { name: 'アーモンド', effect: '肺機能をサポートし金気を補い、行動力を高めます' },
  '黑芝麻': { name: '黒ごま', effect: '腎と精気を養い水気が充満し、知恵の源泉を開きます' },
  '黑豆': { name: '黒豆', effect: '腎に入り水気を補い血を活性化し、磁場を強化します' },
  '核桃': { name: 'くるみ', effect: '腎と脳を養い水気が旺盛で、戦略と洞察を助けます' },
  '桑葚': { name: 'マルベリー', effect: '陰血を養い水気が潤い、恋愛と財運を助けます' },
  '板栗': { name: '栗', effect: '腎を強化し水土が調和して基盤を安定させます' },
  '海带': { name: '昆布', effect: '海から来て水気が最も旺盛、知恵の流れを助けます' },
  '葡萄': { name: 'ぶどう', effect: '汁が豊富で水気が養い、運勢が順調に流れるよう助けます' },
};

// ─── 颜色 meaning 多语言翻译表 ────────────────────────────────
export const COLOR_MEANING_EN: Record<string, string> = {
  '清新生机': 'Fresh vitality', '通透灵动': 'Translucent grace', '清雅脱俗': 'Refined elegance',
  '沉稳内蕴': 'Grounded depth', '蓬勃向上': 'Vibrant growth', '柔和通达': 'Gentle flow',
  '宁静致远': 'Serene vision', '清逸怡然': 'Tranquil ease',
  '热情张扬': 'Passionate radiance', '妩媚灵动': 'Charming grace', '温暖明媚': 'Warm brilliance',
  '神秘高贵': 'Mysterious nobility', '激情奔放': 'Passionate freedom', '明艳动人': 'Vivid allure',
  '喜庆吉祥': 'Festive auspice', '沉稳雅致': 'Composed elegance',
  '温暖富足': 'Warm abundance', '柔和明朗': 'Soft brightness', '饱满圆润': 'Full and mellow',
  '活泼热情': 'Lively warmth', '踏实稳健': 'Grounded steadiness', '素雅高洁': 'Pure refinement',
  '甜蜜幸福': 'Sweet happiness', '厚积薄发': 'Steady accumulation',
  '清净纯粹': 'Pure clarity', '温润如玉': 'Jade-like warmth', '华贵典雅': 'Luxurious elegance',
  '简约脱俗': 'Minimalist grace', '雍容华贵': 'Regal splendor', '清明澄澈': 'Crystal clarity',
  '温暖充实': 'Warm fulfillment', '温雅内敛': 'Warm restraint',
  '深邃智慧': 'Deep wisdom', '开阔通透': 'Open clarity', '沉稳专注': 'Calm focus',
  '灵动清爽': 'Agile freshness', '庄重深沉': 'Dignified depth', '诗意朦胧': 'Poetic haze',
  '耀眼夺目': 'Dazzling brilliance', '冷静清醒': 'Cool clarity',
};

export const COLOR_MEANING_KO: Record<string, string> = {
  '清新生机': '신선한 활력', '通透灵动': '투명한 우아함', '清雅脱俗': '세련된 우아함',
  '沉稳内蕴': '안정된 깊이', '蓬勃向上': '활기찬 성장', '柔和通达': '부드러운 흐름',
  '宁静致远': '고요한 비전', '清逸怡然': '평온한 여유',
  '热情张扬': '열정적인 빛남', '妩媚灵动': '매혹적인 우아함', '温暖明媚': '따뜻한 빛남',
  '神秘高贵': '신비로운 고귀함', '激情奔放': '열정적인 자유', '明艳动人': '생동감 있는 매력',
  '喜庆吉祥': '축제의 길조', '沉稳雅致': '차분한 우아함',
  '温暖富足': '따뜻한 풍요', '柔和明朗': '부드러운 밝음', '饱满圆润': '풍성하고 원만함',
  '活泼热情': '활발한 따뜻함', '踏实稳健': '안정적인 견고함', '素雅高洁': '순수한 세련됨',
  '甜蜜幸福': '달콤한 행복', '厚积薄发': '꾸준한 축적',
  '清净纯粹': '순수한 명료함', '温润如玉': '옥 같은 따뜻함', '华贵典雅': '화려한 우아함',
  '简约脱俗': '미니멀한 우아함', '雍容华贵': '왕족의 화려함', '清明澄澈': '수정 같은 명료함',
  '温暖充实': '따뜻한 충만함', '温雅内敛': '따뜻한 절제',
  '深邃智慧': '깊은 지혜', '开阔通透': '열린 명료함', '沉稳专注': '차분한 집중',
  '灵动清爽': '민첩한 신선함', '庄重深沉': '위엄 있는 깊이', '诗意朦胧': '시적인 안개',
  '耀眼夺目': '눈부신 빛남', '冷静清醒': '냉정한 명료함',
};

export const COLOR_MEANING_JA: Record<string, string> = {
  '清新生机': '清々しい活力', '通透灵动': '透明な優雅さ', '清雅脱俗': '洗練された優雅さ',
  '沉稳内蕴': '落ち着いた深み', '蓬勃向上': '活気ある成長', '柔和通达': '穏やかな流れ',
  '宁静致远': '静かなビジョン', '清逸怡然': '穏やかな安らぎ',
  '热情张扬': '情熱的な輝き', '妩媚灵动': '魅惑的な優雅さ', '温暖明媚': '温かな輝き',
  '神秘高贵': '神秘的な高貴さ', '激情奔放': '情熱的な自由', '明艳动人': '鮮やかな魅力',
  '喜庆吉祥': '祝祭の吉兆', '沉稳雅致': '落ち着いた優雅さ',
  '温暖富足': '温かな豊かさ', '柔和明朗': '柔らかな明るさ', '饱满圆润': '豊かで円満',
  '活泼热情': '活発な温かさ', '踏实稳健': '堅実な安定', '素雅高洁': '純粋な洗練',
  '甜蜜幸福': '甘い幸福', '厚积薄发': '着実な蓄積',
  '清净纯粹': '純粋な明晰さ', '温润如玉': '玉のような温かさ', '华贵典雅': '豪華な優雅さ',
  '简约脱俗': 'ミニマルな優雅さ', '雍容华贵': '王族の華やかさ', '清明澄澈': '水晶のような明晰さ',
  '温暖充实': '温かな充実', '温雅内敛': '温かな節制',
  '深邃智慧': '深い知恵', '开阔通透': '開かれた明晰さ', '沉稳专注': '落ち着いた集中',
  '灵动清爽': '機敏な爽やかさ', '庄重深沉': '威厳ある深み', '诗意朦胧': '詩的な霞',
  '耀眼夺目': '眩しい輝き', '冷静清醒': '冷静な明晰さ',
};

// ─── 幸运颜色描述韩文构建辅助 ─────────────────────────────────
export function buildColorDescKo(
  primaryName: string,
  secondaryName: string,
  primaryMeaning: string,
  secondaryMeaning: string,
  isSame: boolean,
): string {
  const p = COLOR_KO[primaryName] ?? COLOR_EN[primaryName] ?? primaryName;
  const s = COLOR_KO[secondaryName] ?? COLOR_EN[secondaryName] ?? secondaryName;
  const pm = COLOR_MEANING_KO[primaryMeaning] ?? primaryMeaning;
  const sm = COLOR_MEANING_KO[secondaryMeaning] ?? secondaryMeaning;
  if (isSame) {
    return `오늘의 행운 색상은 "${p}"입니다—${pm}. 이 색상을 주요 팔레트로 착용하거나 지니면 하루 종일 전체적인 에너지와 운세가 향상됩니다.`;
  }
  return `오늘의 주요 행운 색상은 "${p}"(${pm})이며, "${s}"(${sm})로 보완됩니다. 두 색상이 조화를 이루어 삶의 모든 영역에서 운세를 증폭시킵니다.`;
}

// ─── 幸运颜色描述日文构建辅助 ─────────────────────────────────
export function buildColorDescJa(
  primaryName: string,
  secondaryName: string,
  primaryMeaning: string,
  secondaryMeaning: string,
  isSame: boolean,
): string {
  const p = COLOR_JA[primaryName] ?? COLOR_EN[primaryName] ?? primaryName;
  const s = COLOR_JA[secondaryName] ?? COLOR_EN[secondaryName] ?? secondaryName;
  const pm = COLOR_MEANING_JA[primaryMeaning] ?? primaryMeaning;
  const sm = COLOR_MEANING_JA[secondaryMeaning] ?? secondaryMeaning;
  if (isSame) {
    return `今日のラッキーカラーは「${p}」です—${pm}。このカラーをメインパレットとして着用または携帯することで、一日を通じて全体的なエネルギーと運勢が向上します。`;
  }
  return `今日のメインラッキーカラーは「${p}」(${pm})で、「${s}」(${sm})で補完されます。二色が調和し、人生のあらゆる領域で運勢を増幅させます。`;
}

// ─── 食物描述韩文构建 ─────────────────────────────────────────
export function buildFoodDescKo(
  food1Name: string,
  food2Name: string,
  weakEl: string,
  todayEl: string,
  isSame: boolean,
): string {
  const f1 = FOOD_KO[food1Name]?.name ?? FOOD_EN[food1Name]?.name ?? food1Name;
  const f2 = FOOD_KO[food2Name]?.name ?? FOOD_EN[food2Name]?.name ?? food2Name;
  const e1 = ELEMENT_KO[weakEl] ?? weakEl;
  const e2 = ELEMENT_KO[todayEl] ?? todayEl;
  const f1Eff = FOOD_KO[food1Name]?.effect ?? FOOD_EN[food1Name]?.effect ?? '';
  const f2Eff = FOOD_KO[food2Name]?.effect ?? FOOD_EN[food2Name]?.effect ?? '';
  if (isSame) {
    return `오늘의 행운 전환 음식은 "${f1}"과 "${f2}"입니다—모두 ${e1}기가 풍부합니다. ${f1Eff}. ${f2Eff}. 오늘 섭취하면 효과가 배가되어 하루의 에너지에 순응하는 데 도움이 됩니다.`;
  }
  return `오늘은 "${f1}"을 먹어 ${e1}기를 보충하세요(${f1Eff}). 또한 "${f2}"로 오늘의 ${e2}기 천시에 순응하세요(${f2Eff}). 두 가지가 서로 보완하여 행운 에너지를 불어넣습니다.`;
}

// ─── 食物描述日文构建 ─────────────────────────────────────────
export function buildFoodDescJa(
  food1Name: string,
  food2Name: string,
  weakEl: string,
  todayEl: string,
  isSame: boolean,
): string {
  const f1 = FOOD_JA[food1Name]?.name ?? FOOD_EN[food1Name]?.name ?? food1Name;
  const f2 = FOOD_JA[food2Name]?.name ?? FOOD_EN[food2Name]?.name ?? food2Name;
  const e1 = ELEMENT_JA[weakEl] ?? weakEl;
  const e2 = ELEMENT_JA[todayEl] ?? todayEl;
  const f1Eff = FOOD_JA[food1Name]?.effect ?? FOOD_EN[food1Name]?.effect ?? '';
  const f2Eff = FOOD_JA[food2Name]?.effect ?? FOOD_EN[food2Name]?.effect ?? '';
  if (isSame) {
    return `今日の開運食は「${f1}」と「${f2}」です—どちらも${e1}気が豊富です。${f1Eff}。${f2Eff}。今日食べると効果が倍増し、その日のエネルギーに順応するのに役立ちます。`;
  }
  return `今日は「${f1}」を食べて${e1}気を補いましょう(${f1Eff})。また「${f2}」で今日の${e2}気の天時に順応しましょう(${f2Eff})。二つが相補い合い、開運エネルギーを注入します。`;
}

// ─── 幸运颜色描述英文构建辅助 ─────────────────────────────────
export function buildColorDescEn(
  primaryName: string,
  secondaryName: string,
  primaryMeaning: string,
  secondaryMeaning: string,
  isSame: boolean,
): string {
  const p = COLOR_EN[primaryName] ?? primaryName;
  const s = COLOR_EN[secondaryName] ?? secondaryName;
  const pm = COLOR_MEANING_EN[primaryMeaning] ?? primaryMeaning;
  const sm = COLOR_MEANING_EN[secondaryMeaning] ?? secondaryMeaning;
  if (isSame) {
    return `Today's lucky color is "${p}"—${pm}. Wearing or carrying this color as your main palette will enhance your overall energy and luck throughout the day.`;
  }
  return `Today's primary lucky color is "${p}" (${pm}), complemented by "${s}" (${sm}). Together they harmonize and amplify your fortune across all areas of life.`;
}

// ─── 幸运数字英文标签 ─────────────────────────────────────────
export const NUMBER_ELEMENT_LABEL_EN: Record<string, string> = {
  '木': 'Wood', '火': 'Fire', '土': 'Earth', '金': 'Metal', '水': 'Water',
};

// ─── 食物英文描述构建 ─────────────────────────────────────────
// ─── 五行强弱等级多语言 ─────────────────────────────────────
export const STRENGTH_LEVEL_I18N: Record<string, Record<string, string>> = {
  '过旺': { 'zh-CN': '过旺', 'zh-HK': '過旺', 'en': 'Excess', 'ko': '과왕', 'ja': '過旺' },
  '旺盛': { 'zh-CN': '旺盛', 'zh-HK': '旺盛', 'en': 'Vigorous', 'ko': '왕성', 'ja': '旺盛' },
  '适中': { 'zh-CN': '适中', 'zh-HK': '適中', 'en': 'Balanced', 'ko': '균형', 'ja': '適中' },
  '偏弱': { 'zh-CN': '偏弱', 'zh-HK': '偏弱', 'en': 'Weak', 'ko': '편약', 'ja': '偏弱' },
  '极弱': { 'zh-CN': '极弱', 'zh-HK': '極弱', 'en': 'Very Weak', 'ko': '극약', 'ja': '極弱' },
};
export function getStrengthLevelLabel(level: string, lang: string): string {
  return STRENGTH_LEVEL_I18N[level]?.[lang] ?? STRENGTH_LEVEL_I18N[level]?.['zh-CN'] ?? convertText(level, lang);
}

// ─── 格局等级多语言 ─────────────────────────────────────────
export const GEJU_LEVEL_I18N: Record<string, Record<string, string>> = {
  '上格': { 'zh-CN': '上格', 'zh-HK': '上格', 'en': 'Superior', 'ko': '상격', 'ja': '上格' },
  '中上格': { 'zh-CN': '中上格', 'zh-HK': '中上格', 'en': 'High', 'ko': '중상격', 'ja': '中上格' },
  '中格': { 'zh-CN': '中格', 'zh-HK': '中格', 'en': 'Middle', 'ko': '중격', 'ja': '中格' },
  '中下格': { 'zh-CN': '中下格', 'zh-HK': '中下格', 'en': 'Moderate', 'ko': '중하격', 'ja': '中下格' },
};
export function getGejuLevelLabel(level: string, lang: string): string {
  return GEJU_LEVEL_I18N[level]?.[lang] ?? GEJU_LEVEL_I18N[level]?.['zh-CN'] ?? convertText(level, lang);
}

// ─── 月令标签多语言 ─────────────────────────────────────────
const MONTH_DECREE_LABEL: Record<string, string> = {
  'zh-CN': '月令', 'zh-HK': '月令', 'en': 'Month Decree', 'ko': '월령', 'ja': '月令',
};
export function getMonthDecreeLabel(lang: string): string {
  return MONTH_DECREE_LABEL[lang] ?? '月令';
}

// ─── 五行关系描述多语言 ─────────────────────────────────────
export function getWuxingRelDesc(
  el1: string,
  relType: 'generates' | 'overcomes' | 'generatedBy' | 'overcomesBy',
  el2: string,
  lang: string,
): string {
  const e1 = getElementLabel(el1, lang);
  const e2 = getElementLabel(el2, lang);
  if (lang === 'en') {
    const map = {
      generates: `${e1} nourishes ${e2}, expending its own energy`,
      overcomes: `${e1} controls ${e2}, asserting dominance`,
      generatedBy: `${e2} nourishes ${e1}, providing support`,
      overcomesBy: `${e2} controls ${e1}, applying pressure`,
    };
    return map[relType];
  }
  if (lang === 'ko') {
    const map = {
      generates: `${e1}이 ${e2}를 자양하며 스스로 에너지를 소모합니다`,
      overcomes: `${e1}이 ${e2}를 극제하며 주도적 힘을 행사합니다`,
      generatedBy: `${e2}가 ${e1}을 자양하며 지원을 제공합니다`,
      overcomesBy: `${e2}가 ${e1}을 극제하며 압박을 가합니다`,
    };
    return map[relType];
  }
  if (lang === 'ja') {
    const map = {
      generates: `${e1}が${e2}を養い、自身のエネルギーを消耗します`,
      overcomes: `${e1}が${e2}を制し、主導力を発揮します`,
      generatedBy: `${e2}が${e1}を養い、サポートを提供します`,
      overcomesBy: `${e2}が${e1}を制し、圧力をかけます`,
    };
    return map[relType];
  }
  // zh-CN / zh-HK
  if (relType === 'generates') return convertText(`${el1}滋养${el2}，消耗自身能量`, lang);
  if (relType === 'overcomes') return convertText(`${el1}克制${el2}，掌控之力`, lang);
  if (relType === 'generatedBy') return convertText(`${el2}滋养${el1}，获得支持`, lang);
  return convertText(`${el2}克制${el1}，承受压力`, lang);
}

// ─── 五行概览总结多语言 ─────────────────────────────────────
export function getWuxingOverviewSummaryLocale(
  balanceScore: number,
  mainExcess: string | null,
  mainDeficiency: string | null,
  lang: string,
): string {
  const s = mainExcess ? getElementLabel(mainExcess, lang) : '';
  const w = mainDeficiency ? getElementLabel(mainDeficiency, lang) : '';
  if (lang === 'en') {
    if (balanceScore >= 85) return 'Your five elements are well-balanced. A harmonious chart promotes well-rounded development and strong adaptability.';
    if (balanceScore >= 65 && s && w) return `Your chart leans toward ${s} energy while ${w} is weaker. Regular adjustments can optimize your elemental balance and enhance fortune.`;
    if (balanceScore >= 65) return 'Your chart has minor elemental imbalances. Regular lifestyle adjustments can optimize your five element balance.';
    if (s && w) return `Your elemental distribution is significantly uneven — ${s} is dominant while ${w} is notably deficient. Targeted elemental adjustments are the key to improving fortune.`;
    return 'Your five elements have significant imbalances. Understanding your elemental traits and making targeted adjustments is the key to improving fortune.';
  }
  if (lang === 'ko') {
    if (balanceScore >= 85) return '오행이 균형 잡혀 있습니다. 조화로운 명국으로 전면적인 발전과 강한 적응력을 가집니다.';
    if (balanceScore >= 65 && s && w) return `명국 오행에 편중이 있어 ${s}기가 강하고 ${w}기가 약합니다. 일상 조절로 오행 균형을 최적화할 수 있습니다.`;
    if (balanceScore >= 65) return '명국 오행에 약간의 불균형이 있습니다. 일상 생활 조절로 오행 균형을 최적화할 수 있습니다.';
    if (s && w) return `오행 분포 차이가 크며 ${s}기가 두드러지고 ${w}기가 현저히 부족합니다. 오행 특성을 이해하고 목표를 가지고 조절하는 것이 운세 개선의 핵심입니다.`;
    return '오행 분포에 큰 차이가 있습니다. 오행 특성을 이해하고 조절하는 것이 운세 개선의 핵심입니다.';
  }
  if (lang === 'ja') {
    if (balanceScore >= 85) return '五行が均衡しています。命局が調和しており、全面的な発展と高い適応力を持ちます。';
    if (balanceScore >= 65 && s && w) return `命局の五行に偏りがあり、${s}気が旺盛で${w}気が弱めです。日常の調整で五行バランスを改善できます。`;
    if (balanceScore >= 65) return '命局の五行に軽微な偏りがあります。日常の生活習慣を調整することで五行バランスを最適化できます。';
    if (s && w) return `五行の分布に大きな差があり、${s}気が際立ち${w}気が明らかに不足しています。自身の五行特性を理解し的を絞った調節が運勢改善の鍵です。`;
    return '五行の分布に大きな偏りがあります。五行特性を理解し目標を持って調節することが運勢改善の鍵です。';
  }
  return '';
}

// ─── 十神简要描述多语言（用于 ShishenTab 列表显示）──────────
const SHISHEN_BRIEF_I18N: Record<string, Record<string, string>> = {
  '比肩': {
    'en': 'Peer star — independent, self-reliant, with strong collaborative and competitive instincts.',
    'ko': '비견 — 독립적이고 자주적이며 협력과 경쟁 본능이 강합니다.',
    'ja': '比肩 — 独立心が強く、協力と競争の本能を持ちます。',
  },
  '劫财': {
    'en': 'Rob Wealth star — bold, decisive, pioneering, with sharp execution and competitive drive.',
    'ko': '겁재 — 대담하고 결단력 있으며 개척적이고 강한 경쟁 의식을 가집니다.',
    'ja': '劫財 — 大胆で果断、開拓的で強い競争心と実行力を持ちます。',
  },
  '食神': {
    'en': 'Output Star — fortunate, optimistic, and talented. Life is rich in creativity and fine enjoyment.',
    'ko': '식신 — 행운과 낙관, 재능이 풍부합니다. 삶이 창의적 표현과 풍요로움으로 가득합니다.',
    'ja': '食神 — 福禄、楽観的で才能豊か。創造的な表現と豊かな享受に溢れた人生です。',
  },
  '伤官': {
    'en': 'Hurt Officer star — exceptionally intelligent, innovative, with a bold and unconventional personality.',
    'ko': '상관 — 매우 총명하고 혁신적이며 대담하고 개성 있는 성격을 가집니다.',
    'ja': '傷官 — 非常に聡明で革新的、大胆で型破りな個性を持ちます。',
  },
  '偏财': {
    'en': 'Side Wealth star — socially versatile, broad networks, and flexible multi-channel fortune.',
    'ko': '편재 — 사회적으로 다재다능하고 넓은 인맥과 유연한 다채널 재운을 가집니다.',
    'ja': '偏財 — 社交的に多才で広い人脈と柔軟な多チャンネルの財運を持ちます。',
  },
  '正财': {
    'en': 'Direct Wealth star — practical, trustworthy, financially disciplined. Wealth grows through steady effort.',
    'ko': '정재 — 현실적이고 신뢰할 수 있으며 재정적으로 규율 있습니다. 꾸준한 노력으로 재물이 성장합니다.',
    'ja': '正財 — 現実的で信頼でき、財務規律があります。着実な努力で財が成長します。',
  },
  '七杀': {
    'en': 'Seven Killings star — immense willpower and challenge-driven energy. Pressure activates extraordinary potential.',
    'ko': '칠살 — 엄청난 의지력과 도전 정신을 가집니다. 압박이 비범한 잠재력을 활성화합니다.',
    'ja': '七殺 — 強大な意志力と挑戦精神を持ちます。プレッシャーが並外れた潜在力を引き出します。',
  },
  '正官': {
    'en': 'Direct Officer star — principled, disciplined, and upright. High social recognition and steady advancement.',
    'ko': '정관 — 원칙적이고 규율적이며 공정합니다. 높은 사회적 인정과 안정적인 발전을 이룹니다.',
    'ja': '正官 — 原則的で規律正しく公正です。高い社会的評価と着実な発展を実現します。',
  },
  '偏印': {
    'en': 'Side Seal star — unique insight and deep expertise. Independent thinking leads to specialized mastery.',
    'ko': '편인 — 독특한 통찰력과 깊은 전문성을 가집니다. 독립적 사고가 전문적 숙달로 이어집니다.',
    'ja': '偏印 — 独自の洞察力と深い専門性を持ちます。独立した思考が専門的な熟達に繋がります。',
  },
  '正印': {
    'en': 'Direct Seal star — kind-hearted, knowledgeable, with strong benefactor affinity and noble helpers.',
    'ko': '정인 — 인자하고 학식이 넓으며 귀인 인연이 강합니다.',
    'ja': '正印 — 慈悲深く博識で、貴人縁が強く高貴な助力者に恵まれます。',
  },
};

export function getShishenBriefLocale(name: string, lang: string): string | null {
  if (lang === 'en' || lang === 'ko' || lang === 'ja') {
    return SHISHEN_BRIEF_I18N[name]?.[lang] ?? null;
  }
  return null;
}

// ─── 格局简介/特质/事业/感情多语言 ───────────────────────────
const GEJU_BRIEF_EN: Record<string, string> = {
  '正官格': 'Direct Officer Pattern: principled, disciplined, and upright. High social recognition and steady career advancement.',
  '七杀格': 'Seven Killings Pattern: extraordinary willpower and courage. Challenges and pressure activate immense potential for outstanding achievement.',
  '正印格': 'Direct Seal Pattern: kind-hearted, knowledgeable, blessed with noble helpers. Mentors and benefactors guide a meaningful journey.',
  '偏印格': 'Side Seal Pattern: unique thinking and deep insight. Specialized expertise and independent research lead to profound achievement.',
  '食神格': 'Output Star Pattern: blessed with prosperity and talent. Life is filled with abundance, creativity, and refined enjoyment.',
  '伤官格': 'Hurt Officer Pattern: exceptionally intelligent with powerful innovation. Individuality and creative breakthroughs define the path forward.',
  '正财格': 'Direct Wealth Pattern: practical and diligent. Wealth accumulates steadily through consistent effort and trustworthy conduct.',
  '偏财格': 'Side Wealth Pattern: socially versatile with extensive connections. Fortune flows through diverse channels and dynamic opportunities.',
  '比劫格': 'Peer-Rob Pattern: strong self-awareness and independence. Competitive spirit and pioneering drive lead to breakthroughs.',
  '从强格': 'Follow Strength Pattern: powerful self-determination. Working with the dominant element\'s energy creates remarkable outcomes.',
  '从弱格': 'Follow Weakness Pattern: graceful adaptability and strong benefactor affinity. Leveraging others\' strengths is the path to success.',
  '从财格': 'Follow Wealth Pattern: sharp financial instinct and business acumen. Natural talent for managing and multiplying wealth.',
  '从杀格': 'Follow Killings Pattern: iron willpower refined under pressure and challenge. Adversity reveals extraordinary leadership potential.',
  '从儿格': 'Follow Output Pattern: boundless creativity and forward-thinking talent. Creative expression is the greatest wealth.',
  '化气格': 'Transform Qi Pattern: unique transformative qualities. Specialized talents shine brilliantly in particular domains.',
};
const GEJU_CAREER_EN: Record<string, string> = {
  '正官格': 'Best suited for government, corporate management, law, and education. Principled conduct leads to steady, recognized advancement.',
  '七杀格': 'Excels in military, policing, entrepreneurship, and competitive fields. Pressure activates your greatest potential.',
  '正印格': 'Ideal for education, culture, medicine, charity, and academia. Reputation and wisdom are your greatest career assets.',
  '偏印格': 'Thrives in research, philosophy, technology, strategic consulting, and creative arts. Deep expertise creates outstanding value.',
  '食神格': 'Natural fit for arts, culinary, education, and creative design. Talent flows naturally; career unfolds with ease and joy.',
  '伤官格': 'Best in media, arts, law, and scientific research. Creative talent shines brightest when breaking conventional boundaries.',
  '正财格': 'Strong in finance, accounting, administration, and industry. Steady diligence and integrity build lasting wealth.',
  '偏财格': 'Excels in commerce, finance, sales, and PR. Extensive networks create opportunities and wealth through connection.',
  '比劫格': 'Best in competitive industries, entrepreneurship, and sports. Persistence and grit win through rivalry.',
  '从强格': 'Career aligned with the dominant element\'s nature yields the best results. Specialize in your natural domain.',
  '从弱格': 'Thrives in structured environments with strong team support. Leveraging others\' strengths achieves career success.',
  '从财格': 'Natural domain in commerce, finance, and trade. Business acumen and wealth management shine brightly.',
  '从杀格': 'Excels in military, policing, high-pressure management, and competitive fields. Adversity reveals your full power.',
  '从儿格': 'Best in arts, media, and creative industries. Talent is the greatest wealth; creative expression is the path.',
  '化气格': 'Career aligned with the transformed element\'s nature. Unique talents create exceptional value in specialized fields.',
};
const GEJU_LOVE_EN: Record<string, string> = {
  '正官格': 'Traditional and stable in relationships. Loyal and devoted, preferring socially recognized, responsible partnerships.',
  '七杀格': 'Intense and direct in love, with strong protectiveness. Equal communication prevents power imbalances in relationships.',
  '正印格': 'Gentle and spiritually deep. Seeks mature, intellectually resonant partners. Quality matters more than speed.',
  '偏印格': 'Reserved in love; values independence and intellectual connection. Partners need patience and genuine understanding.',
  '食神格': 'Tender and appreciative; values a partner who treasures talent and quality. Romance thrives with shared aesthetics.',
  '伤官格': 'Romantically idealistic with high expectations. Cultivating more tolerance creates richer, more lasting love.',
  '正财格': 'Steady and devoted; values family responsibility and practical partnership. Marriage is grounded and long-lasting.',
  '偏财格': 'Magnetically attractive with a vibrant social life. If partnered, focus fully on your primary relationship for lasting happiness.',
  '比劫格': 'Values equality and independence; dislikes being controlled. Mutual respect and personal space are essential.',
  '从强格': 'Independent and self-sufficient in love. Partners need to give sufficient respect and personal space.',
  '从弱格': 'Tends toward reliance; best with mature, dependable partners who provide emotional support.',
  '从财格': 'Practical in love; values material foundation and lifestyle compatibility in relationships.',
  '从杀格': 'Intense with strong control tendencies. Building trust and cultivating tolerance deepens lasting relationships.',
  '从儿格': 'Romantically free-spirited; values spiritual resonance. Partners need to appreciate and understand unique individuality.',
  '化气格': 'Naturally harmonizing in relationships; skilled at creating balance and sustaining warmth with a partner.',
};
const GEJU_TRAITS_EN: Record<string, string[]> = {
  '正官格': ['Principled & Upright', 'Disciplined & Reliable', 'Strong Responsibility', 'Values Honor', 'Fair & Just'],
  '七杀格': ['Extraordinary Willpower', 'Courageous Challenger', 'Determined & Resolute', 'Strong Leadership', 'Pressure-Resilient'],
  '正印格': ['Kind-Hearted', 'Widely Knowledgeable', 'Strong Noble Affinity', 'Broad-Minded', 'Values Inner Growth'],
  '偏印格': ['Unique Thinking', 'Deep Insight', 'Specialized Expertise', 'Independent Mind', 'Research-Oriented'],
  '食神格': ['Intelligent & Optimistic', 'Richly Talented', 'High Life Taste', 'Composed & Easy-going', 'Enjoys Life'],
  '伤官格': ['Exceptionally Brilliant', 'Innovative Breakthrough', 'Expressive', 'Distinctive Personality', 'Ahead of the Times'],
  '正财格': ['Practical & Steady', 'Trustworthy', 'Sound Financial Sense', 'Values Material Foundation', 'Diligent & Grounded'],
  '偏财格': ['Socially Versatile', 'Strong Networker', 'Opportunity Seizer', 'Generous & Open', 'Diverse Income'],
  '比劫格': ['Independent & Self-reliant', 'Competitive Awareness', 'Pioneering Spirit', 'Loyal & Values Friendship', 'Determined'],
  '从强格': ['Firm Character', 'Strong Self-Direction', 'High Action Drive', 'Independence', 'Ambitious'],
  '从弱格': ['Adaptable & Humble', 'Skilled at Leverage', 'Strong Adaptability', 'Noble Benefactor Luck', 'Resilient'],
  '从财格': ['Financial Instinct', 'Business-Minded', 'Pragmatic', 'Progressive', 'Career-Focused'],
  '从杀格': ['Pressure-Resistant', 'Iron Will', 'Courageous', 'Composed Under Pressure', 'Leadership Presence'],
  '从儿格': ['Extraordinary Creativity', 'Forward-Thinking', 'Outstanding Talent', 'Free Individuality', 'Expressive'],
  '化气格': ['Flexible & Adaptive', 'Quick to Respond', 'Inner & Outer Harmony', 'Good at Integration', 'Unique Character'],
};

const GEJU_BRIEF_KO: Record<string, string> = {
  '正官格': '정관격: 원칙적이고 규율적이며 공정합니다. 높은 사회적 인정과 관리 능력으로 안정적인 발전을 이룹니다.',
  '七杀格': '칠살격: 비범한 의지력과 용기를 가집니다. 도전과 압박 속에서 잠재력이 활성화되어 탁월한 성취를 이룹니다.',
  '正印格': '정인격: 인자하고 학식이 넓으며 귀인운이 강합니다. 스승과 귀인의 도움으로 인생이 풍요로워집니다.',
  '偏印格': '편인격: 독특한 사고와 깊은 통찰력을 가집니다. 전문 지식과 독립적 연구로 깊은 성취를 이룹니다.',
  '食神格': '식신격: 복록이 넘치고 낙관적이며 재능이 풍부합니다. 삶이 풍요롭고 창의적이며 세련된 즐거움으로 가득합니다.',
  '伤官格': '상관격: 탁월한 지능과 강한 혁신 능력을 가집니다. 개성과 창의적 돌파구가 앞길을 열어갑니다.',
  '正财格': '정재격: 현실적이고 성실합니다. 꾸준한 노력과 신뢰로 재물이 안정적으로 쌓입니다.',
  '偏财格': '편재격: 사회적 다재다능함과 광범위한 인맥을 가집니다. 다양한 채널과 역동적인 기회를 통해 운이 흐릅니다.',
  '比劫格': '비겁격: 강한 자아의식과 독립심을 가집니다. 경쟁 의식과 개척 정신으로 경쟁 속에서 돌파구를 만듭니다.',
  '从强格': '종강격: 강한 자기 결정력을 가집니다. 주도적 오행 에너지와 함께하면 탁월한 성과를 냅니다.',
  '从弱格': '종약격: 우아한 적응력과 강한 귀인 인연을 가집니다. 타인의 강점을 활용하는 것이 성공의 길입니다.',
  '从财格': '종재격: 예리한 재무 감각과 사업 안목을 가집니다. 재물을 관리하고 증식하는 천부적 재능이 있습니다.',
  '从杀格': '종살격: 압박과 도전 속에서 단련된 강철 같은 의지력을 가집니다. 역경이 탁월한 리더십 잠재력을 드러냅니다.',
  '从儿格': '종아격: 끝없는 창의력과 선구적 재능을 가집니다. 창의적 표현이 가장 큰 재물입니다.',
  '化气格': '화기격: 독특한 변환 특질을 가집니다. 특정 분야에서 전문적인 재능이 빛납니다.',
};
const GEJU_CAREER_KO: Record<string, string> = {
  '正官格': '정부 기관, 기업 관리, 법률, 교육 등 원칙과 공신력이 필요한 분야에 최적입니다.',
  '七杀格': '군경, 창업, 경쟁이 강한 분야에 적합합니다. 압박 속에서 최대 잠재력이 발휘됩니다.',
  '正印格': '교육, 문화, 의료, 공익, 학술 연구에 이상적입니다. 인심과 학식이 최대 자산입니다.',
  '偏印格': '연구, 철학, 기술, 전략 컨설팅, 창의 예술에 적합합니다. 깊은 전문성이 탁월한 가치를 만듭니다.',
  '食神格': '예술, 음식, 교육, 창의 디자인에 자연스럽게 맞습니다. 재능이 자연스럽게 흘러 커리어가 기쁘게 펼쳐집니다.',
  '伤官格': '미디어, 예술, 법률, 과학 연구에 최적입니다. 창의적 재능은 규칙을 깨는 곳에서 빛납니다.',
  '正财格': '금융, 회계, 행정, 실업에 강합니다. 꾸준한 성실함과 신뢰로 지속적인 재물을 쌓습니다.',
  '偏财格': '상업, 금융, 영업, PR에 탁월합니다. 광범위한 인맥이 기회와 재물을 만들어냅니다.',
  '比劫格': '경쟁 산업, 창업, 스포츠에 적합합니다. 집념과 투지로 경쟁 속에서 승리합니다.',
  '从强格': '주도적 오행의 특성에 맞는 직업이 최선입니다. 자신의 영역에서 깊이 발전하세요.',
  '从弱格': '강한 팀 지원이 있는 구조화된 환경에서 번창합니다. 타인의 강점을 활용해 커리어를 성공시킵니다.',
  '从财格': '상업, 금융, 무역이 자연스러운 영역입니다. 사업 감각과 재물 관리 능력이 빛납니다.',
  '从杀格': '군경, 고압 관리, 경쟁 분야에 탁월합니다. 역경이 최대 능력을 드러냅니다.',
  '从儿格': '예술, 미디어, 창의 산업에 최적입니다. 재능이 가장 큰 재물이며 창의적 표현이 길입니다.',
  '化气格': '변화 오행의 특성에 맞는 커리어에서 독특한 재능이 탁월한 가치를 발휘합니다.',
};
const GEJU_LOVE_KO: Record<string, string> = {
  '正官格': '전통적이고 안정적인 관계를 선호합니다. 충실하고 헌신적이며 사회적으로 인정받는 책임감 있는 파트너를 원합니다.',
  '七杀格': '사랑에 강렬하고 직접적이며 보호욕이 강합니다. 평등한 소통이 관계의 권력 불균형을 방지합니다.',
  '正印格': '온화하고 정신적으로 깊습니다. 성숙하고 지적으로 공명하는 파트너를 추구하며 속도보다 질을 중시합니다.',
  '偏印格': '사랑에서 내성적이며 독립성과 지적 교감을 중시합니다. 파트너는 인내심과 진정한 이해가 필요합니다.',
  '食神格': '다정하고 감사하며 재능과 품위를 소중히 여기는 파트너를 원합니다. 로맨스는 공유된 미적 감각 속에서 꽃핍니다.',
  '伤官格': '낭만적으로 이상주의적이고 기대치가 높습니다. 더 많은 관용이 더 풍부하고 지속적인 사랑을 만듭니다.',
  '正财格': '안정적이고 헌신적이며 가족 책임과 실질적인 파트너십을 중시합니다. 결혼이 안정적이고 오래갑니다.',
  '偏财格': '강한 매력과 활기찬 사교 생활을 가집니다. 파트너가 있다면 주요 관계에 집중해야 지속적인 행복을 얻습니다.',
  '比劫格': '평등과 독립을 중시하며 통제를 싫어합니다. 상호 존중과 개인 공간이 필수입니다.',
  '从强格': '사랑에서 독립적이고 자급자족합니다. 파트너는 충분한 존중과 개인 공간을 주어야 합니다.',
  '从弱格': '의존하는 경향이 있습니다. 성숙하고 신뢰할 수 있는 파트너가 감정적 지원을 제공하는 것이 최선입니다.',
  '从财格': '사랑에서 실용적이며 물질적 기반과 생활 방식 호환성을 중시합니다.',
  '从杀格': '강도 높고 통제 성향이 있습니다. 신뢰를 쌓고 관용을 키우는 것이 지속적인 관계를 깊게 합니다.',
  '从儿格': '낭만적으로 자유로우며 정신적 공명을 중시합니다. 파트너는 독특한 개성을 이해하고 감상해야 합니다.',
  '化气格': '관계에서 자연스럽게 조화를 이루며 파트너와 균형을 만들고 온기를 유지하는 데 능숙합니다.',
};
const GEJU_TRAITS_KO: Record<string, string[]> = {
  '正官格': ['원칙적·공정함', '규율적·신뢰할 수 있음', '강한 책임감', '명예 중시', '공명정대'],
  '七杀格': ['비범한 의지력', '용감한 도전자', '굳건한 결단력', '강한 리더십', '압박에 강함'],
  '正印格': ['인자함', '폭넓은 학식', '강한 귀인 인연', '넓은 마음', '내면 성장 중시'],
  '偏印格': ['독특한 사고', '깊은 통찰', '전문 지식', '독립적 사고', '연구 지향'],
  '食神格': ['총명하고 낙관적', '재능이 풍부', '높은 생활 취향', '여유로움', '인생 즐김'],
  '伤官格': ['탁월한 총명함', '혁신적 돌파', '표현력 강함', '독특한 개성', '시대를 앞서감'],
  '正财格': ['실용적·안정적', '신뢰할 수 있음', '재무 감각', '물질적 기반 중시', '성실하고 착실'],
  '偏财格': ['사회적 다재다능', '강한 인맥', '기회 포착', '관대하고 개방적', '다양한 수입'],
  '比劫格': ['독립 자주', '경쟁 의식', '개척 정신', '의리 중시', '결단력'],
  '从强格': ['강한 성격', '강한 자기 결정', '높은 행동력', '독립성', '야망'],
  '从弱格': ['적응력·겸손', '차용에 능숙', '강한 적응성', '귀인 복', '유연한 강인함'],
  '从财格': ['재무 감각', '사업 마인드', '실용주의', '진취적', '사업 의식'],
  '从杀格': ['압박 저항력', '강철 의지', '용감함', '침착함', '리더십'],
  '从儿格': ['탁월한 창의력', '선구적 사고', '뛰어난 재능', '자유로운 개성', '표현력'],
  '化气格': ['유연하고 적응적', '임기응변에 능함', '내외 조화', '통합에 능함', '독특한 개성'],
};
const GEJU_BRIEF_JA: Record<string, string> = {
  '正官格': '正官格：原則的で規律正しく公正です。高い社会的評価と管理能力で着実なキャリアアップを実現します。',
  '七杀格': '七殺格：並外れた意志と勇気を持ちます。挑戦と圧力の中で潜在力が活性化し、卓越した成果を生みます。',
  '正印格': '正印格：慈悲深く博識で貴人運に恵まれます。師匠や貴人のサポートが人生を豊かにします。',
  '偏印格': '偏印格：独自の思考と深い洞察力を持ちます。専門知識と独立した研究で深い成就を実現します。',
  '食神格': '食神格：福禄に恵まれ楽観的で才能豊か。豊かで創造的な生活に洗練された喜びが満ちあふれます。',
  '伤官格': '傷官格：傑出した聡明さと強い革新力を持ちます。個性と創造的突破口が道を切り開きます。',
  '正财格': '正財格：実際的で勤勉です。着実な努力と誠実さで財が安定して積み重なります。',
  '偏财格': '偏財格：社交的に多才で広い人脈を持ちます。多様なチャンネルと動的な機会を通じて運が流れます。',
  '比劫格': '比劫格：強い自我意識と独立心を持ちます。競争意識と開拓精神で競争の中に突破口を見つけます。',
  '从强格': '従強格：強い自己決定力を持ちます。主導的な五行エネルギーと協力することで卓越した成果を生みます。',
  '从弱格': '従弱格：優雅な適応力と強い貴人縁を持ちます。他者の強みを活用することが成功への道です。',
  '从财格': '従財格：鋭い財務感覚とビジネス眼識を持ちます。財を管理・増加させる天性の才能があります。',
  '从杀格': '従殺格：圧力と挑戦の中で鍛えられた鋼鉄のような意志を持ちます。逆境が卓越したリーダーシップ潜在力を引き出します。',
  '从儿格': '従児格：無限の創造力と先見的才能を持ちます。創造的表現が最大の財産です。',
  '化气格': '化気格：独特の変換特質を持ちます。特定の分野で専門的な才能が輝きます。',
};
const GEJU_CAREER_JA: Record<string, string> = {
  '正官格': '政府機関・企業管理・法律・教育など原則と信用が求められる分野に最適です。',
  '七杀格': '軍警・起業・競争の激しい分野が向いています。プレッシャー下で最大の潜在力を発揮します。',
  '正印格': '教育・文化・医療・公益・学術研究に理想的です。人心と学識が最大の職業資本です。',
  '偏印格': '研究・哲学・技術・戦略コンサルティング・創造芸術が向いています。深い専門性が卓越した価値を生みます。',
  '食神格': '芸術・飲食・教育・創意デザインに自然と合います。才能が自然に流れ、キャリアは喜びとともに展開します。',
  '伤官格': 'メディア・芸術・法律・科学研究に最適。創造的才能は常識を超えるところで最も輝きます。',
  '正财格': '金融・会計・行政・実業に強みがあります。着実な勤勉さと誠実さが持続的な財を築きます。',
  '偏财格': '商業・金融・営業・PRで卓越しています。広い人脈が機会と財富を生み出します。',
  '比劫格': '競争産業・起業・スポーツが向いています。粘り強さと闘志で競争に勝ちます。',
  '从强格': '主導五行の特性に合った職業が最善。自分の領域で深く発展しましょう。',
  '从弱格': '強いチームサポートのある構造化された環境で活躍します。他者の強みを借りてキャリアを成功させます。',
  '从财格': '商業・金融・貿易が自然な領域です。ビジネス感覚と財管理の才能が輝きます。',
  '从杀格': '軍警・高圧管理・競争分野が卓越しています。逆境が最大能力を引き出します。',
  '从儿格': '芸術・メディア・創意産業に最適。才能が最大の財産で、創造的表現が道です。',
  '化气格': '変換五行の特性に合ったキャリアで独特の才能が卓越した価値を発揮します。',
};
const GEJU_LOVE_JA: Record<string, string> = {
  '正官格': '伝統的で安定した関係を好みます。誠実で献身的、社会的に認められた責任ある関係を望みます。',
  '七杀格': '愛において強烈で直接的、保護欲が強い。平等なコミュニケーションが関係の権力不均衡を防ぎます。',
  '正印格': '温和で精神的に深い。成熟した知的共鳴のあるパートナーを求め、速さより質を重視します。',
  '偏印格': '愛に内向的で独立性と知的つながりを重視。パートナーには忍耐と真の理解が必要です。',
  '食神格': '優しく感謝に満ち、才能と品位を大切にするパートナーを望みます。共有された美的感覚の中でロマンスが花開きます。',
  '伤官格': '恋愛的に理想主義的で期待が高い。より多くの寛容さがより豊かで持続的な愛を生みます。',
  '正财格': '安定した献身的な関係を築き、家族の責任と実際的なパートナーシップを重視します。婚姻は安定で長続き。',
  '偏财格': '強い魅力と活発な社交生活を持ちます。パートナーがいれば主要な関係に集中することが幸福の鍵。',
  '比劫格': '平等と独立を重視し、束縛を嫌います。相互尊重と個人空間が不可欠です。',
  '从强格': '愛において独立的で自立します。パートナーには十分な尊重と個人空間を必要とします。',
  '从弱格': '依存傾向があります。成熟した信頼できるパートナーが感情的サポートを提供するのが最善。',
  '从财格': '愛において実際的で物質的基盤と生活様式の相性を重視します。',
  '从杀格': '強度が高く支配傾向があります。信頼を築き寛容を育てることが持続的な関係を深めます。',
  '从儿格': '恋愛的に自由で精神的共鳴を重視。パートナーは独自の個性を理解・感謝する必要があります。',
  '化气格': '関係において自然に調和し、パートナーとのバランスを作り温かさを維持するのが得意です。',
};
const GEJU_TRAITS_JA: Record<string, string[]> = {
  '正官格': ['原則的・公正', '規律・信頼', '責任感が強い', '名誉重視', '公明正大'],
  '七杀格': ['並外れた意志', '勇敢な挑戦者', '堅い決断力', '強いリーダーシップ', '圧力に強い'],
  '正印格': ['慈悲深い', '幅広い学識', '強い貴人縁', '広い心', '内面成長重視'],
  '偏印格': ['独自の思考', '深い洞察', '専門知識', '独立した心', '研究志向'],
  '食神格': ['聡明で楽観的', '才能豊か', '高い生活センス', '落ち着いた余裕', '人生を楽しむ'],
  '伤官格': ['傑出した聡明さ', '革新的突破', '表現力が強い', '独特な個性', '時代を先取り'],
  '正财格': ['実際的・安定', '信頼できる', '財務感覚', '物質基盤重視', '勤勉で着実'],
  '偏财格': ['社交的多才', '強い人脈', '機会を掴む', '気前よく開放的', '多様な収入'],
  '比劫格': ['独立自主', '競争意識', '開拓精神', '義理を重んじる', '決断力'],
  '从强格': ['しっかりした性格', '強い自己決定', '高い行動力', '独立性', '野心'],
  '从弱格': ['適応力・謙虚', '借力が得意', '強い適応性', '貴人福', '柔軟な強さ'],
  '从财格': ['財務感覚', 'ビジネス思考', '実用主義', '積極進取', '事業意識'],
  '从杀格': ['プレッシャー耐性', '鉄の意志', '勇敢', '泰然自若', 'リーダーシップ'],
  '从儿格': ['卓越した創造力', '先見的思考', '傑出した才能', '自由な個性', '表現力'],
  '化气格': ['柔軟で適応的', '臨機応変', '内外の調和', '統合が得意', '独特の個性'],
};

export function getGejuBriefLocale(name: string, lang: string): string | null {
  if (lang === 'en') return GEJU_BRIEF_EN[name] ?? null;
  if (lang === 'ko') return GEJU_BRIEF_KO[name] ?? null;
  if (lang === 'ja') return GEJU_BRIEF_JA[name] ?? null;
  return null;
}
export function getGejuCareerLocale(name: string, lang: string): string | null {
  if (lang === 'en') return GEJU_CAREER_EN[name] ?? null;
  if (lang === 'ko') return GEJU_CAREER_KO[name] ?? null;
  if (lang === 'ja') return GEJU_CAREER_JA[name] ?? null;
  return null;
}
export function getGejuLoveLocale(name: string, lang: string): string | null {
  if (lang === 'en') return GEJU_LOVE_EN[name] ?? null;
  if (lang === 'ko') return GEJU_LOVE_KO[name] ?? null;
  if (lang === 'ja') return GEJU_LOVE_JA[name] ?? null;
  return null;
}
export function getGejuTraitsLocale(name: string, lang: string): string[] | null {
  if (lang === 'en') return GEJU_TRAITS_EN[name] ?? null;
  if (lang === 'ko') return GEJU_TRAITS_KO[name] ?? null;
  if (lang === 'ja') return GEJU_TRAITS_JA[name] ?? null;
  return null;
}

// ─── 神煞描述/化解多语言（en/ko/ja）────────────────────────
const SHENSHA_DESC_EN: Record<string, string> = {
  '天乙贵人': 'Heavenly Yi Noble brings noble helpers and auspicious turning points. When difficulties arise, helpful people naturally appear to guide the way.',
  '文昌贵人': 'Literary Star Noble enhances intelligence and academic talent. Excellent for studies, exams, and creative endeavors.',
  '驿马': 'Travel Star indicates a life of movement and opportunity. Fortune grows through travel, relocation, and dynamic careers.',
  '桃花': 'Peach Blossom Star bestows natural charm and excellent relationships. Magnetic personality attracts social and romantic opportunities.',
  '羊刃': 'Yang Blade Star brings bold willpower and competitive spirit. Channel this sharp energy into courageous, decisive action.',
  '华盖': 'Flowery Canopy Star gifts artistic talent and independent thinking. Spiritual and creative pursuits bring great fulfillment.',
  '将星': 'General Star confers natural leadership authority. People naturally gather around you; management roles bring great success.',
  '魁罡': 'Kui Gang Star brings sharp intelligence and decisive character. Excel by pairing strength with flexibility.',
  '孤辰': 'Solitary Star indicates emotional sensitivity and strong independence. Active social engagement opens the heart to connection.',
  '寡宿': 'Widow Star reflects an introspective, self-reliant nature. Building community bonds brings warmth and meaningful relationships.',
};
const SHENSHA_RESOLVE_EN: Record<string, string> = {
  '羊刃': 'Channel this energy into competitive fields or martial arts. Decisive action transforms the blade into achievement.',
  '孤辰': 'Actively expand social circles and stay open to connection. Let relationships develop naturally.',
  '寡宿': 'Join community groups and cultivate close friendships. Marriage is better later than early.',
  '魁罡': 'Cultivate flexibility alongside strength. Balancing firmness and gentleness amplifies noble energy.',
};
const SHENSHA_DESC_KO: Record<string, string> = {
  '天乙贵人': '천을귀인은 귀인과 행운의 전기를 불러옵니다. 어려움에 처했을 때 도움이 될 사람이 자연스럽게 나타납니다.',
  '文昌贵人': '문창귀인은 학문과 창작 능력을 높여줍니다. 시험, 공부, 예술 활동에 매우 유리합니다.',
  '驿马': '역마는 이동과 기회가 많은 삶을 나타냅니다. 여행, 이직, 활동적인 직업에서 운이 성장합니다.',
  '桃花': '도화는 타고난 매력과 풍부한 인간관계를 상징합니다. 사교와 연애 기회를 끌어당깁니다.',
  '羊刃': '양인은 강한 의지와 경쟁심을 나타냅니다. 이 예리한 에너지를 용감하고 결단력 있는 행동으로 발휘하세요.',
  '华盖': '화개는 예술적 재능과 독립적 사고를 부여합니다. 창의적·정신적 추구에서 큰 보람을 얻습니다.',
  '将星': '장성은 타고난 리더십과 권위를 나타냅니다. 집단 속에서 자연스럽게 사람들을 모으며 관리직에서 탁월합니다.',
  '魁罡': '괴강은 예리한 두뇌와 결단력 있는 성격을 가집니다. 강함과 유연함의 균형으로 더욱 빛납니다.',
  '孤辰': '고진은 감정이 예민하고 독립심이 강합니다. 적극적인 사교 활동으로 마음을 열어 인연을 만드세요.',
  '寡宿': '과숙은 내성적이고 자립심이 강한 성격을 나타냅니다. 커뮤니티 유대를 쌓으면 따뜻함과 의미 있는 관계를 얻습니다.',
};
const SHENSHA_RESOLVE_KO: Record<string, string> = {
  '羊刃': '이 에너지를 경쟁 분야나 무도에 쏟으세요. 결단력이 성과로 이어집니다.',
  '孤辰': '적극적으로 인맥을 넓히고 인연이 자연스럽게 발전하도록 마음을 여세요.',
  '寡宿': '커뮤니티 그룹에 참여하고 친밀한 우정을 키우세요. 결혼은 서두르지 않는 게 좋습니다.',
  '魁罡': '강함과 유연함을 함께 키우세요. 강유 조화로 귀기가 더 돋보입니다.',
};
const SHENSHA_DESC_JA: Record<string, string> = {
  '天乙贵人': '天乙貴人は貴人運と幸運の転機をもたらします。困難な時、助けてくれる人が自然と現れます。',
  '文昌贵人': '文昌貴人は学問と創造力を高めます。試験・学業・芸術活動に非常に有利です。',
  '驿马': '驛馬は移動と機会の多い人生を示します。旅行・転職・動的なキャリアで運が開けます。',
  '桃花': '桃花は天性の魅力と豊かな人間関係を象徴します。社交・恋愛の機会を引き寄せます。',
  '羊刃': '羊刃は強い意志と競争心を持ちます。この鋭いエネルギーを勇気ある果断な行動に発揮しましょう。',
  '华盖': '華蓋は芸術的才能と独立した思考を授けます。創造的・精神的な探求で大きな充実感を得られます。',
  '将星': '将星は天性のリーダーシップと権威をもたらします。管理職で卓越した成果を上げます。',
  '魁罡': '魁罡は鋭い頭脳と果断な性格を持ちます。強さと柔軟さのバランスで貴気が輝きます。',
  '孤辰': '孤辰は感情が繊細で独立心が強い。積極的な社交活動で心を開き、ご縁を育てましょう。',
  '寡宿': '寡宿は内向的で自立心が強い性格を示します。コミュニティとの絆を築くことで温もりが生まれます。',
};
const SHENSHA_RESOLVE_JA: Record<string, string> = {
  '羊刃': 'このエネルギーを競技分野や武道に向けましょう。決断力が成果に繋がります。',
  '孤辰': '積極的に人脈を広げ、ご縁が自然に発展するよう心を開いてください。',
  '寡宿': 'コミュニティグループに参加し、親密な友情を育てましょう。結婚は焦らないほうが良いです。',
  '魁罡': '強さと柔軟さを共に培いましょう。剛柔のバランスで貴気がさらに輝きます。',
};

// ─── 神煞概览总结多语言（en/ko/ja）────────────────────────────
export function getShenshaSummaryLocale(
  jiCount: number,
  zhongCount: number,
  zhuyiCount: number,
  lang: string,
): string | null {
  if (lang === 'en') {
    if (jiCount === 0 && zhuyiCount === 0) {
      return 'Your chart carries relatively few Shen Sha stars. Fortune is steady and balanced — keep working earnestly and let life unfold naturally.';
    }
    const parts: string[] = [];
    if (jiCount > 0) parts.push(`${jiCount} auspicious star${jiCount > 1 ? 's' : ''} blessing your chart`);
    if (zhongCount > 0) parts.push(`${zhongCount} neutral star${zhongCount > 1 ? 's' : ''} providing unique energy`);
    if (zhuyiCount > 0) parts.push(`${zhuyiCount} star${zhuyiCount > 1 ? 's' : ''} calling for mindful attention`);
    return parts.join(', ') + '. Shen Sha analysis is a tool for self-understanding — leverage the auspicious stars wisely, and use awareness to navigate the challenging ones with clarity and purpose.';
  }
  if (lang === 'ko') {
    if (jiCount === 0 && zhuyiCount === 0) {
      return '명국의 신살이 비교적 적습니다. 운세가 안정적이고 균형 잡혀 있으니 성실히 나아가면 됩니다.';
    }
    const parts: string[] = [];
    if (jiCount > 0) parts.push(`길성 ${jiCount}개가 명국을 가호`);
    if (zhongCount > 0) parts.push(`중성 ${zhongCount}개가 독특한 에너지 제공`);
    if (zhuyiCount > 0) parts.push(`주의가 필요한 신살 ${zhuyiCount}개`);
    return parts.join(', ') + '. 신살은 자신을 이해하는 도구입니다. 길성을 현명하게 활용하고 불리한 요소는 지혜롭게 화해하세요.';
  }
  if (lang === 'ja') {
    if (jiCount === 0 && zhuyiCount === 0) {
      return '命局の神煞は比較的少なく、運勢は安定しています。地道に努力すれば自然と道が開けます。';
    }
    const parts: string[] = [];
    if (jiCount > 0) parts.push(`吉星${jiCount}つが命局を守護`);
    if (zhongCount > 0) parts.push(`中性神煞${zhongCount}つが独自のエネルギーを提供`);
    if (zhuyiCount > 0) parts.push(`注意が必要な神煞${zhuyiCount}つ`);
    return parts.join('、') + '。神煞は自己理解のツールです。吉星を賢く活かし、課題となる部分は洞察で乗り越えましょう。';
  }
  return null;
}

// ─── 五行相生相克关系辅助（用于 XiyongTab 英文理由）─────────
const _ELEM_GENERATES: Record<string, string> = { '木': '火', '火': '土', '土': '金', '金': '水', '水': '木' };
const _ELEM_OVERCOMES: Record<string, string> = { '木': '土', '土': '水', '水': '火', '火': '金', '金': '木' };
const _ELEM_GENERATED_BY: Record<string, string> = { '木': '水', '火': '木', '土': '火', '金': '土', '水': '金' };

// ─── 喜用神理由英文 locale ──────────────────────────────────
export function buildXiyongXiReasonLocale(el: string, dayStemEl: string, lang: string): string | null {
  if (lang === 'en') {
    if (el === dayStemEl) return 'Same element as your Day Master — provides peer support and strengthens the chart\'s foundation when your Day Master needs nourishment.';
    if (_ELEM_GENERATED_BY[dayStemEl] === el) return 'Seal energy that nourishes your Day Master directly — provides protection, amplifies inner strength, and helps you receive support from others.';
    if (_ELEM_GENERATES[dayStemEl] === el) return 'Output energy that channels your Day Master\'s vitality into talent and creative expression — allows energy to flow freely and converts strength into achievement.';
    if (_ELEM_OVERCOMES[el] === dayStemEl) return 'Officer/Killer energy that disciplines your abundant Day Master strength — converts excess into structured authority, social recognition, and purposeful drive.';
    if (_ELEM_OVERCOMES[dayStemEl] === el) return 'Wealth energy that your strong Day Master can readily control and activate — creates natural financial potential and practical real-world results.';
    return 'Supports five element balance in your chart and promotes harmonious overall energy flow.';
  }
  if (lang === 'ko') {
    if (el === dayStemEl) return '일주와 같은 오행으로 비겁이 도와줍니다. 약한 일주를 강화하여 명국이 더 안정됩니다.';
    if (_ELEM_GENERATED_BY[dayStemEl] === el) return '인성이 일주를 생조합니다. 보호와 내적 강화를 제공하며 귀인의 도움을 받기 쉽습니다.';
    if (_ELEM_GENERATES[dayStemEl] === el) return '식상이 일주의 활력을 재능과 창의적 표현으로 전환합니다. 에너지가 자유롭게 흐르게 합니다.';
    if (_ELEM_OVERCOMES[el] === dayStemEl) return '관살이 왕성한 일주를 조절합니다. 과도한 힘을 규율과 사회적 인정으로 변환합니다.';
    if (_ELEM_OVERCOMES[dayStemEl] === el) return '강한 일주가 재성을 다룰 수 있습니다. 자연스러운 재물 잠재력과 실질적 결과를 만듭니다.';
    return '오행 균형을 지원하고 명국의 조화로운 에너지 흐름을 촉진합니다.';
  }
  if (lang === 'ja') {
    if (el === dayStemEl) return '日主と同じ五行の比劫。弱い日主を強化し、命局の基盤を安定させます。';
    if (_ELEM_GENERATED_BY[dayStemEl] === el) return '日主を直接養う印星。保護と内的強化を提供し、貴人の助けを受けやすくなります。';
    if (_ELEM_GENERATES[dayStemEl] === el) return '日主の活力を才能と創造的表現に変換する食傷。エネルギーを自由に流し、成果に変えます。';
    if (_ELEM_OVERCOMES[el] === dayStemEl) return '旺盛な日主を規律する官殺。過剰なエネルギーを社会的権威と認定に転換します。';
    if (_ELEM_OVERCOMES[dayStemEl] === el) return '強い日主が財星をコントロールできます。自然な財務ポテンシャルと実践的成果を生みます。';
    return '五行バランスをサポートし、命局全体のエネルギーの調和を促進します。';
  }
  return null;
}

// ─── 忌神理由英文 locale ────────────────────────────────────
export function buildXiyongJiReasonLocale(el: string, dayStemEl: string, lang: string): string | null {
  if (lang === 'en') {
    if (el === dayStemEl) return 'Same element as your Day Master — when the chart is already strong, adding more of the same element pushes the Day Master to excess. Too much of a good thing creates imbalance.';
    if (_ELEM_GENERATED_BY[dayStemEl] === el) return 'Seal energy nourishes your Day Master — but when already strong, additional Seal amplifies excess. This further tips the chart out of balance.';
    if (_ELEM_GENERATES[dayStemEl] === el) return 'Output energy drains your Day Master\'s vitality — when the chart is already weak, this further depletes the foundation that most needs strengthening.';
    if (_ELEM_OVERCOMES[el] === dayStemEl) return 'Officer/Killer energy presses on your Day Master — when already weak, this additional pressure creates more strain than the chart can constructively absorb.';
    if (_ELEM_OVERCOMES[dayStemEl] === el) return 'Wealth energy draws from your Day Master\'s limited resources — a weak Day Master cannot effectively sustain wealth without first building its own energetic foundation.';
    return 'Creates interference in your chart\'s elemental balance. Reducing contact with this element promotes overall harmony.';
  }
  if (lang === 'ko') {
    if (el === dayStemEl) return '일주와 같은 오행으로 이미 강한 명국에 비겁이 더해지면 과도하게 됩니다. 좋은 것도 지나치면 불균형을 만듭니다.';
    if (_ELEM_GENERATED_BY[dayStemEl] === el) return '인성이 일주를 생조하지만 이미 강할 때 더 추가되면 과잉이 됩니다. 균형이 더 어긋납니다.';
    if (_ELEM_GENERATES[dayStemEl] === el) return '식상이 일주의 활력을 소모합니다. 약한 명국에서 이것이 더해지면 가장 필요한 기반이 더 약해집니다.';
    if (_ELEM_OVERCOMES[el] === dayStemEl) return '관살이 일주에 압박을 줍니다. 이미 약할 때 이 압박이 추가되면 건설적으로 흡수하기 어렵습니다.';
    if (_ELEM_OVERCOMES[dayStemEl] === el) return '재성이 일주의 제한된 자원을 소모합니다. 약한 일주는 먼저 자신의 기반을 구축해야 재물을 지탱할 수 있습니다.';
    return '명국의 오행 균형에 간섭을 만듭니다. 이 오행과의 접촉을 줄이면 전반적 조화가 향상됩니다.';
  }
  if (lang === 'ja') {
    if (el === dayStemEl) return '日主と同じ五行の比劫。既に強い命局にさらに加わると過剰になります。良いものも過ぎると不均衡を生じます。';
    if (_ELEM_GENERATED_BY[dayStemEl] === el) return '印星が日主を養いますが、既に強い時にさらに加わると過剰を増幅させます。バランスがさらに崩れます。';
    if (_ELEM_GENERATES[dayStemEl] === el) return '食傷が日主の活力を消耗します。弱い命局でこれが加わると、最も強化が必要な基盤がさらに弱まります。';
    if (_ELEM_OVERCOMES[el] === dayStemEl) return '官殺が日主に圧力をかけます。既に弱い時にこの圧力が加わると、命局が建設的に吸収できる限界を超えます。';
    if (_ELEM_OVERCOMES[dayStemEl] === el) return '財星が日主の限られた資源を消耗します。弱い日主は財を維持する前に自身のエネルギー基盤を構築する必要があります。';
    return '命局の五行バランスに干渉を生じます。この五行との接触を減らすと全体的な調和が向上します。';
  }
  return null;
}

export function getShenshaDescLocale(name: string, lang: string): string | null {
  if (lang === 'en') return SHENSHA_DESC_EN[name] ?? null;
  if (lang === 'ko') return SHENSHA_DESC_KO[name] ?? null;
  if (lang === 'ja') return SHENSHA_DESC_JA[name] ?? null;
  return null;
}
export function getShenshaResolveLocale(name: string, lang: string): string | null {
  if (lang === 'en') return SHENSHA_RESOLVE_EN[name] ?? null;
  if (lang === 'ko') return SHENSHA_RESOLVE_KO[name] ?? null;
  if (lang === 'ja') return SHENSHA_RESOLVE_JA[name] ?? null;
  return null;
}

export function buildFoodDescEn(
  food1Name: string,
  food2Name: string,
  weakEl: string,
  todayEl: string,
  isSame: boolean,
): string {
  const f1 = FOOD_EN[food1Name]?.name ?? food1Name;
  const f2 = FOOD_EN[food2Name]?.name ?? food2Name;
  const e1 = ELEMENT_EN[weakEl] ?? weakEl;
  const e2 = ELEMENT_EN[todayEl] ?? todayEl;
  const f1Eff = FOOD_EN[food1Name]?.effect ?? '';
  const f2Eff = FOOD_EN[food2Name]?.effect ?? '';
  if (isSame) {
    return `Today's top luck-turning foods are "${f1}" and "${f2}"—both rich in ${e1} energy. ${f1Eff}. ${f2Eff}. Consuming them today multiplies the effect and helps you align with the day's energy.`;
  }
  return `Today, eat "${f1}" to replenish ${e1} energy (${f1Eff}). Also enjoy "${f2}" to align with today's ${e2} energy (${f2Eff}). Together they fill you with transformative fortune energy.`;
}

// ─── 五行固定属性及级别分析英文数据已移至 ./locale/wuxingLocale ─
// 请直接从 wuxingLocale 导入 getWuxingFixedLocale / getWuxingAnalysisLocale
// （已在文件顶部 re-export）
const _WUXING_DATA_REMOVED_PLACEHOLDER: Record<string, unknown> = {
  '木': {
    keyword: 'Growth · Creation · Benevolence',
    symbol: 'Great trees, bamboo groves, flowers',
    season: 'Spring',
    direction: 'East',
    taste: 'Sour',
    emotion: 'Anger (passion, drive)',
    organ: 'Liver',
    organRelated: 'Gallbladder, tendons, eyes',
    careers: ['Education & Training', 'Literary Creation', 'Healthcare', 'Eco & Gardening', 'Design & Planning', 'Counseling', 'Law'],
    boostTips: [
      'Walk daily in forests and parks; surround yourself with green plants',
      'Place indoor plants at home; decorate with green and teal tones',
      'Eat sour foods: vinegar, citrus fruits, leafy greens',
      'Head east; eastern cities and environments strengthen Wood energy',
      'Practice yoga or Tai Chi to enhance flexibility and nourish Wood',
    ],
    reduceTips: [
      'Reduce green and wood-material decor; introduce metallic elements',
      'Incorporate white and silver tones; Metal energy balances excess Wood',
      'Moderate sour foods; bring greater variety and balance to your diet',
      'Practice daily meditation to calm impulsive, reactive emotions',
      'Add structured, disciplined activities: planning, organized work habits',
    ],
  },
  '火': {
    keyword: 'Passion · Expression · Leadership',
    symbol: 'The sun, hearth fire, candlelight',
    season: 'Summer',
    direction: 'South',
    taste: 'Bitter',
    emotion: 'Joy (enthusiasm, delight)',
    organ: 'Heart',
    organRelated: 'Small intestine, blood vessels, tongue',
    careers: ['Entertainment & Performing Arts', 'Marketing', 'Leadership & Management', 'PR & Events', 'Culinary Arts', 'Spiritual Practice', 'Sports & Athletics'],
    boostTips: [
      'Maximize sunlight exposure; south-facing environments amplify Fire energy',
      'Wear warm colors: red, orange, and vibrant bright tones',
      'Engage actively in social activities; deepen interpersonal connections',
      'Eat warming foods: ginger, leek, and mildly spicy dishes',
      'Cultivate passions and hobbies to continuously ignite inner fire',
    ],
    reduceTips: [
      'Increase Water energy: drink abundantly; live near water sources',
      'Use cool blue and black tones throughout your living space',
      'Practice meditation and mindfulness daily to stabilize emotions',
      'Reduce spicy and stimulating foods; favor lighter, cooling meals',
      'Create more quiet reflection time; avoid overstimulation',
    ],
  },
  '土': {
    keyword: 'Stability · Inclusion · Trustworthiness',
    symbol: 'Great earth, mountains, fields and gardens',
    season: 'Seasonal transitions (last 18 days each season)',
    direction: 'Center',
    taste: 'Sweet',
    emotion: 'Pensiveness (contemplation, focus)',
    organ: 'Spleen',
    organRelated: 'Stomach, muscles, mouth',
    careers: ['Real Estate', 'Agriculture & Food', 'Finance & Accounting', 'Administration & Management', 'Banking', 'Logistics & Warehousing', 'Traditional Crafts'],
    boostTips: [
      'Connect with the earth: countryside walks, gardening, farming',
      'Use yellow, brown, and warm earthy tones in home decor',
      'Eat sweet earthy foods: sweet potato, pumpkin, corn, red dates',
      'Central and inland regions provide stronger Earth energy',
      'Build stable daily routines and consistent, grounded life habits',
    ],
    reduceTips: [
      'Increase Wood energy: spend time in nature; add indoor plants',
      'Reduce yellow in clothing; incorporate more green and teal tones',
      'Reduce sweet foods moderately; maintain healthy weight',
      'Increase physical activity; avoid prolonged sitting',
      'Broaden your perspective; try new things to prevent stagnation',
    ],
  },
  '金': {
    keyword: 'Decisiveness · Discipline · Precision',
    symbol: 'Swords, precious gems, metallic objects',
    season: 'Autumn',
    direction: 'West',
    taste: 'Pungent',
    emotion: 'Grief (acuity, deep reflection)',
    organ: 'Lungs',
    organRelated: 'Large intestine, skin, nose',
    careers: ['Finance & Securities', 'Law & Arbitration', 'Engineering & Technology', 'Jewelry & Gemstones', 'Law Enforcement', 'Surgical Medicine', 'Automotive & Machinery'],
    boostTips: [
      'Wear metal jewelry: gold, silver, or steel pieces',
      'Use white, silver, and metallic elements in home decor',
      'Eat pungent foods: scallions, ginger, white radish',
      'Head west; western regions and cities strengthen Metal energy',
      'Cultivate precision, discipline, and organized living and working habits',
    ],
    reduceTips: [
      'Add Fire energy: get more sunlight; use warm red and orange decor',
      'Reduce metal jewelry; shift clothing toward red and orange tones',
      'Moderate pungent foods in your overall diet',
      'Practice gentler expression; soften direct, assertive communication',
      'Increase warm interpersonal connection; practice vulnerability and cooperation',
    ],
  },
  '水': {
    keyword: 'Wisdom · Flexibility · Insight',
    symbol: 'Rivers and seas, rain, springs',
    season: 'Winter',
    direction: 'North',
    taste: 'Salty',
    emotion: 'Fear (intuition, depth)',
    organ: 'Kidneys',
    organRelated: 'Bladder, bones, ears',
    careers: ['Philosophy & Research', 'Counseling & Therapy', 'Information Technology', 'Diplomacy', 'Arts & Literature', 'Travel & Exploration', 'History & Archaeology'],
    boostTips: [
      'Live or work near water sources: rivers, lakes, or coastal areas',
      'Use black and deep blue tones in decor to enhance Water energy',
      'Eat salty and black-colored foods: black sesame, seafood, black beans',
      'Head north; coastal and northern cities favor Water energy',
      'Warmth is essential; protect kidneys and lower body from cold',
    ],
    reduceTips: [
      'Add Earth energy: spend time in mountain or plains environments',
      'Use warm yellow and brown home tones to strengthen Earth',
      'Reduce salty foods; eat lightly to protect kidney function',
      'Increase action and follow-through; reduce over-analysis',
      'Build stable, consistent life routines; reduce emotional fluctuations',
    ],
  },
};

// ─── 五行级别分析英文数据 ─────────────────────────────────────
interface WuxingAnalysisEN {
  title: string; summary: string; personality: string; career: string;
  emotion: string; health: string; balance: string;
}

const WUXING_ANALYSIS_EN: Record<string, Record<string, WuxingAnalysisEN>> = {
  '木': {
    '过旺': {
      title: 'Wood Overabundant',
      summary: 'Your chart carries an abundance of Wood energy — like a towering tree in full force, vibrant and powerful, yet wisdom is needed to channel that growth into lasting fruit.',
      personality: 'Bold, creative, and fiercely ambitious — you see possibilities where others see limits. Your convictions run deep and you champion what you believe in wholeheartedly. At times passion tips into stubbornness; learning to hold your principles while remaining open to different approaches makes you an unstoppable force.',
      career: 'A natural pioneer and trailblazer. Wood energy is best channeled into creative, expansive fields: entrepreneurship, team leadership, education, arts, or healthcare. Pairing this vitality with Metal discipline — structured work, clear rules — transforms boundless drive into enduring achievement.',
      emotion: 'You love fiercely and protect those close to you with everything you have. Sometimes this passion can feel overwhelming; practicing deep listening and giving your partner space to shine makes relationships richer and more sustainable.',
      health: 'Liver and gallbladder are most active with excess Wood. Watch for emotional irritability, dry eyes, and sleep disruptions. Reduce acidic and heavy foods; incorporate liver-soothing foods. Emotional calm is the most powerful Wood health medicine.',
      balance: 'Introduce Metal to channel the overflow: wear metallic jewelry, use white and silver in decor, and embrace more structure and discipline daily. Reduce green in wardrobe and let abundant Wood flow productively rather than accumulate.',
    },
    '旺盛': {
      title: 'Wood Vigorous',
      summary: 'Vigorous Wood energy — like a tree in full bloom, vitality and creativity are genuine assets powering everything you do.',
      personality: 'Energetic, curious, and naturally forward-thinking, with talent for planning and follow-through. People are drawn to your warmth and openness. When idealism occasionally clouds judgment, a moment of practical reflection restores balance.',
      career: 'Strong career energy in education, culture, creative industries, healthcare, and law. Leadership quality surfaces naturally. Consistent patience amplifies results — great achievements come to those who cultivate rather than rush.',
      emotion: 'Loyal and devoted, with genuine protectiveness for those close to you. A reliable and trustworthy partner who brings stability to relationships.',
      health: 'Liver and gallbladder are in good condition. Maintain regular exercise and avoid prolonged sitting — keep Wood energy flowing smoothly.',
      balance: 'Vigorous Wood is a natural advantage — maintain it well. The key is staying flexible within strong convictions; blending firmness with openness creates the most dynamic version of yourself.',
    },
    '适中': {
      title: 'Wood Balanced',
      summary: 'Wood energy in perfect equilibrium — ambition and serenity coexist beautifully. One of the most desirable five-element states.',
      personality: 'Grounded yet inspiring, principled yet adaptable. You navigate the dance between holding your ground and accommodating others with remarkable grace, earning the deep trust of those around you.',
      career: 'Well-rounded development in Wood-related fields: education, healthcare, design, creative industries. Career advances at a healthy, sustainable pace.',
      emotion: 'Harmonious relationships with strong communication skills. You give partners space while showing up fully — a rare and beautiful quality.',
      health: 'Liver and gallbladder are balanced. Maintain current healthy habits and keep emotions steady.',
      balance: 'Balanced Wood is ideal — simply maintain it. If Wood energy needs a boost in certain periods, spend more time in nature surrounded by green plants.',
    },
    '偏弱': {
      title: 'Wood Weak',
      summary: 'Wood energy needs some nourishment — like a young seedling needing more sunlight and water. With intentional care, Wood vitality grows steadily.',
      personality: 'At times you may feel less decisive or adventurous than you\'d like. This quieter energy also gives you a thoughtful, careful nature. Building momentum through small, consistent steps is your most powerful path forward.',
      career: 'Choose Wood-related fields to activate and strengthen this energy: education, creative work, healthcare. Set small, clear goals and pursue them actively — each bold step is Wood energy in action.',
      emotion: 'You may lean toward a more passive approach in relationships. Expressing your heart proactively — taking the first step — creates the warmth and momentum that love needs to thrive.',
      health: 'Give the liver and gallbladder extra attention. Increase outdoor activities in green environments and incorporate liver-nourishing foods. Gentle, regular exercise is beneficial.',
      balance: 'Actively cultivate Wood energy: walk in forests daily, fill home with green plants, wear green tones, and eat sour foods like citrus and vinegar. Lifestyle is the most powerful five-element adjustment.',
    },
    '极弱': {
      title: 'Wood Very Weak',
      summary: 'Wood energy is minimal — the spark of vitality needs to be carefully kindled. This is not a limitation but an invitation to consciously awaken your innate growth energy.',
      personality: 'Challenges can feel daunting and decisiveness takes more effort. Yet very weak Wood often produces extraordinarily gentle, supportive personalities gifted at harmony and collaboration. Consciously developing planning skills and follow-through gradually transforms this energy.',
      career: 'Seek structured environments with clear team support and external frameworks. Actively engage with Wood-related professions to feed this element through daily work.',
      emotion: 'In love, staying true to your own needs matters greatly — avoid endless accommodation that causes you to lose yourself. Finding your own rhythm makes love more balanced and fulfilling.',
      health: 'Liver and gallbladder deserve priority attention. Schedule regular check-ups, care for eye health and tendons. Eat green vegetables and liver-protective foods; strictly minimize alcohol.',
      balance: 'Full-spectrum Wood cultivation: 30+ minutes daily in green outdoor spaces; maximize green plants at home; wear green as primary color; emphasize sour and green foods. Remember: destiny guides, but how you live is the real five-element regulator.',
    },
  },
  '火': {
    '过旺': {
      title: 'Fire Overabundant',
      summary: 'Fire blazes at full intensity — your passion and charisma are extraordinary, yet wisdom to know when to dim the flame ensures the fire burns long and bright.',
      personality: 'Electrifying presence, magnetic charisma, a born leader who moves rooms. This intense energy can tip toward impulsiveness — words wound before the mind catches up. Adding thoughtful calm transforms fire power into enduring, lasting influence.',
      career: 'Brilliantly suited for entertainment, public speaking, PR, management, and high-energy leadership. Directing Fire energy outward through creative output transforms intensity into fuel for lasting achievement rather than burnout.',
      emotion: 'You love with extraordinary heat and devotion — partners feel deeply treasured. Remember to give space; even the sun sets so others can rest. Love becomes deeper when it breathes.',
      health: 'Heart and cardiovascular health need priority attention with excess Fire. Watch for emotional over-excitement, insomnia, and rapid heartbeat. Eat cooling foods: bitter melon, celery. Quality, consistent sleep protects the heart.',
      balance: 'Water elements balance excess Fire: drink abundantly, live near water, use blue and black in decor. Slow daily rhythms; 10–15 minutes of daily meditation channels blazing fire into radiant, sustainable warmth.',
    },
    '旺盛': {
      title: 'Fire Vigorous',
      summary: 'Fire energy is strong and vibrant — enthusiasm and vitality are your most precious gifts, naturally inspiring all who encounter you.',
      personality: 'Radiant optimism, boundless energy — you naturally become the room\'s light source. Strong communication paired with a genuine desire to uplift others makes you an exceptional team builder. Cultivating patience alongside passion lets your impact run deeper and longer.',
      career: 'Excels in all domains requiring enthusiastic presentation and human connection. Career momentum is strong, particularly in public-facing, leadership, and creative roles.',
      emotion: 'Relationships are vibrant and passionate — your warmth makes partners feel deeply valued. Adding a thread of quiet, steady tenderness alongside the fire deepens love beautifully.',
      health: 'Vitality is excellent. Monitor heart health and avoid excessive overwork — consistent rest preserves powerful Fire energy.',
      balance: 'Vigorous Fire is a genuine gift. The art is integrating calm depth within the brilliance, elevating your presence from dazzling to truly profound.',
    },
    '适中': {
      title: 'Fire Balanced',
      summary: 'Fire energy is perfectly calibrated — passion coexists with reflection, warmth with wisdom. A beautifully ideal state.',
      personality: 'Cheerful and grounded in equal measure: enthusiastic without being overwhelming, optimistic while remaining thoughtful. A rare combination that naturally draws people toward you.',
      career: 'Performs excellently in both high-energy presentation roles and detail-oriented, patient work. Balanced versatility is a genuine advantage.',
      emotion: 'Romantic relationships are healthy and vibrant — both passionate and tender in turn. A wonderful partner energy.',
      health: 'Cardiovascular health is good. Maintain regular exercise and consistent sleep routines.',
      balance: 'Balanced Fire is ideal — simply maintain. When energy feels low, social engagement and light physical activity reignite the natural spark.',
    },
    '偏弱': {
      title: 'Fire Weak',
      summary: 'Fire needs replenishment — like a lamp needing more oil. Intentional lifestyle adjustments steadily rebuild inner passion and vitality.',
      personality: 'Warming up in social settings may take time — yet your depth and quieter energy make you exceptional at meaningful one-on-one connection. Actively joining social activities and stepping outside comfort zones gradually rekindles Fire.',
      career: 'Seek opportunities to present and express yourself publicly: lead small projects, give brief talks, join speaking groups. Practice is the most direct path to activating inner Fire energy.',
      emotion: 'Partners may not clearly see your inner warmth. Be more proactive about expressing care — even small gestures of affection speak volumes when feelings stay hidden.',
      health: 'Pay attention to cardiovascular health. Regular aerobic exercise and consistent sunlight exposure are genuinely helpful. Warm-Yang foods like ginger and red dates boost Fire energy.',
      balance: 'Actively cultivate Fire: maximize sunlight; wear warm red and orange tones; participate in social activities regularly; enjoy warming foods. Sunny southern environments support Fire energy.',
    },
    '极弱': {
      title: 'Fire Very Weak',
      summary: 'Fire energy is dim — like a distant star, small but present, waiting to be nurtured into full brightness.',
      personality: 'Introspective and quietly perceptive — you observe the world with extraordinary sensitivity and depth. This quality produces rare artistic and contemplative souls. Intentionally stepping outside comfort zones gradually awakens the expressive energy within.',
      career: 'Start with roles where you influence small groups, then expand gradually. Join interest communities and take professional development courses — these environments actively kindle Fire.',
      emotion: 'Connection requires special attention — without expressed warmth, partners may feel distant. Create intentional moments of affection and tenderness to let genuine care be felt.',
      health: 'Heart and circulatory health need close monitoring — regular check-ups are valuable. Daily outdoor activity, sunlight, and Yang-warming foods like ginger and dates are essential support.',
      balance: 'Comprehensive Fire restoration: 30+ minutes of daily sunlight; warm red and orange home environment; regular social activities and group exercise; warming food focus; sunny living environments are ideal.',
    },
  },
  '土': {
    '过旺': {
      title: 'Earth Overabundant',
      summary: 'Earth energy is exceptionally thick and grounded — remarkably reliable and dependable, yet needing the vitality of movement to keep life rich and alive.',
      personality: 'Deeply trustworthy and principled — people instinctively rely on you. Your word is bond. Rigidity can occasionally be the shadow side; cultivating openness to new ways ensures legendary reliability pairs with forward-thinking adaptability.',
      career: 'Naturally suited for fields requiring stability and trust: finance, real estate, administration, management, banking. Deliberately embrace new ideas and evolving methods so reliability pairs with adaptability.',
      emotion: 'A loyal, devoted, bedrock partner. Relationships are deep and lasting. Adding intentional moments of romance and spontaneity keeps long-term love energized and fresh.',
      health: 'Excess Earth can impact digestion — watch for bloating or sluggish digestion. Reduce heavy, sweet, and fatty foods; increase movement to help the body process and circulate energy.',
      balance: 'Wood energy activates and refreshes excess Earth: connect deeply with nature, increase green plants in your environment. Maintain an active social life and embrace new experiences — let life flow, not stagnate.',
    },
    '旺盛': {
      title: 'Earth Vigorous',
      summary: 'Strong Earth energy — dependability and patience are your foundation, nourishing everything and everyone around you with quiet, steady power.',
      personality: 'Warm, inclusive, and reassuringly steady. People feel safe and valued around you. Practical and results-focused, you earn respect through consistent excellence rather than flash.',
      career: 'Financial stability and steady advancement are hallmarks of strong Earth. Career momentum is strongest in middle age — the classic Earth pattern of slow, deep, powerful accumulation.',
      emotion: 'Deeply committed and reliable. In stable relationships, occasional romantic spontaneity adds warmth that transforms a solid partnership into a truly beautiful one.',
      health: 'Good digestive health. Maintain regular meals and avoid overeating. Keep moving to prevent stagnation from excessive comfort.',
      balance: 'Strong Earth is a genuine advantage — the key is staying engaged and curious. Resist over-complacency; maintain forward momentum and embrace the new.',
    },
    '适中': {
      title: 'Earth Balanced',
      summary: 'Earth energy in equilibrium — grounded yet flexible, reliable yet open. A truly ideal state.',
      personality: 'The perfect blend of steadiness and adaptable intelligence. Fair, consistent, and genuinely trustworthy — the person others always want in their corner.',
      career: 'Balanced Earth opens every door, particularly roles requiring patience, integrity, and steady accumulation. Career advances at a healthy, dependable pace.',
      emotion: 'Relationship dynamics are harmonious — responsible yet spacious, devoted yet free. A deeply mature partnership energy.',
      health: 'Digestive health is balanced. Maintain regular eating patterns and moderate exercise.',
      balance: 'Balanced Earth is ideal — simply maintain your current rhythm.',
    },
    '偏弱': {
      title: 'Earth Weak',
      summary: 'Earth energy needs strengthening — roots need deepening. With intentional lifestyle adjustments, inner stability and groundedness grow steadily.',
      personality: 'Security and a stable foundation matter deeply to you; uncertainty can feel unsettling. This awareness is actually profound self-knowledge. Building consistent daily habits gradually creates the inner ground you need.',
      career: 'Choose structured work environments with clear frameworks. Steady advancement over frequent job changes is genuinely the most powerful strategy. Each grounded step is Earth energy in action.',
      emotion: 'You may crave more security and certainty in relationships. Building trust actively — showing up consistently — creates the foundation for truly stable love.',
      health: 'Digestive system needs attention: regular, warm, easily digestible meals. Congee, yam, pumpkin, and sweet potato support spleen and stomach beautifully.',
      balance: 'Cultivate Earth energy through lifestyle: walk barefoot on grass; use warm yellow and brown home tones; eat regular, warming meals; inland living supports Earth. Build meaningful daily rituals.',
    },
    '极弱': {
      title: 'Earth Very Weak',
      summary: 'Earth energy is very thin — like seeds needing rich soil. Nourishing Earth creates the stable foundation every flourishing life requires.',
      personality: 'Life\'s rhythm can be harder to sustain — yet this quality often produces brilliantly adaptive, free-thinking personalities. Deliberately cultivating structure and regularity beautifully balances this inherent freedom.',
      career: 'Define clear long-term goals and build a structured career path. Mentors and organized environments provide the external framework that complements your natural energy.',
      emotion: 'Stability in relationships is especially valuable — choose a grounded, dependable partner. Avoid letting insecurity create instability; trust is built one consistent action at a time.',
      health: 'Spleen and stomach need priority care: eat warm, regular meals; avoid cold and raw foods. Chinese yam, barley, lotus seed, and red dates powerfully support digestive health.',
      balance: 'Full Earth restoration: daily contact with earth and nature; warm yellow home environment; three regular daily meals; inland living; most importantly, establish meaningful daily rituals for deep, grounding consistency.',
    },
  },
  '金': {
    '过旺': {
      title: 'Metal Overabundant',
      summary: 'Metal energy is razor-sharp and powerful — decisive and incisive, yet needing a measure of warmth and softness to become both effective and enduring.',
      personality: 'Bold, direct, action-first — you cut through ambiguity with precision. This energy can create friction when directness becomes bluntness. Softening communication while maintaining decisiveness transforms Metal power into remarkable, lasting leadership.',
      career: 'Extraordinary execution ability in fast-decision, high-action environments. When paired with genuine collaborative listening, your capacity to lead and achieve becomes truly exceptional.',
      emotion: 'Protection and responsibility come naturally — your love is real and fierce. Learning to soften tone and show vulnerability occasionally makes relationships deeply warmer and more intimate.',
      health: 'Lungs and large intestine need attention with excess Metal. Dry skin and respiratory sensitivity can emerge. Increase hydration, maintain humid environments, and reduce spicy foods.',
      balance: 'Fire energy balances excess Metal: maximize sunlight, incorporate warm red and orange decor, increase social warmth. Reduce metal jewelry and soften daily interactions with lightness and genuine care.',
    },
    '旺盛': {
      title: 'Metal Vigorous',
      summary: 'Vigorous Metal energy — decisive clarity and strong execution are among your greatest natural gifts.',
      personality: 'Disciplined, self-reliant, and highly principled — you deliver what you promise without exception. This reliability earns deep, lasting respect. Adding lightness and warmth to interactions makes you not just trusted but truly beloved.',
      career: 'Finance, law, engineering, and management sectors are natural fits. Financial accumulation comes steadily through consistent, disciplined effort.',
      emotion: 'Loyal, committed, and entirely trustworthy — a deeply secure presence for your partner. Adding spontaneous warmth and romance enriches what is already a beautiful foundation.',
      health: 'Good overall health. Maintain respiratory health; avoid heavily polluted environments.',
      balance: 'Vigorous Metal is an advantage — the ongoing art is integrating genuine warmth alongside strength.',
    },
    '适中': {
      title: 'Metal Balanced',
      summary: 'Metal energy in perfect balance — decisive yet compassionate, principled yet warm. Truly ideal.',
      personality: 'Holds principles firmly while remaining genuinely sensitive to others\' needs. Fair, consistent, and trustworthy in a way that is also warm and human.',
      career: 'Metal-related industries have strong potential. Work style combines decisive execution with genuine people awareness.',
      emotion: 'Relationships are stable and warm — committed love with genuine tenderness. A beautiful partnership energy.',
      health: 'Lung and large intestine health is excellent. Maintain good breathing habits and regular exercise.',
      balance: 'Balanced Metal is ideal — simply maintain your current rhythm.',
    },
    '偏弱': {
      title: 'Metal Weak',
      summary: 'Metal energy needs development — decisiveness and follow-through are areas to consciously strengthen, while inner warmth and empathy are naturally refined gifts.',
      personality: 'Quick decisions and direct confrontation may feel challenging. This quality has a beautiful shadow: extraordinary empathy and attunement to others. Consciously practicing decisive action gradually builds Metal strength.',
      career: 'Actively pursue opportunities with decision-making responsibility. Efficiency and productivity training directly builds Metal energy through practice.',
      emotion: 'Warm and deeply considerate in relationships — yet learning to advocate for your own needs creates more balanced, healthy partnership dynamics.',
      health: 'Lungs and large intestine deserve extra attention. Regular aerobic exercise and fresh air exposure build respiratory strength.',
      balance: 'Cultivate Metal through lifestyle: wear gold or silver jewelry; use white and silver home elements; eat pungent foods moderately; develop westward. Precision and discipline in daily habits is the most direct Metal practice.',
    },
    '极弱': {
      title: 'Metal Very Weak',
      summary: 'Metal energy is minimal — decisiveness and execution require conscious cultivation. This is a powerful growth direction.',
      personality: 'Action and decision-making require more internal effort — yet this produces extraordinarily attuned, sensitive, and emotionally intelligent personalities. Building structured habits and clear goals transforms this quality.',
      career: 'Start with clear goal-setting and deliberate cultivation of execution habits. Rule-rich, structured environments provide the external Metal support that develops internal strength.',
      emotion: 'Learning to hold gentle but clear boundaries in relationships creates the healthy dynamic where love can truly flourish.',
      health: 'Lungs, large intestine, and skin need priority focus. Regular check-ups, fresh air, and respiratory-supportive exercises are essential. Avoid heavily polluted environments.',
      balance: 'Full Metal restoration: generous metal jewelry and white wardrobe; west-focused development; pungent warming foods; rigorous daily self-discipline. Making and executing a daily plan is the most powerful Metal cultivation exercise.',
    },
  },
  '水': {
    '过旺': {
      title: 'Water Overabundant',
      summary: 'Water flows at great depth and volume — profound wisdom and keen perception, yet needing firm banks to guide the current toward true purpose.',
      personality: 'Extraordinarily perceptive and insightful — you sense what others cannot see. This depth can turn to overthinking and self-doubt. The key growth is moving from analysis to action, trusting your own wisdom enough to execute it.',
      career: 'Exceptional in strategy, philosophy, counseling, business analysis, and complex problem-solving. The career art is converting deep insight into clear, decisive action — channeling the vast water into productive, flowing direction.',
      emotion: 'Profoundly sensitive — you feel your partner\'s emotions before words form. When sensitivity becomes hypervigilance, it creates misunderstandings that aren\'t there. Learning to trust and communicate openly is transformative.',
      health: 'Kidney health is the priority with excess Water. Emotional volatility can disrupt the endocrine system. Warmth is essential, especially for the lower back. Reduce salty foods; maintain adequate hydration.',
      balance: 'Earth energy grounds excess Water: connect with mountains and plains, use yellow and brown tones in decor, build regular structured routines. Channel abundant water into wisdom and creative force rather than endless rumination.',
    },
    '旺盛': {
      title: 'Water Vigorous',
      summary: 'Water flows powerfully — wisdom and adaptability are your most valuable assets, flowing through any environment with natural ease.',
      personality: 'Sharp-minded, supremely adaptive, reading situations and people with precision. Genuine emotional intelligence makes you skilled at building connections across any background or personality type.',
      career: 'Strategy, deep analysis, and interpersonal coordination are where Water energy shines most brilliantly. Wisdom accumulates to a peak in middle years, creating a powerful competitive advantage.',
      emotion: 'Deep, devoted love that emerges gradually and fully. Openly expressing inner feelings rather than waiting for others to guess allows the depth to be truly seen and appreciated.',
      health: 'Kidneys are healthy. Maintain warmth in cold seasons and adequate hydration; keep sleep cycles regular.',
      balance: 'Vigorous Water is a gift — action is the balancing force. Pair wisdom with execution and nothing is truly out of reach.',
    },
    '适中': {
      title: 'Water Balanced',
      summary: 'Water energy in perfect equilibrium — wisdom alongside practicality, depth alongside decisive action. A truly ideal state.',
      personality: 'Sharp-minded without losing ground, thoughtful without becoming indecisive. A skilled navigator of complex human dynamics with genuine emotional intelligence.',
      career: 'Excels across fields; especially distinguished in strategy-demanding roles. Adapts to virtually any professional environment with remarkable ease.',
      emotion: 'Relationships are both deep and warm — emotionally attuned and genuinely connected. A beautiful, balanced partner energy.',
      health: 'Kidneys are balanced. Maintain regular routines and adequate daily hydration.',
      balance: 'Balanced Water is ideal — simply maintain your current rhythm.',
    },
    '偏弱': {
      title: 'Water Weak',
      summary: 'Water needs nurturing — wisdom and intuition flow somewhat less freely, but with intention the springs of insight open steadily.',
      personality: 'Thinking may occasionally feel less fluid in fast-changing situations — an invitation to invest in continuous learning and mental stretching. Knowledge is the most powerful Water replenishment.',
      career: 'Read widely; pursue new knowledge consistently to keep thinking fluid and creative. Water-related fields like philosophy, counseling, and IT actively rekindle this energy.',
      emotion: 'Emotional sensitivity may need conscious cultivation — actively attending to your partner\'s subtle shifts deepens connection and relational wisdom.',
      health: 'Kidney health needs attention — stay warm, avoid cold foods and environments. Black sesame, walnut, black bean are powerfully supportive kidney-nourishing foods.',
      balance: 'Cultivate Water through lifestyle: live near water sources; use blue and black home elements; eat black and kidney-nourishing foods; read and think deeply; maintain genuine curiosity.',
    },
    '极弱': {
      title: 'Water Very Weak',
      summary: 'Water energy is minimal — like a dry riverbed, yet with dedicated cultivation wisdom\'s springs can flow fully again.',
      personality: 'Rigid thinking patterns can make flexibility challenging — yet this energy often produces remarkably practical, grounded, reliable personalities. Deep reading across disciplines is the most direct path to unlocking dormant Water.',
      career: 'Invest in careers requiring depth of thought and stay long enough to develop real mastery. Regular dialogue with deeply knowledgeable people activates intellectual vitality.',
      emotion: 'Actively developing empathic emotional awareness — learning to see from a partner\'s perspective — brings the relational warmth that Water energy naturally creates.',
      health: 'Kidney health requires close attention: regular check-ups, consistent lower-back warmth, and avoiding overwork. Wolfberry, black bean, walnut, and black sesame are excellent sustained support.',
      balance: 'Full Water restoration: live near water; immerse in blue and black tones; drink abundantly; read consistently; nourish kidneys with food and rest; protect sleep quality — kidneys restore at night.',
    },
  },
};

// getWuxingFixedLocale and getWuxingAnalysisLocale are now exported from ./locale/wuxingLocale (re-exported at top)

// ─── 天干名称多语言 ─────────────────────────────────────────
const STEM_NAMES_I18N: Record<string, Record<string, string>> = {
  '甲': { 'zh-CN': '甲', 'zh-HK': '甲', 'en': 'Jiǎ', 'ko': '갑', 'ja': '甲' },
  '乙': { 'zh-CN': '乙', 'zh-HK': '乙', 'en': 'Yǐ',  'ko': '을', 'ja': '乙' },
  '丙': { 'zh-CN': '丙', 'zh-HK': '丙', 'en': 'Bǐng', 'ko': '병', 'ja': '丙' },
  '丁': { 'zh-CN': '丁', 'zh-HK': '丁', 'en': 'Dīng', 'ko': '정', 'ja': '丁' },
  '戊': { 'zh-CN': '戊', 'zh-HK': '戊', 'en': 'Wù',  'ko': '무', 'ja': '戊' },
  '己': { 'zh-CN': '己', 'zh-HK': '己', 'en': 'Jǐ',  'ko': '기', 'ja': '己' },
  '庚': { 'zh-CN': '庚', 'zh-HK': '庚', 'en': 'Gēng', 'ko': '경', 'ja': '庚' },
  '辛': { 'zh-CN': '辛', 'zh-HK': '辛', 'en': 'Xīn', 'ko': '신', 'ja': '辛' },
  '壬': { 'zh-CN': '壬', 'zh-HK': '壬', 'en': 'Rén', 'ko': '임', 'ja': '壬' },
  '癸': { 'zh-CN': '癸', 'zh-HK': '癸', 'en': 'Guǐ', 'ko': '계', 'ja': '癸' },
};

export function getStemLabel(stem: string, lang: string): string {
  if (lang === 'zh-CN' || lang === 'zh-HK' || lang === 'zh-TW') return stem;
  return STEM_NAMES_I18N[stem]?.[lang] ?? stem;
}

// ─── 地支名称多语言 ─────────────────────────────────────────
const BRANCH_NAMES_I18N: Record<string, Record<string, string>> = {
  '子': { 'zh-CN': '子', 'zh-HK': '子', 'en': 'Zǐ',   'ko': '자', 'ja': '子' },
  '丑': { 'zh-CN': '丑', 'zh-HK': '丑', 'en': 'Chǒu', 'ko': '축', 'ja': '丑' },
  '寅': { 'zh-CN': '寅', 'zh-HK': '寅', 'en': 'Yín',  'ko': '인', 'ja': '寅' },
  '卯': { 'zh-CN': '卯', 'zh-HK': '卯', 'en': 'Mǎo',  'ko': '묘', 'ja': '卯' },
  '辰': { 'zh-CN': '辰', 'zh-HK': '辰', 'en': 'Chén', 'ko': '진', 'ja': '辰' },
  '巳': { 'zh-CN': '巳', 'zh-HK': '巳', 'en': 'Sì',   'ko': '사', 'ja': '巳' },
  '午': { 'zh-CN': '午', 'zh-HK': '午', 'en': 'Wǔ',   'ko': '오', 'ja': '午' },
  '未': { 'zh-CN': '未', 'zh-HK': '未', 'en': 'Wèi',  'ko': '미', 'ja': '未' },
  '申': { 'zh-CN': '申', 'zh-HK': '申', 'en': 'Shēn', 'ko': '신', 'ja': '申' },
  '酉': { 'zh-CN': '酉', 'zh-HK': '酉', 'en': 'Yǒu',  'ko': '유', 'ja': '酉' },
  '戌': { 'zh-CN': '戌', 'zh-HK': '戌', 'en': 'Xū',   'ko': '술', 'ja': '戌' },
  '亥': { 'zh-CN': '亥', 'zh-HK': '亥', 'en': 'Hài',  'ko': '해', 'ja': '亥' },
};

export function getBranchLabel(branch: string, lang: string): string {
  if (lang === 'zh-CN' || lang === 'zh-HK' || lang === 'zh-TW') return branch;
  return BRANCH_NAMES_I18N[branch]?.[lang] ?? branch;
}

// ─── 日主方面评分标签多语言 ──────────────────────────────────
const RIZHU_ASPECT_LABEL_EN: Record<string, string> = {
  '事业': 'Career', '感情': 'Romance', '财运': 'Wealth', '健康': 'Health',
};
const RIZHU_ASPECT_LABEL_JA: Record<string, string> = {
  '事业': '仕事', '感情': '恋愛', '财运': '財運', '健康': '健康',
};
const RIZHU_ASPECT_LABEL_KO: Record<string, string> = {
  '事业': '직업', '感情': '감정', '财运': '재운', '健康': '건강',
};

export function getRizhuAspectLabel(label: string, lang: string): string {
  if (lang === 'en') return RIZHU_ASPECT_LABEL_EN[label] ?? label;
  if (lang === 'ja') return RIZHU_ASPECT_LABEL_JA[label] ?? label;
  if (lang === 'ko') return RIZHU_ASPECT_LABEL_KO[label] ?? label;
  if (lang === 'zh-HK') return convertText(label, lang);
  return label;
}

// ─── 喜用神 tips 英文数据 ────────────────────────────────────
const XIYONG_TIP_TITLE_EN: Record<string, string> = {
  '幸运颜色': 'Lucky Colors', '吉利方位': 'Auspicious Directions',
  '幸运数字': 'Lucky Numbers', '适宜居住': 'Ideal Locations',
};
const ELEMENT_LUCKY_COLOR_EN_MAP: Record<string, string> = {
  '木': 'Green, Teal', '火': 'Red, Orange, Purple', '土': 'Yellow, Brown, Beige', '金': 'White, Silver, Gold', '水': 'Black, Blue, Deep Grey',
};
const ELEMENT_LUCKY_DIRECTION_EN_MAP: Record<string, string> = {
  '木': 'East, Southeast', '火': 'South', '土': 'Center, Southwest, Northeast', '金': 'West, Northwest', '水': 'North',
};
const ELEMENT_LUCKY_NUMBER_EN_MAP: Record<string, string> = {
  '木': '3, 8 (Wood numbers)', '火': '2, 7 (Fire numbers)', '土': '5, 0 (Earth numbers)', '金': '4, 9 (Metal numbers)', '水': '1, 6 (Water numbers)',
};
const ELEMENT_LUCKY_PLACE_EN_MAP: Record<string, string> = {
  '木': 'Forest areas and eastern cities', '火': 'Sunny, warm southern cities', '土': 'Plains and inland cities', '金': 'Western cities and commercial centers', '水': 'Coastal and northern cities',
};

const ELEMENT_LUCKY_COLOR_JA_MAP: Record<string, string> = {
  '木': 'グリーン・青緑', '火': '赤・オレンジ・紫', '土': '黄色・茶色・ベージュ', '金': '白・シルバー・ゴールド', '水': '黒・紺・濃グレー',
};
const ELEMENT_LUCKY_DIRECTION_JA_MAP: Record<string, string> = {
  '木': '東・東南', '火': '南', '土': '中央・南西・北東', '金': '西・北西', '水': '北',
};
const ELEMENT_LUCKY_NUMBER_JA_MAP: Record<string, string> = {
  '木': '3・8（木の数字）', '火': '2・7（火の数字）', '土': '5・0（土の数字）', '金': '4・9（金の数字）', '水': '1・6（水の数字）',
};
const ELEMENT_LUCKY_PLACE_JA_MAP: Record<string, string> = {
  '木': '森林地帯・東の都市', '火': '温暖な南方都市', '土': '平原・内陸都市', '金': '西部都市・商業中心地', '水': '沿岸・北部都市',
};
const ELEMENT_LUCKY_COLOR_KO_MAP: Record<string, string> = {
  '木': '녹색·청록', '火': '빨강·주황·보라', '土': '노란색·갈색·베이지', '金': '흰색·은색·금색', '水': '검정·진한 파랑·짙은 회색',
};
const ELEMENT_LUCKY_DIRECTION_KO_MAP: Record<string, string> = {
  '木': '동쪽·동남쪽', '火': '남쪽', '土': '중앙·남서·북동', '金': '서쪽·북서쪽', '水': '북쪽',
};
const ELEMENT_LUCKY_NUMBER_KO_MAP: Record<string, string> = {
  '木': '3·8(목 숫자)', '火': '2·7(화 숫자)', '土': '5·0(토 숫자)', '金': '4·9(금 숫자)', '水': '1·6(수 숫자)',
};
const ELEMENT_LUCKY_PLACE_KO_MAP: Record<string, string> = {
  '木': '삼림 지대·동쪽 도시', '火': '따뜻한 남쪽 도시', '土': '평원·내륙 도시', '金': '서쪽 도시·상업 중심지', '水': '해안·북쪽 도시',
};

export function buildXiyongTipsLocale(
  xiElements: string[],
  lang: string,
): Array<{ icon: string; title: string; value: string; color: string }> | null {
  const ELEMENT_COLORS_MAP: Record<string, string> = {
    '木': '#7BC67E', '火': '#D14B45', '土': '#A9744F', '金': '#D4AF37', '水': '#4A90D9',
  };
  const primaryEl = xiElements[0];
  if (!primaryEl) return null;
  const secondaryEl = xiElements[1];
  const primaryColor = ELEMENT_COLORS_MAP[primaryEl] ?? '#E8A020';
  const secondaryColor = secondaryEl ? (ELEMENT_COLORS_MAP[secondaryEl] ?? primaryColor) : primaryColor;

  if (lang === 'en') {
    return [
      { icon: 'ri-palette-line', title: 'Lucky Colors', value: xiElements.map(e => ELEMENT_LUCKY_COLOR_EN_MAP[e]).filter(Boolean).join(', '), color: primaryColor },
      { icon: 'ri-compass-3-line', title: 'Auspicious Directions', value: xiElements.map(e => ELEMENT_LUCKY_DIRECTION_EN_MAP[e]).filter(Boolean).join(', '), color: primaryColor },
      { icon: 'ri-number-1', title: 'Lucky Numbers', value: xiElements.map(e => ELEMENT_LUCKY_NUMBER_EN_MAP[e]).filter(Boolean).join(', '), color: secondaryColor },
      { icon: 'ri-map-pin-line', title: 'Ideal Locations', value: ELEMENT_LUCKY_PLACE_EN_MAP[primaryEl] ?? '', color: secondaryColor },
    ];
  }
  if (lang === 'ja') {
    return [
      { icon: 'ri-palette-line', title: 'ラッキーカラー', value: xiElements.map(e => ELEMENT_LUCKY_COLOR_JA_MAP[e]).filter(Boolean).join('、'), color: primaryColor },
      { icon: 'ri-compass-3-line', title: '吉方位', value: xiElements.map(e => ELEMENT_LUCKY_DIRECTION_JA_MAP[e]).filter(Boolean).join('、'), color: primaryColor },
      { icon: 'ri-number-1', title: 'ラッキーナンバー', value: xiElements.map(e => ELEMENT_LUCKY_NUMBER_JA_MAP[e]).filter(Boolean).join('、'), color: secondaryColor },
      { icon: 'ri-map-pin-line', title: '適した居住地', value: ELEMENT_LUCKY_PLACE_JA_MAP[primaryEl] ?? '', color: secondaryColor },
    ];
  }
  if (lang === 'ko') {
    return [
      { icon: 'ri-palette-line', title: '행운의 색상', value: xiElements.map(e => ELEMENT_LUCKY_COLOR_KO_MAP[e]).filter(Boolean).join(', '), color: primaryColor },
      { icon: 'ri-compass-3-line', title: '길한 방향', value: xiElements.map(e => ELEMENT_LUCKY_DIRECTION_KO_MAP[e]).filter(Boolean).join(', '), color: primaryColor },
      { icon: 'ri-number-1', title: '행운의 숫자', value: xiElements.map(e => ELEMENT_LUCKY_NUMBER_KO_MAP[e]).filter(Boolean).join(', '), color: secondaryColor },
      { icon: 'ri-map-pin-line', title: '적합한 거주지', value: ELEMENT_LUCKY_PLACE_KO_MAP[primaryEl] ?? '', color: secondaryColor },
    ];
  }
  return null;
}

export function getXiyongAdviceLocale(
  xiElements: string[],
  jiElements: string[],
  bodyStrength: string,
  lang: string,
): string | null {
  if (lang === 'en') {
    const strengthDescMap: Record<string, string> = {
      'strong': 'Your Day Master is strong and abundant.',
      'weak': 'Your Day Master is relatively weak.',
      'neutral': 'Your Day Master is in a balanced state.',
    };
    const strengthDesc = strengthDescMap[bodyStrength] ?? 'Your Day Master energy is balanced.';
    const xiColors = xiElements.map(e => ELEMENT_LUCKY_COLOR_EN_MAP[e]).filter(Boolean).join(', ');
    const jiColors = jiElements.map(e => ELEMENT_LUCKY_COLOR_EN_MAP[e]).filter(Boolean).join(', ');
    return `${strengthDesc} In daily life, incorporate ${xiColors} colors and their associated elements — wear these tones, decorate your space with them, and engage with their corresponding environments.${jiColors ? ` Minimize heavy contact with ${jiColors} energy to keep your chart in balance.` : ''} BaZi is a tool for self-understanding; a positive mindset and intentional lifestyle choices let every drop of your energy find its fullest expression.`;
  }
  if (lang === 'ja') {
    const strengthDescMap: Record<string, string> = {
      'strong': '日主のエネルギーは充沛で旺盛です。',
      'weak': '日主のエネルギーはやや弱めです。',
      'neutral': '日主のエネルギーは中和状態です。',
    };
    const strengthDesc = strengthDescMap[bodyStrength] ?? '日主エネルギーはバランスが取れています。';
    const xiColors = xiElements.map(e => ELEMENT_LUCKY_COLOR_JA_MAP[e]).filter(Boolean).join('・');
    const jiColors = jiElements.map(e => ELEMENT_LUCKY_COLOR_JA_MAP[e]).filter(Boolean).join('・');
    return `${strengthDesc} 日常生活では${xiColors}のカラーやその関連要素を取り入れましょう。これらのトーンの服を着たり、インテリアに使ったり、対応する環境に身を置くことが有益です。${jiColors ? `${jiColors}のエネルギーとの過度な接触は控えると命局のバランスが保たれます。` : ''}四柱推命は自己理解のツールです。前向きな心持ちと意図的な生活習慣で、あなたのエネルギーが最大限に発揮されます。`;
  }
  if (lang === 'ko') {
    const strengthDescMap: Record<string, string> = {
      'strong': '일주 에너지가 충패하고 왕성합니다.',
      'weak': '일주 에너지가 다소 약한 편입니다.',
      'neutral': '일주 에너지가 중화 상태입니다.',
    };
    const strengthDesc = strengthDescMap[bodyStrength] ?? '일주 에너지가 균형을 이루고 있습니다.';
    const xiColors = xiElements.map(e => ELEMENT_LUCKY_COLOR_KO_MAP[e]).filter(Boolean).join('·');
    const jiColors = jiElements.map(e => ELEMENT_LUCKY_COLOR_KO_MAP[e]).filter(Boolean).join('·');
    return `${strengthDesc} 일상에서 ${xiColors} 색상과 관련 요소를 활용하세요. 이 색조의 옷을 입고, 공간을 꾸미고, 관련 환경에서 활동하는 것이 좋습니다.${jiColors ? ` ${jiColors} 에너지와의 과도한 접촉을 줄이면 명국의 균형이 유지됩니다.` : ''} 사주는 자기 이해의 도구입니다. 긍정적인 마음가짐과 의도적인 생활 선택으로 에너지가 최대로 발휘됩니다.`;
  }
  return null;
}
